// // // import React, { useState, useEffect, useRef } from "react";
// // // import { ToastContainer, toast } from "react-toastify";
// // // import Accordion from "react-bootstrap/Accordion";
// // // import Modal from "react-bootstrap/Modal";
// // // import Slider from "react-slick";
// // // import { URLS } from "../Url";
// // // import Footer from "./Footer";
// // // import Header from "./Header";
// // // import Typer from "./Typer";
// // // import axios from "axios";
// // // import roses from "./images/roses.jpg";
// // // import cake4 from "./images/cake 4.jpg";
// // // import { FaStar } from "react-icons/fa";
// // // import { useNavigate } from "react-router-dom";
// // // import { Galleria } from "primereact/galleria";
// // // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// // // import beverages from "./images/foodbeverages.jpg";
// // // import screening from "./images/screening.jpg";
// // // import { Helmet } from "react-helmet";
// // // import {
// // //   faUser,
// // //   faPhone,
// // //   faEnvelope,
// // //   faCalendarAlt,
// // //   faClipboard,
// // // } from "@fortawesome/free-solid-svg-icons";
// // // import logo from "../components/carnival_footer_logo-2-removebg-preview.png";

// // // import { Carousel, Card, Container, Row, Col, Button } from "react-bootstrap";
// // // import CouponSection from "./Coupons";
// // // import Time from "../Blogs/Time";
// // // import PopupModal from "./PopUpModal";
// // // import HomePackagesSection from "./PackageSection";

// // // export const fetchPopupImage = async () => {
// // //   try {
// // //     const res = await fetch(
// // //       "https://api.carnivalcastle.com/v1/carnivalApi/admin/popup/getpopupimage?type=CarnivalCastle"
// // //     );

// // //     const data = await res.json();

// // //     if (data.success && data.data?.length > 0) {
// // //       return data.data[0]; // return first popup
// // //     }

// // //     return null;
// // //   } catch (error) {
// // //     console.error("Popup fetch error:", error);
// // //     return null;
// // //   }
// // // };


// // // function Home() {


// // //   const [isLoading, setIsLoading] = useState(false);

// // //   const [form, setform] = useState({
// // //     name: "",
// // //     email: "",
// // //     mobileNumber: "",
// // //     description: "",
// // //     eventName: "",
// // //   });

// // //   useEffect(() => {
// // //     GetHomePage();
// // //     GetAllGalleryDate();
// // //   }, []);

// // //   const [Faqs, setFaqs] = useState([]);
// // //   const [Sliders, setSliders] = useState([]);
// // //   console.log(Sliders);
// // //   const [Howtojoin, setHowtojoin] = useState([]);
// // //   const [LatestInfo, setLatestInfo] = useState([]);
// // //   const [LatestInfos, setLatestInfos] = useState([]);
// // //   console.log(LatestInfos);
// // //   const [Highlights, setHighlights] = useState([]);
// // //   const [Testimonial, setTestimonial] = useState([]);
// // //   const [Howtojoinpoints, setHowtojoinpoints] = useState([]);
// // //   const [HighlightsPoints, setHighlightsPoints] = useState([]);

// // //   const [Offers, setOffers] = useState([]);
// // //   const [services, setservices] = useState([]);

// // //   const [Contact, setContact] = useState([]);

// // //   const navigate = useNavigate();

// // //   const [PopUp, setPopUp] = useState([]);

// // //   const GetHomePage = () => {
// // //     axios.post(URLS.AllModules, {}, {}).then((res) => {
// // //       if (res.status === 200) {
// // //         setFaqs(res?.data?.faqs);
// // //         setContact(res?.data?.contactus[0]);
// // //         setSliders(res?.data?.homesliders);
// // //         setTestimonial(res?.data?.testimonials);
// // //         setHowtojoin(res?.data?.howtojoin[0]);
// // //         setHighlights(res?.data?.highlight[0]);
// // //         setLatestInfo(res?.data?.latestinfo[0]);
// // //         setLatestInfos(res?.data?.latestinfo[0]?.count);
// // //         setHighlightsPoints(res?.data?.highlight[0]?.features);
// // //         setHowtojoinpoints(res?.data?.howtojoin[0]?.benefits);
// // //         setPopUp(res?.data?.popup[0]);
// // //         setOffers(res?.data?.offer);
// // //         setservices(res?.data?.occasions);
// // //         setLgShow(res?.data?.popup[0]?.popupBoolean);
// // //         setIsLoading(false);
// // //       }
// // //     });
// // //     sessionStorage.clear();
// // //   };

// // //   const formsubmit = (e) => {
// // //     e.preventDefault();
// // //     EnquiryNow();
// // //   };

// // //   const handleChange = (e) => {
// // //     let myUser = { ...form };
// // //     myUser[e.target.name] = e.target.value;
// // //     setform(myUser);
// // //   };

// // //   const EnquiryNow = () => {
// // //     const dataArray = {
// // //       name: form.name,
// // //       email: form.email,
// // //       mobileNumber: form.mobileNumber,
// // //       description: form.description,
// // //       eventName: form.eventName,
// // //     };

// // //     axios.post(URLS.AddEnquiry, dataArray).then(
// // //       (res) => {
// // //         if (res.status === 200) {
// // //           toast(res.data.message);
// // //           setform({
// // //             name: "",
// // //             email: "",
// // //             mobileNumber: "",
// // //             description: "",
// // //             eventName: "",
// // //           });
// // //         }
// // //       },
// // //       (error) => {
// // //         if (error.response && error.response.status === 400) {
// // //           toast(error.response.data.message);
// // //         }
// // //       }
// // //     );
// // //   };

// // //   const [showAllFaqs, setShowAllFaqs] = useState(false);

// // //   const [showPopup, setShowPopup] = useState(false);
// // //   const [popupImage, setPopupImage] = useState("");

// // //   useEffect(() => {
// // //     const loadPopup = async () => {
// // //       const popup = await fetchPopupImage();

// // //       // ✅ Only open if modalEnabled is true
// // //       if (popup?.modalEnabled) {
// // //         setPopupImage(popup.image);
// // //         setShowPopup(true);
// // //       }
// // //     };

// // //     loadPopup();
// // //   }, []);

// // //   const settings = {
// // //     dots: false,
// // //     infinite: true,
// // //     speed: 1000,
// // //     fade: true,
// // //     slidesToShow: 1,
// // //     slidesToScroll: 1,
// // //     autoplay: true,
// // //     responsive: [
// // //       {
// // //         breakpoint: 1024,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //           infinite: true,
// // //           dots: false,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 600,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //           initialSlide: 1,
// // //           infinite: true,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 480,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //           infinite: true,
// // //         },
// // //       },
// // //     ],
// // //   };

// // //   const settings4 = {
// // //     dots: false,
// // //     infinite: true,
// // //     arrows: true,
// // //     speed: 1000,
// // //     slidesToShow: 1,
// // //     slidesToScroll: 1,
// // //     autoplay: true,
// // //     responsive: [
// // //       {
// // //         breakpoint: 1024,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //           infinite: true,
// // //           arrows: false,
// // //           dots: false,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 600,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //           initialSlide: 1,
// // //           infinite: true,
// // //           arrows: false,
// // //           dots: false,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 480,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //           infinite: true,
// // //           arrows: false,
// // //           dots: false,
// // //         },
// // //       },
// // //     ],
// // //   };

// // //   const settings2 = {
// // //     dots: false,
// // //     infinite: true,
// // //     arrows: true,
// // //     autoplay: false,
// // //     speed: 1000,
// // //     // slidesToShow: 4,
// // //     slidesToShow: 2,
// // //     slidesToScroll: 1,
// // //     initialSlide: 0,
// // //     responsive: [
// // //       {
// // //         breakpoint: 1024,
// // //         settings: {
// // //           slidesToShow: 3,
// // //           slidesToScroll: 3,
// // //           infinite: true,
// // //           dots: true,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 600,
// // //         settings: {
// // //           slidesToShow: 2,
// // //           slidesToScroll: 2,
// // //           initialSlide: 2,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 480,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //         },
// // //       },
// // //     ],
// // //   };

// // //   const settings3 = {
// // //     dots: false,
// // //     autoplay: true,
// // //     infinite: true,
// // //     speed: 1000,
// // //     slidesToShow: 4,
// // //     slidesToScroll: 4,
// // //     initialSlide: 0,
// // //     responsive: [
// // //       {
// // //         breakpoint: 1024,
// // //         settings: {
// // //           slidesToShow: 3,
// // //           slidesToScroll: 3,
// // //           infinite: true,
// // //           dots: true,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 600,
// // //         settings: {
// // //           slidesToShow: 2,
// // //           slidesToScroll: 2,
// // //           initialSlide: 2,
// // //         },
// // //       },
// // //       {
// // //         breakpoint: 480,
// // //         settings: {
// // //           slidesToShow: 1,
// // //           slidesToScroll: 1,
// // //         },
// // //       },
// // //     ],
// // //   };

// // //   const [images, setImages] = useState([]);

// // //   const GetAllGalleryDate = () => {
// // //     axios.post(URLS.GetAllGallery, {}, {}).then((res) => {
// // //       if (res.status === 200) {
// // //         setImages(res?.data?.gallerys?.slice(0, 3));
// // //       }
// // //     });
// // //   };

// // //   const [activeIndex, setActiveIndex] = useState(0);
// // //   const galleria = useRef(null);

// // //   const itemTemplate = (item) => {
// // //     return (
// // //       <img
// // //         src={URLS.Base + item.image}
// // //         alt={item.alt}
// // //         style={{ width: "100%", display: "block" }}
// // //       />
// // //     );
// // //   };

// // //   const thumbnailTemplate = (item) => {
// // //     return (
// // //       <img
// // //         src={URLS.Base + item.image}
// // //         alt={item.alt}
// // //         style={{ display: "block" }}
// // //       />
// // //     );
// // //   };

// // //   const [timeLeft, setTimeLeft] = useState(39639);

// // //   useEffect(() => {
// // //     if (timeLeft <= 0) return;
// // //     const intervalId = setInterval(() => {
// // //       setTimeLeft(timeLeft - 1);
// // //     }, 1000);
// // //     return () => clearInterval(intervalId);
// // //   }, [timeLeft]);

// // //   const formatTime = (time) => {
// // //     const hours = Math.floor(time / 3600);
// // //     const minutes = Math.floor((time % 3600) / 60);
// // //     const seconds = time % 60;
// // //     return {
// // //       hours: hours.toString().padStart(2, "0"),
// // //       minutes: minutes.toString().padStart(2, "0"),
// // //       seconds: seconds.toString().padStart(2, "0"),
// // //     };
// // //   };

// // //   const { hours, minutes, seconds } = formatTime(timeLeft);

// // //   const [Theaters, setTheaters] = useState([]);

// // //   const [hoveredIndex, setHoveredIndex] = useState(null);

// // //   useEffect(() => {
// // //     GetTheatersData();
// // //   }, []);

// // //   const GetTheatersData = () => {
// // //     axios.post(URLS.GetAllTheaters, {}, {}).then((res) => {
// // //       if (res.status === 200) {
// // //         setTheaters(res.data.theatres);
// // //       }
// // //     });
// // //   };

// // //   const today = new Date();

// // //   const [date, setDate] = useState(today);

// // //   const dateString = date;

// // //   const dateObject = new Date(dateString);

// // //   const dd = dateObject.getDate().toString().padStart(2, "0");
// // //   const mm = (dateObject.getMonth() + 1).toString().padStart(2, "0");
// // //   const yyyy = dateObject.getFullYear();

// // //   const formattedDateString = `${yyyy}-${mm}-${dd}`;

// // //   const databyid = (data) => {
// // //     sessionStorage.clear();
// // //     axios.post(URLS.GetUnicId, {}, {}).then((res) => {
// // //       if (res.status === 200) {
// // //         sessionStorage.setItem("UserId", res.data.userId);
// // //         sessionStorage.setItem("Theaterid", data._id);
// // //         sessionStorage.setItem("theatreName", data.name);
// // //         sessionStorage.setItem("theatrePrice", data.offerPrice);
// // //         sessionStorage.setItem("date", formattedDateString);
// // //         window.location.href = "/BookingDetails";
// // //       }
// // //     });
// // //   };

// // //   const navigateTheater = useNavigate();
// // //   const handleTheater = () => {
// // //     navigateTheater("./locations");
// // //   };

// // //   const [PopUp1, setPopUp1] = useState([]);

// // //   useEffect(() => {
// // //     GetFooterData();
// // //   }, []);

// // //   const GetFooterData = () => {
// // //     axios.post(URLS.GetFooter, {}, {}).then((res) => {
// // //       if (res.status === 200) {
// // //         setContact(res.data.contactus);
// // //         setPopUp1(res.data.popup[0]);
// // //       }
// // //     });
// // //   };

// // //   const [lgvis, setLgVis] = useState(false);

// // //   const modelShow = () => {
// // //     setLgVis(!false);
// // //   };



// // //   const packages = [
// // //     // {
// // //     //   id: 1,
// // //     //   title: "Basic Plan",
// // //     //   price: "2149",
// // //     //   subtitle: "Simple theatre slot, no setup",
// // //     //   detailedFeatures: {
// // //     //     "Theatre Hall": true,
// // //     //     "Decoration": true,
// // //     //     "Fog Entry (1 Pot)": false,
// // //     //     "Candle Path": false,
// // //     //     "HBD LED": false,
// // //     //     "Name with LED (6)": false,
// // //     //     "AGE Number LED": false,
// // //     //     "HBD with Rose petals": false,
// // //     //     "Photo Clipping (10)": false,
// // //     //     "Birthday Sash": false,
// // //     //     "Birthday Crown, Spects": false,
// // //     //     "Rose Bouquet (12 Roses)": false,
// // //     //     "Customisation cake (1 kg)": false,
// // //     //     "Photography (30 Mins)": false,
// // //     //     "Cold fire entry (6 pieces)": false,
// // //     //     "Videography(Edited 1 Min Reel)": false,
// // //     //     "Hall fog (4 Pots)": false,
// // //     //   },
// // //     //   badgeText: "Saved ₹0",
// // //     //   buttonText: "Proceed →",
// // //     // },
// // //     {
// // //       id: 2,
// // //       title: "Standard Plan",
// // //       subtitle: "Includes cake, lights & decor.",
// // //       detailedFeatures: {
// // //         "Theatre + Decoration": true,
// // //         "Fog Entry (1 Pot)": true,
// // //         "Candle Path": true,
// // //         "HBD LED": true,
// // //         "Name with LED (6)": true,
// // //         "AGE Number LED": true,
// // //         "HBD with Rose Petals": true,
// // //         "Photo Clipping (10)": true,
// // //         "Birthday Sash": true,
// // //         "Birthday Crown, Spects": true,
// // //         "Rose": true,
// // //         "Regular Cake - 1/2 kg": true,
// // //         "Photography (15 Mins)": true,
// // //         "Cold fire entry (6 pieces)": false,
// // //         "Videography(Edited 1 Min Reel)": false,
// // //         "Hall fog (4 Pots)": false,
// // //       },
// // //       badgeText: "Save ₹200",
// // //       buttonText: "Proceed →",
// // //     },
// // //     {
// // //       id: 3,
// // //       title: "Special Plan",
// // //       subtitle: "Our grandest experience, full royal vibes.",
// // //       detailedFeatures: {
// // //         "Theatre + Decoration": true,
// // //         "Fog Entry (1 Pot)": true,
// // //         "Candle Path": true,
// // //         "HBD LED": true,
// // //         "Name with LED (6)": true,
// // //         "AGE Number LED": true,
// // //         "HBD with Rose petals": true,
// // //         "Photo Clipping (10)": true,
// // //         "Birthday Sash": true,
// // //         "Birthday Crown, Spects": true,
// // //         "Rose Bouquet (6 Roses)": true,
// // //         "Customisation cake (1 kg)": true,
// // //         "Photography (30 Mins)": true,
// // //         "Cold fire entry (4 pieces)": true,
// // //         "Videography(Edited 1 Min Reel)": false,
// // //         "Hall fog (4 Pots)": false,
// // //       },
// // //       badgeText: "Save ₹400",
// // //       buttonText: "Proceed →",
// // //     },
// // //     {
// // //       id: 4,
// // //       title: "Premium Plan",
// // //       subtitle: "More guests, more upgrades, more glam.",
// // //       detailedFeatures: {
// // //         "Theatre + Decoration": true,
// // //         "Fog Entry (1 Pot)": true,
// // //         "Candle Path": true,
// // //         "HBD LED": true,
// // //         "Name with LED (6)": true,
// // //         "AGE Number LED": true,
// // //         "HBD with Rose petals": true,
// // //         "Photo Clipping (10)": true,
// // //         "Birthday Sash": true,
// // //         "Birthday Crown, Spects": true,
// // //         "Rose Bouquet (12 Roses)": true,
// // //         "Customisation cake (1 kg)": true,
// // //         "Photography (30 Mins)": true,
// // //         "Cold fire entry (6 pieces)": true,
// // //         "Videography(Edited 1 Min Reel)": true,
// // //         "Hall fog (4 Pots)": true,
// // //       },
// // //       badgeText: "Save ₹300",
// // //       buttonText: "Proceed →",
// // //     },
// // //   ];



// // //   const [showMore, setShowMore] = useState({});




// // //   const [index, setIndex] = useState(0);
// // //   const intervalRef = useRef(null);

// // //   const startAutoRotate = () => {
// // //     intervalRef.current = setInterval(() => {
// // //       setIndex((prevIndex) => (prevIndex + 1) % whyUsSlides.length);
// // //     }, 6000);
// // //   };

// // //   const stopAutoRotate = () => {
// // //     if (intervalRef.current) {
// // //       clearInterval(intervalRef.current);
// // //     }
// // //   };

// // //   useEffect(() => {
// // //     startAutoRotate();
// // //     return () => stopAutoRotate();
// // //   }, []);

// // //   const handleSelect = (selectedIndex) => {
// // //     stopAutoRotate();
// // //     setIndex(selectedIndex);
// // //     startAutoRotate(); // restart timer on manual select
// // //   };
// // //   const whyUsSlides = [
// // //     {
// // //       image: URLS?.Base + Highlights?.image, // Replace with dynamic images
// // //       title: "Why Choose CarnivalCastle Private Theatre?",
// // //       subtitle:
// // //         "At CarnivalCastle, we believe every celebration deserves a cinematic experience — intimate, exclusive and unforgettable. Here’s why our private theatre stands out:",
// // //       points: [
// // //         "Perfect for Every Occasion: Themed decorations, cakes, fog effects & photography.",
// // //         "Luxurious Ambience: Recliners, premium sound, elegant decor.",
// // //         "Budget-Friendly Luxury: Combo offers & rewards for every budget.",
// // //         "Prime Location in Hyderabad: Easily accessible, cozy, and convenient.",
// // //         "End-to-End Convenience: WhatsApp support, décor add-ons & great food."
// // //       ]
// // //     },
// // //     {
// // //       image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg", // Replace with another image
// // //       title: "Celebrate Cinematically!",
// // //       subtitle:
// // //         "Experience celebrations like never before in our private theatres — where entertainment meets exclusivity.",
// // //       points: [
// // //         "Customizable Packages: Tailor your party exactly how you like it.",
// // //         "Gourmet Snacks & Beverages: From popcorn to premium platters.",
// // //         "Full HD Projector & Sound: A real theatre vibe, privately yours.",
// // //         "Cozy for Everyone: Perfect for couples, families, and friends.",
// // //         "Hassle-Free Booking: Fast, flexible & fully digital!"
// // //       ]
// // //     },
// // //     {
// // //       image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg", // Replace with another image
// // //       title: "Make Every Moment Magical",
// // //       subtitle:
// // //         "From surprise proposals to baby showers — bring your vision to life in an immersive, themed theatre setting.",
// // //       points: [
// // //         "Baby Showers, Anniversaries & More: Celebrate every milestone.",
// // //         "Themed Decor & Props: Transform the space into your dream setting.",
// // //         "Memorable Photo Zones: Instagram-worthy backdrops included.",
// // //         "Night or Day Slots: Flexible celebration timings.",
// // //         "Personalized Assistance: Our team helps plan every detail."
// // //       ]
// // //     }
// // //   ];

// // //   const [testimonials, setTestimonials] = useState([]);
// // //   const [selected, setSelected] = useState(null);

// // //   useEffect(() => {
// // //     const fetchTestimonials = async () => {
// // //       try {
// // //         const res = await axios.post(
// // //           "https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle"
// // //         );

// // //         if (res.data?.success && Array.isArray(res.data.testimoni)) {
// // //           // ✅ Only include testimonials that are active and have a valid videoId
// // //           const videoTestimonials = res.data.testimoni.filter(
// // //             (t) =>
// // //               t.status === "active" &&
// // //               t.videoId &&
// // //               t.videoId.trim() !== ""
// // //           );

// // //           setTestimonials(videoTestimonials);
// // //           console.log("Video Testimonials:", videoTestimonials);

// // //           // ✅ Set first video testimonial as default selected
// // //           if (videoTestimonials.length > 0) {
// // //             setSelected(videoTestimonials[0]);
// // //           }
// // //         }
// // //       } catch (err) {
// // //         console.error("Error fetching testimonials:", err);
// // //       }
// // //     };

// // //     fetchTestimonials();
// // //   }, []);


// // //   const [slides, setSlides] = useState([]);

// // //   useEffect(() => {
// // //     const fetchTestimonials = async () => {
// // //       try {
// // //         const res = await axios.post(
// // //           "https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle"
// // //         );

// // //         if (res.data?.success && Array.isArray(res.data.testimoni)) {
// // //           // ✅ Filter only active + with videoId
// // //           const filtered = res.data.testimoni.filter(
// // //             (t) => t.status === "active" && t.videoId
// // //           );

// // //           // ✅ Map API fields to front-end fields
// // //           const formatted = filtered.map((t) => ({
// // //             name: t.name,
// // //             location: t.role || "Customer",
// // //             rating: Number(t.rating) || 5,
// // //             description: t.description || "",
// // //             image: `https://api.carnivalcastle.com/${t.image}`,
// // //             avatar: `https://api.carnivalcastle.com/${t.profileImage}`, // using same image as avatar
// // //             occasion: t.type === "Yes" ? "Special Celebration" : "",
// // //           }));

// // //           // ✅ Group into slides of 3 per slide
// // //           const grouped = [];
// // //           for (let i = 0; i < formatted.length; i += 3) {
// // //             grouped.push(formatted.slice(i, i + 3));
// // //           }

// // //           setSlides(grouped);
// // //         }
// // //       } catch (err) {
// // //         console.error("Error fetching testimonials:", err);
// // //       }
// // //     };

// // //     fetchTestimonials();
// // //   }, []);




// // //   const [occasions, setOccasions] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);

// // //   useEffect(() => {
// // //     const fetchOccasions = async () => {
// // //       try {
// // //         const response = await axios.post(URLS.GetAllOccation, {});
// // //         if (response.status === 200) {
// // //           setOccasions(response.data?.occasions || []);
// // //         }
// // //       } catch (err) {
// // //         setError(err.message);
// // //       } finally {
// // //         setLoading(false);
// // //       }
// // //     };

// // //     fetchOccasions();
// // //   }, []);




// // //   const BaseUrl = "https://api.carnivalcastle.com/v1/carnivalApi/";
// // //   const ImageBase = "https://api.carnivalcastle.com/";

// // //   const [addresses, setAddresses] = useState([]);

// // //   useEffect(() => {
// // //     const fetchAddresses = async () => {
// // //       try {
// // //         const res = await axios.get(`${BaseUrl}admin/address/alladdress`);
// // //         if (res.data && res.data.success) {
// // //           setAddresses(res.data.data || []);
// // //         } else {
// // //           setAddresses([]);
// // //         }
// // //       } catch (error) {
// // //         console.error("Error fetching addresses:", error);
// // //         setAddresses([]);
// // //       }
// // //     };
// // //     fetchAddresses();
// // //   }, []);


// // //   const [lgShow, setLgShow] = useState(false);

// // //   useEffect(() => {
// // //     const isModalShown = localStorage.getItem("popupShown");
// // //     if (!isModalShown) {
// // //       setLgShow(true);
// // //     }
// // //   }, []);

// // //   const handleClose = () => {
// // //     setLgShow(false);
// // //     localStorage.setItem("popupShown", "true");
// // //   };

// // //   const [banner, setBanner] = useState(null);
// // //   const [currentIndex, setCurrentIndex] = useState(0);

// // //   // Fetch Banner Data
// // //   useEffect(() => {
// // //     const fetchBanner = async () => {
// // //       try {
// // //         const res = await axios.get(
// // //           "https://api.carnivalcastle.com/v1/carnivalApi/admin/get-banners?type=carnivalcastle"
// // //         );
// // //         if (res.data.success && res.data.banners.length > 0) {
// // //           setBanner(res.data.banners[0]);
// // //         }
// // //       } catch (err) {
// // //         console.error("Error fetching banner:", err);
// // //       }
// // //     };
// // //     fetchBanner();
// // //   }, []);

// // //   // Auto-slide every 4 seconds
// // //   useEffect(() => {
// // //     if (!banner?.desktopImages?.length) return;
// // //     const interval = setInterval(() => {
// // //       setCurrentIndex((prevIndex) =>
// // //         prevIndex + 1 >= banner.desktopImages.length ? 0 : prevIndex + 1
// // //       );
// // //     }, 3000);
// // //     return () => clearInterval(interval);
// // //   }, [banner]);

// // //   if (!banner) return null;

// // //   // Get current image
// // //   const desktopImage1 = `https://api.carnivalcastle.com/${banner.desktopImages[currentIndex]}`;
// // //   const mobileImage = `https://api.carnivalcastle.com/${banner.mobileImages[currentIndex]}`;

// // //   // Manual navigation
// // //   const prevSlide = () =>
// // //     setCurrentIndex((prev) =>
// // //       prev === 0 ? banner.desktopImages.length - 1 : prev - 1
// // //     );
// // //   const nextSlide = () =>
// // //     setCurrentIndex((prev) =>
// // //       prev + 1 >= banner.desktopImages.length ? 0 : prev + 1
// // //     );


// // //   return (
// // //     <>
// // //       <Helmet>
// // //         <meta charSet="utf-8" />
// // //         <title>
// // //           Carnival Castle | Best Private Theaters for Celebrations in Hyderabad
// // //         </title>
// // //         <meta
// // //           name="description"
// // //           content="Experience the magic of celebrations at Carnival Castle Private Theatres in Hyderabad. Perfect for Birthdays, Anniversaries, Bride To Be, Surprise Parties, etc"
// // //         />
// // //       </Helmet>

// // //       {isLoading == true ? (
// // //         <>
// // //           <div
// // //             className="text-center"
// // //             style={{
// // //               // background:
// // //               //   "linear-gradient(329deg, rgba(191, 63, 249, 1) 0%, rgba(113, 51, 210, 1) 100%)",
// // //               backgroundColor: "var(--charcoal-black)",
// // //               height: "100vh",
// // //               display: "flex",
// // //               alignItems: "center",
// // //               justifyContent: "center",
// // //               flexDirection: "column",
// // //             }}
// // //           >
// // //             <div>
// // //               <img
// // //                 src="assets/img/giff.gif"
// // //                 style={{ height: "300px", color: "white" }}
// // //               ></img>
// // //               <h6 style={{ color: "gold" }}>Loading...</h6>
// // //             </div>
// // //           </div>
// // //         </>
// // //       ) : (
// // //         <>
// // //           <div className="home-page indexsix bg-dark">
// // //             <div className="main-wrapper bg-light">
// // //               <>
// // //                 <Header />
// // //                 <div className="scrollbar">
// // //                   {/* <Time/> */}
// // //                   <Slider {...settings}>
// // //                     {/* Desktop images ko map karo */}
// // //                     {banner?.desktopImages?.map((desktopImage, index) => (
// // //                       <div key={index}>
// // //                         <div className="mt-0">
// // //                           {PopUp1.modalEnabled && (
// // //                             <div style={{ backgroundColor: "#9D4DFF" }} className="text-center py-2">
// // //                               <marquee className="text-white fw-bold">
// // //                                 {PopUp1.title}
// // //                               </marquee>
// // //                             </div>
// // //                           )}
// // //                         </div>
// // //                         <section
// // //                           className="banner-section d-flex align-items-center position-relative text-white overflow-hidden"
// // //                           style={{
// // //                             backgroundImage: `url(https://api.carnivalcastle.com/${desktopImage})`,
// // //                             backgroundSize: "cover",
// // //                             backgroundPosition: "center",
// // //                             backgroundRepeat: "no-repeat",
// // //                             height: "80vh",
// // //                             transition: "background-image 1s ease-in-out",
// // //                           }}
// // //                         >
// // //                           {/* Overlay */}
// // //                           <div
// // //                             className="overlay position-absolute w-100 h-100"
// // //                             style={{
// // //                               background: "rgba(0, 0, 0, 0.4)",
// // //                               top: 0,
// // //                               left: 0,
// // //                               zIndex: 1,
// // //                             }}
// // //                           ></div>

// // //                           {/* Content */}
// // //                           <div className="container position-relative h-100" style={{ zIndex: 2 }}>
// // //                             <div className="row justify-content-center text-center text-md-start h-100">
// // //                               <div className="col-lg-10 d-flex flex-column justify-content-center h-100">
// // //                                 <h1 className="fw-bold mb-3 animate__animated animate__fadeInDown">
// // //                                   {banner.title}
// // //                                 </h1>
// // //                                 <p className="lead mt-2 mb-4 animate__animated animate__fadeInUp">
// // //                                   {banner.description}
// // //                                 </p>

// // //                                 <div className="banner-buttons d-flex flex-column flex-sm-row gap-3">
// // //                                   <a
// // //                                     href="/locations"
// // //                                     className="btn btn-lg px-4 fw-bold btn-light"
// // //                                   >
// // //                                     Book Now
// // //                                   </a>
// // //                                   <a
// // //                                     href="tel:8977917555"
// // //                                     className="btn btn-lg px-4 fw-bold btn-light"
// // //                                   >
// // //                                     Book via Call
// // //                                   </a>
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           </div>



// // //                           {/* Slide Dots */}
// // //                           <div
// // //                             className="position-absolute w-100 d-flex justify-content-center gap-2"
// // //                             style={{ bottom: "25px", zIndex: 3 }}
// // //                           >
// // //                             {banner.desktopImages.map((_, index) => (
// // //                               <div
// // //                                 key={index}
// // //                                 onClick={() => setCurrentIndex(index)}
// // //                                 style={{
// // //                                   width: currentIndex === index ? "12px" : "8px",
// // //                                   height: currentIndex === index ? "12px" : "8px",
// // //                                   borderRadius: "50%",
// // //                                   background:
// // //                                     currentIndex === index
// // //                                       ? "#fff"
// // //                                       : "rgba(255,255,255,0.5)",
// // //                                   cursor: "pointer",
// // //                                   transition: "all 0.3s ease",
// // //                                 }}
// // //                               ></div>
// // //                             ))}
// // //                           </div>

// // //                           {/* Mobile background override */}
// // //                           <style>
// // //                             {`
// // //                               @media (max-width: 768px) {
// // //                                 .banner-section {
// // //                                   background-image: url(${mobileImage}) !important;
// // //                                 }
// // //                               }
// // //                             `}
// // //                           </style>
// // //                         </section>

// // //                       </div>
// // //                     )
// // //                     )}
// // //                   </Slider>
// // //                 </div>

// // //                 {testimonials.length > 0 && (
// // //                   <section
// // //                     className="py-5 position-relative text-dark"
// // //                     style={{ backgroundColor: "#fff", overflowX: "hidden" }}
// // //                   >
// // //                     <Container fluid="lg">
// // //                       <Row className="flex-column align-items-center text-center">
// // //                         {/* TITLE */}
// // //                         <Col xs={12} className="mb-4">
// // //                           <h2 className="fw-bold mt-3 dark-text">Testimonials</h2>
// // //                           <p className="light-text fs-6">
// // //                             Real stories. Real celebrations. Real magic at Binge N Joy.
// // //                           </p>
// // //                         </Col>

// // //                         {/* SLIDER */}
// // //                         <Col xs={12} className="d-flex justify-content-center position-relative">
// // //                           <div
// // //                             id="testimonial3DCarousel"
// // //                             className="carousel slide carousel-fade position-relative"
// // //                             data-bs-ride="false"
// // //                           >
// // //                             <div className="carousel-inner w-100">
// // //                               {testimonials.map((item, index) => {
// // //                                 const prevIndex = index === 0 ? testimonials.length - 1 : index - 1;
// // //                                 const nextIndex = index === testimonials.length - 1 ? 0 : index + 1;

// // //                                 return (
// // //                                   <div
// // //                                     key={index}
// // //                                     className={`carousel-item ${index === 0 ? "active" : ""}`}
// // //                                   >
// // //                                     <div className="d-flex justify-content-center align-items-center gap-3 px-3">
// // //                                       {/* LEFT SMALL CARD - PREVIOUS TESTIMONIAL */}
// // //                                       <div
// // //                                         className="side-video small-card shadow rounded overflow-hidden d-none d-md-block"
// // //                                         style={{
// // //                                           width: "150px",
// // //                                           height: "200px",
// // //                                           backgroundImage: `url(${testimonials[prevIndex]?.profileImage
// // //                                             ? testimonials[prevIndex]?.profileImage.replace(/\\/g, "/").startsWith("uploads/")
// // //                                               ? `https://api.carnivalcastle.com/${testimonials[prevIndex]?.profileImage.replace(/\\/g, "/")}`
// // //                                               : testimonials[prevIndex]?.profileImage
// // //                                             : ""
// // //                                             })`,

// // //                                           backgroundSize: "cover",
// // //                                           backgroundPosition: "center",
// // //                                           opacity: "0.7",
// // //                                         }}
// // //                                       >
// // //                                         <div className="w-100 h-100 d-flex align-items-end justify-content-center p-2">
// // //                                           <div className="bg-dark bg-opacity-75 text-white px-2 py-1 rounded small">
// // //                                             {testimonials[prevIndex]?.name}
// // //                                           </div>
// // //                                         </div>
// // //                                       </div>

// // //                                       {/* MAIN VIDEO - CURRENT TESTIMONIAL */}
// // //                                       <div
// // //                                         className="main-video-card position-relative shadow rounded overflow-hidden"
// // //                                         style={{ width: "400px" }}
// // //                                       >
// // //                                         <iframe
// // //                                           width="100%"
// // //                                           height="300"
// // //                                           src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1&loop=0`}
// // //                                           title={item.name}
// // //                                           allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
// // //                                           allowFullScreen
// // //                                         ></iframe>

// // //                                         <div className="label-card mt-3">
// // //                                           <div className="bg-white px-3 py-2 rounded-4 shadow-sm text-center">
// // //                                             <strong className="dark-text">{item.name}</strong>
// // //                                             <br />
// // //                                             <small className="text-dark">{item.role}</small>
// // //                                           </div>
// // //                                         </div>
// // //                                       </div>

// // //                                       {/* RIGHT SMALL CARD - NEXT TESTIMONIAL */}
// // //                                       <div
// // //                                         className="side-video small-card shadow rounded overflow-hidden d-none d-md-block"
// // //                                         style={{
// // //                                           width: "150px",
// // //                                           height: "200px",
// // //                                           backgroundImage: `url(${testimonials[nextIndex]?.profileImage?.replace(/\\/g, "/").startsWith("uploads/")
// // //                                             ? `https://api.carnivalcastle.com/${testimonials[nextIndex]?.profileImage.replace(/\\/g, "/")}`
// // //                                             : testimonials[nextIndex]?.profileImage
// // //                                             })`,

// // //                                           backgroundSize: "cover",
// // //                                           backgroundPosition: "center",
// // //                                           opacity: "0.7",
// // //                                         }}
// // //                                       >
// // //                                         <div className="w-100 h-100 d-flex align-items-end justify-content-center p-2">
// // //                                           <div className="bg-dark bg-opacity-75 text-white px-2 py-1 rounded small">
// // //                                             {testimonials[nextIndex]?.name}
// // //                                           </div>
// // //                                         </div>
// // //                                       </div>
// // //                                     </div>
// // //                                   </div>
// // //                                 );
// // //                               })}
// // //                             </div>

// // //                             {/* Desktop Indicators - Top position */}
// // //                             <div className="carousel-indicators position-relative mt-4 d-none d-md-flex justify-content-center">
// // //                               {testimonials.map((_, index) => (
// // //                                 <button
// // //                                   key={index}
// // //                                   type="button"
// // //                                   data-bs-target="#testimonial3DCarousel"
// // //                                   data-bs-slide-to={index}
// // //                                   className={index === 0 ? "active" : ""}
// // //                                   aria-current={index === 0 ? "true" : "false"}
// // //                                   aria-label={`Slide ${index + 1}`}
// // //                                 ></button>
// // //                               ))}
// // //                             </div>

// // //                             {/* Mobile Navigation Buttons - Bottom position */}
// // //                             <div className="d-md-none mobile-navigation-buttons position-absolute w-100 d-flex justify-content-center align-items-center gap-3">
// // //                               <button
// // //                                 className="mobile-nav-btn mobile-prev-btn bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
// // //                                 type="button"
// // //                                 data-bs-target="#testimonial3DCarousel"
// // //                                 data-bs-slide="prev"
// // //                                 aria-label="Previous testimonial"
// // //                               >
// // //                                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// // //                                   <path d="M15 18l-6-6 6-6" />
// // //                                 </svg>
// // //                               </button>

// // //                               {/* Mobile Slide Indicators */}
// // //                               <div className="d-flex align-items-center gap-2">
// // //                                 {testimonials.map((_, index) => (
// // //                                   <button
// // //                                     key={index}
// // //                                     type="button"
// // //                                     data-bs-target="#testimonial3DCarousel"
// // //                                     data-bs-slide-to={index}
// // //                                     className={`mobile-indicator-btn ${index === 0 ? "active" : ""}`}
// // //                                     aria-label={`Go to slide ${index + 1}`}
// // //                                   ></button>
// // //                                 ))}
// // //                               </div>

// // //                               <button
// // //                                 className="mobile-nav-btn mobile-next-btn bg-dark text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
// // //                                 type="button"
// // //                                 data-bs-target="#testimonial3DCarousel"
// // //                                 data-bs-slide="next"
// // //                                 aria-label="Next testimonial"
// // //                               >
// // //                                 <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
// // //                                   <path d="M9 18l6-6-6-6" />
// // //                                 </svg>
// // //                               </button>
// // //                             </div>

// // //                             {/* Desktop Controls */}
// // //                             {/* <button
// // //                               className="carousel-control-prev d-none d-md-flex"
// // //                               type="button"
// // //                               data-bs-target="#testimonial3DCarousel"
// // //                               data-bs-slide="prev"
// // //                             >
// // //                               <span
// // //                                 className="carousel-control-prev-icon bg-dark rounded-circle p-2"
// // //                                 aria-hidden="true"
// // //                               ></span>
// // //                               <span className="visually-hidden">Previous</span>
// // //                             </button>
// // //                             <button
// // //                               className="carousel-control-next d-none d-md-flex"
// // //                               type="button"
// // //                               data-bs-target="#testimonial3DCarousel"
// // //                               data-bs-slide="next"
// // //                             >
// // //                               <span
// // //                                 className="carousel-control-next-icon bg-dark rounded-circle p-2"
// // //                                 aria-hidden="true"
// // //                               ></span>
// // //                               <span className="visually-hidden">Next</span>
// // //                             </button> */}
// // //                           </div>
// // //                         </Col>
// // //                       </Row>
// // //                     </Container>

// // //                     {/* CSS */}
// // //                     <style jsx>{`
// // //       #testimonial3DCarousel {
// // //         margin: 0 auto;
// // //         max-width: 900px;
// // //         width: 100%;
// // //         position: relative;
// // //         padding-bottom: 80px; /* Space for mobile navigation */
// // //       }

// // //       .carousel-inner {
// // //         text-align: center;
// // //       }

// // //       .carousel-item {
// // //         transition: transform 0.6s ease-in-out;
// // //       }

// // //       .carousel-item.active .main-video-card {
// // //         transform: scale(1.05);
// // //         transition: transform 0.6s ease;
// // //       }

// // //       .carousel-item.active .side-video {
// // //         opacity: 1 !important;
// // //         transform: scale(0.9);
// // //         transition: all 0.4s ease;
// // //       }

// // //       .main-video-card {
// // //         transition: all 0.6s ease;
// // //         z-index: 2;
// // //         flex-shrink: 0;
// // //       }

// // //       .side-video {
// // //         transition: all 0.4s ease;
// // //         position: relative;
// // //         cursor: pointer;
// // //       }

// // //       .side-video:hover {
// // //         opacity: 0.9 !important;
// // //         transform: scale(0.95);
// // //       }

// // //       /* Desktop Indicators */
// // //       .carousel-indicators.position-relative {
// // //         margin-top: 2rem;
// // //       }

// // //       .carousel-indicators.position-relative button {
// // //         background-color: #dee2e6;
// // //         width: 10px;
// // //         height: 10px;
// // //         border-radius: 50%;
// // //         border: none;
// // //         margin: 0 5px;
// // //         transition: all 0.3s ease;
// // //       }

// // //       .carousel-indicators.position-relative .active {
// // //         background-color: #7b2cbf;
// // //         width: 25px;
// // //         border-radius: 10px;
// // //       }

// // //       /* Mobile Navigation Buttons */
// // //       .mobile-navigation-buttons {
// // //         bottom: 10px;
// // //         left: 0;
// // //         right: 0;
// // //         padding: 0 20px;
// // //         z-index: 10;
// // //       }

// // //       .mobile-nav-btn {
// // //         width: 44px;
// // //         height: 44px;
// // //         background-color: #7b2cbf !important;
// // //         border: none;
// // //         cursor: pointer;
// // //         transition: all 0.3s ease;
// // //         flex-shrink: 0;
// // //       }

// // //       .mobile-nav-btn:hover {
// // //         background-color: #6a1b9a !important;
// // //         transform: scale(1.1);
// // //       }

// // //       .mobile-nav-btn:active {
// // //         transform: scale(0.95);
// // //       }

// // //       .mobile-nav-btn svg {
// // //         color: white;
// // //       }

// // //       /* Mobile Slide Indicators */
// // //       .mobile-indicator-btn {
// // //         width: 10px;
// // //         height: 10px;
// // //         border-radius: 50%;
// // //         border: none;
// // //         background-color: #dee2e6;
// // //         cursor: pointer;
// // //         transition: all 0.3s ease;
// // //         margin: 0 2px;
// // //       }

// // //       .mobile-indicator-btn.active {
// // //         background-color: #7b2cbf;
// // //         width: 25px;
// // //         border-radius: 10px;
// // //       }

// // //       .mobile-indicator-btn:hover {
// // //         background-color: #7b2cbf;
// // //         transform: scale(1.2);
// // //       }

// // //       .carousel-control-prev,
// // //       .carousel-control-next {
// // //         width: auto;
// // //         opacity: 1;
// // //       }

// // //       .carousel-control-prev {
// // //         left: -50px;
// // //       }

// // //       .carousel-control-next {
// // //         right: -50px;
// // //       }

// // //       /* Mobile-specific styles */
// // //       @media (max-width: 1200px) {
// // //         .carousel-control-prev {
// // //           left: -30px;
// // //         }
// // //         .carousel-control-next {
// // //           right: -30px;
// // //         }
// // //       }

// // //       @media (max-width: 992px) {
// // //         .main-video-card {
// // //           width: 100% !important;
// // //           max-width: 350px;
// // //         }

// // //         .side-video {
// // //           display: none !important;
// // //         }

// // //         .carousel-control-prev {
// // //           left: -20px;
// // //         }
// // //         .carousel-control-next {
// // //           right: -20px;
// // //         }

// // //         #testimonial3DCarousel {
// // //           padding-bottom: 70px;
// // //         }

// // //         .mobile-navigation-buttons {
// // //           bottom: 5px;
// // //         }
// // //       }

// // //       @media (max-width: 768px) {
// // //         .mobile-nav-btn {
// // //           width: 40px;
// // //           height: 40px;
// // //         }

// // //         .mobile-indicator-btn {
// // //           width: 8px;
// // //           height: 8px;
// // //         }

// // //         .mobile-indicator-btn.active {
// // //           width: 20px;
// // //         }
// // //       }

// // //       @media (max-width: 576px) {
// // //         .main-video-card iframe {
// // //           height: 220px;
// // //         }

// // //         .carousel-control-prev,
// // //         .carousel-control-next {
// // //           display: none;
// // //         }

// // //         #testimonial3DCarousel {
// // //           padding-bottom: 60px;
// // //         }

// // //         .mobile-navigation-buttons {
// // //           bottom: 0;
// // //           padding: 0 15px;
// // //         }

// // //         .mobile-nav-btn {
// // //           width: 36px;
// // //           height: 36px;
// // //         }

// // //         .mobile-indicator-btn {
// // //           width: 7px;
// // //           height: 7px;
// // //         }

// // //         .mobile-indicator-btn.active {
// // //           width: 18px;
// // //         }
// // //       }

// // //       @media (max-width: 400px) {
// // //         .mobile-nav-btn {
// // //           width: 32px;
// // //           height: 32px;
// // //         }

// // //         .mobile-indicator-btn {
// // //           width: 6px;
// // //           height: 6px;
// // //           margin: 0 1px;
// // //         }

// // //         .mobile-indicator-btn.active {
// // //           width: 16px;
// // //         }

// // //         #testimonial3DCarousel {
// // //           padding-bottom: 50px;
// // //         }

// // //         .mobile-navigation-buttons {
// // //           gap: 2px;
// // //         }
// // //       }
// // //     `}</style>
// // //                   </section>
// // //                 )}







// // //                 <section
// // //                   className="occasions-section py-5 text-dark"
// // //                   style={{ backgroundColor: "#fff" }}
// // //                 >
// // //                   <div className="container">
// // //                     <h2 className="text-center mb-5 light-text">
// // //                       What Can You Celebrate at Carnival Castle?
// // //                     </h2>

// // //                     <div
// // //                       className="card text-white p-4 rounded-4 border-0"
// // //                       style={{ backgroundColor: "#E9DCFF" }}
// // //                     >
// // //                       <Slider
// // //                         dots={false}
// // //                         infinite={true}
// // //                         speed={500}
// // //                         slidesToShow={3} // default for large screens
// // //                         slidesToScroll={1} // scroll one card at a time
// // //                         autoplay={true}
// // //                         autoplaySpeed={3000}
// // //                         responsive={[
// // //                           {
// // //                             breakpoint: 992, // medium devices
// // //                             settings: {
// // //                               slidesToShow: 2,
// // //                               slidesToScroll: 1,
// // //                             },
// // //                           },
// // //                           {
// // //                             breakpoint: 768, // small devices
// // //                             settings: {
// // //                               slidesToShow: 1,
// // //                               slidesToScroll: 1,
// // //                             },
// // //                           },
// // //                         ]}
// // //                       >
// // //                         {occasions.map((occasion, index) => {
// // //                           let description = "";
// // //                           switch (occasion.name) {
// // //                             case "Anniversary":
// // //                               description =
// // //                                 "Celebrate your love and commitment in a private, luxurious theatre at CarnivalCastle. Enjoy a personalized ambiance, delicious food, and exceptional picture quality.";
// // //                               break;
// // //                             case "Bride To Be":
// // //                               description =
// // //                                 "Celebrate your upcoming wedding with a special private screening. Enjoy a memorable day filled with personalized decor, scrumptious food, and a luxurious theatre experience.";
// // //                               break;
// // //                             case "Groom To Be":
// // //                               description =
// // //                                 "Make the groom’s last night as a bachelor memorable with a private screening and special services. Enjoy delicious food, exceptional sound, and an intimate theatre experience.";
// // //                               break;
// // //                             case "Dad To Be":
// // //                               description =
// // //                                 "Celebrate the soon-to-be father in a private, luxurious setting with custom decor and exceptional service. Enjoy great food, a perfect movie, and a memorable experience.";
// // //                               break;
// // //                             case "Mom To Be":
// // //                               description =
// // //                                 "Celebrate the expecting mother in a private theatre with amazing decor and personalized services. Enjoy a relaxing, unforgettable experience with great food and movies.";
// // //                               break;
// // //                             case "Love Proposal":
// // //                               description =
// // //                                 "Plan the perfect surprise proposal at CarnivalCastle Private Theatres. With a magical atmosphere, your proposal will be an unforgettable moment, complete with beautiful decor and food.";
// // //                               break;
// // //                             case "Marriage Proposal":
// // //                               description =
// // //                                 "Propose in the most romantic and unforgettable way at CarnivalCastle. Enjoy a private theatre with personalized decor, delicious food, and everything you need for the perfect proposal.";
// // //                               break;
// // //                             case "Farewell":
// // //                               description =
// // //                                 "Bid farewell in style at CarnivalCastle Private Theatres. Celebrate the memories with a private screening, delicious food, and the perfect ambiance for your farewell.";
// // //                               break;
// // //                             case "Bon voyage":
// // //                               description =
// // //                                 "Send off a loved one with a special farewell event at CarnivalCastle Private Theatres. Enjoy a private screening with gourmet food and personalized decor for the perfect bon voyage.";
// // //                               break;
// // //                             default:
// // //                               description =
// // //                                 "Carnival Castle Private Theatres is the perfect place to celebrate any special occasion. Enjoy an intimate and luxurious setting with exceptional picture and sound quality, delicious food, and attentive staff.";
// // //                               break;
// // //                           }

// // //                           return (
// // //                             <div key={index} className="px-2">
// // //                               <div
// // //                                 className="card h-100 text-center bg-light rounded-4 gradient45 p-2"
// // //                               >
// // //                                 <div className="card-body d-flex flex-column align-items-center" onClick={() => navigateTheater("/locations")}>
// // //                                   <img
// // //                                     src={URLS.Base + occasion.image}
// // //                                     alt={occasion.name}
// // //                                     className="rounded-5 mb-3 img-fluid"
// // //                                     style={{
// // //                                       height: "250px",
// // //                                       width: "100%",
// // //                                       objectFit: "cover",
// // //                                       border: "2px solid #9D4DFF",
// // //                                     }}
// // //                                   />
// // //                                   <h2 className="card-title fw-bold" style={{ color: "#681DC0" }}>
// // //                                     {occasion.name === "Carnival Castle"
// // //                                       ? "Carnival Castle"
// // //                                       : occasion.name}
// // //                                   </h2>
// // //                                   {/* <p className="card-text small">{description}</p> */}
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           );
// // //                         })}
// // //                       </Slider>

// // //                       {/* Proceed Button */}
// // //                       <div className="text-center">

// // //                         {/* Proceed Button */}
// // //                         <button
// // //                           className="btn px-5 py-2 rounded-3 fw-bold light-back text-light mb-3"
// // //                           style={{ width: "80%", maxWidth: "500px" }}
// // //                           onClick={() => navigateTheater("/locations")}
// // //                         >
// // //                           Proceed to Book <i className="bi bi-arrow-right ms-2"></i>
// // //                         </button>

// // //                         {/* WhatsApp Chat Button */}
// // //                         <div>
// // //                           <a
// // //                             href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets."
// // //                             target="_blank"
// // //                             rel="noopener noreferrer"
// // //                             className="btn px-5 py-1 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2"
// // //                             style={{
// // //                               width: "80%",
// // //                               maxWidth: "500px",
// // //                               background: "#25D366",
// // //                               color: "#fff",
// // //                               margin: "0 auto"
// // //                             }}
// // //                           >
// // //                             <i className="bi bi-whatsapp fs-5"></i>
// // //                             Chat With Us
// // //                           </a>
// // //                         </div>

// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                   <style jsx>{`
// // //                   /* slider indicators */
// // // .slick-dots {
// // //   bottom: -35px;
// // // }

// // // .slick-dots li button:before {
// // //   font-size: 10px;
// // //   color: #ccc; /* inactive color */
// // //   opacity: 1;
// // // }

// // // .slick-dots li.slick-active button:before {
// // //   color: #681DC0; /* active dot color */
// // // }
// // //   `}</style>
// // //                 </section>

// // //                 <section className="services-section py-2 text-dark bg-white">
// // //                   <div className="container">
// // //                     <h2 className="text-center dark-text fw-bold">Our Services</h2>

// // //                     {/* Large Card Wrapper */}
// // //                     <div className="card text-dark p-4 rounded-4 border-0" style={{ backgroundColor: "#fff" }}>

// // //                       {/* Carousel for Mobile/Tablet */}
// // //                       <div
// // //                         id="servicesCarousel"
// // //                         className="carousel slide d-xl-none"
// // //                         data-bs-ride="carousel"
// // //                         data-bs-interval="3000"
// // //                       >
// // //                         <div className="carousel-inner">
// // //                           {/* Slide 1 - Food & Beverages */}
// // //                           <div className="carousel-item active">
// // //                             <div className="row g-4 justify-content-center">
// // //                               <div className="col-12 col-md-6">
// // //                                 <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                                   <div className="card-body d-flex flex-column align-items-center">
// // //                                     <img
// // //                                       src={beverages}
// // //                                       alt="Food & Beverages"
// // //                                       className="rounded mb-3"
// // //                                       style={{
// // //                                         height: "200px",
// // //                                         width: "100%",
// // //                                         objectFit: "cover",
// // //                                         border: "2px solid"
// // //                                       }}
// // //                                     />
// // //                                     <h5 className="card-title light-text">Food & Beverages</h5>
// // //                                     <p className="card-text">Choose the perfect food combo for your celebration.</p>
// // //                                     <a href="/Food" className="mt-auto light-text">
// // //                                       View more <i className="fas fa-arrow-right"></i>
// // //                                     </a>
// // //                                   </div>
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           </div>

// // //                           {/* Slide 2 - Screening */}
// // //                           <div className="carousel-item">
// // //                             <div className="row g-4 justify-content-center">
// // //                               <div className="col-12 col-md-6">
// // //                                 <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                                   <div className="card-body d-flex flex-column align-items-center">
// // //                                     <img
// // //                                       src={cake4}
// // //                                       alt="Cakes"
// // //                                       className="rounded mb-3"
// // //                                       style={{
// // //                                         height: "200px",
// // //                                         width: "100%",
// // //                                         objectFit: "cover",
// // //                                         border: "2px solid #E9BE5F"
// // //                                       }}
// // //                                     />
// // //                                     <h5 className="card-title light-text">Cakes</h5>
// // //                                     <p className="card-text">Choose the perfect cake for your celebration from our selection.</p>
// // //                                     <a href="/cakes" className="mt-auto light-text">
// // //                                       View more <i className="fas fa-arrow-right"></i>
// // //                                     </a>
// // //                                   </div>
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           </div>

// // //                           {/* Slide 3 - Cakes */}
// // //                           <div className="carousel-item">
// // //                             <div className="row g-4 justify-content-center">
// // //                               <div className="col-12 col-md-6">
// // //                                 <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                                   <div className="card-body d-flex flex-column align-items-center">
// // //                                     <img
// // //                                       src={screening}
// // //                                       alt="Screening"
// // //                                       className="rounded mb-3"
// // //                                       style={{
// // //                                         height: "200px",
// // //                                         width: "100%",
// // //                                         objectFit: "cover",
// // //                                         border: "2px solid #E9BE5F"
// // //                                       }}
// // //                                     />
// // //                                     <h5 className="card-title light-text">Screening</h5>
// // //                                     <p className="card-text">Bring your OTT accounts and relive the theatre magic!</p>
// // //                                   </div>
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           </div>

// // //                           {/* Slide 4 - Bouquets */}
// // //                           <div className="carousel-item">
// // //                             <div className="row g-4 justify-content-center">
// // //                               <div className="col-12 col-md-6">
// // //                                 <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                                   <div className="card-body d-flex flex-column align-items-center">
// // //                                     <img
// // //                                       src={roses}
// // //                                       alt="Bouquets"
// // //                                       className="rounded mb-3"
// // //                                       style={{
// // //                                         height: "200px",
// // //                                         width: "100%",
// // //                                         objectFit: "cover",
// // //                                         border: "2px solid #E9BE5F"
// // //                                       }}
// // //                                     />
// // //                                     <h5 className="card-title light-text">Bouquets</h5>
// // //                                     <p className="card-text">Add a beautiful rose bouquet to enhance your celebration.</p>
// // //                                   </div>
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           </div>
// // //                         </div>

// // //                         {/* Carousel Controls */}
// // //                         <button className="carousel-control-prev" type="button" data-bs-target="#servicesCarousel" data-bs-slide="prev">
// // //                           <span className="carousel-control-prev-icon" aria-hidden="true" style={{ backgroundColor: '', borderRadius: '50%', padding: '15px' }}></span>
// // //                           <span className="visually-hidden">Previous</span>
// // //                         </button>
// // //                         <button className="carousel-control-next" type="button" data-bs-target="#servicesCarousel" data-bs-slide="next">
// // //                           <span className="carousel-control-next-icon" aria-hidden="true" style={{ backgroundColor: '', borderRadius: '50%', padding: '15px' }}></span>
// // //                           <span className="visually-hidden">Next</span>
// // //                         </button>

// // //                         {/* Carousel Indicators */}
// // //                         <div className="carousel-indicators position-relative mt-3">
// // //                           <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
// // //                           <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="1" aria-label="Slide 2" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
// // //                           <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="2" aria-label="Slide 3" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
// // //                           <button type="button" data-bs-target="#servicesCarousel" data-bs-slide-to="3" aria-label="Slide 4" style={{ backgroundColor: '#800080', width: '10px', height: '10px', borderRadius: '50%', margin: '0 5px' }}></button>
// // //                         </div>
// // //                       </div>

// // //                       {/* Desktop Grid - 4 cards in a row (Visible only on large screens) */}
// // //                       <div className="row g-4 d-none d-xl-flex gradient45 p-3 rounded-3">
// // //                         {/* Service Card 1 */}
// // //                         <div className="col-12 col-sm-6 col-lg-3">
// // //                           <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                             <div className="card-body d-flex flex-column align-items-center">
// // //                               <img
// // //                                 src={beverages}
// // //                                 alt="Food & Beverages"
// // //                                 className="rounded mb-3"
// // //                                 style={{
// // //                                   height: "200px",
// // //                                   width: "100%",
// // //                                   objectFit: "cover",
// // //                                   border: "2px solid #E9BE5F"
// // //                                 }}
// // //                               />
// // //                               <h5 className="card-title light-text">Food & Beverages</h5>
// // //                               <p className="card-text">Choose the perfect food combo for your celebration.</p>
// // //                               <a href="/Food" className="mt-auto light-text">
// // //                                 View more <i className="fas fa-arrow-right"></i>
// // //                               </a>
// // //                             </div>
// // //                           </div>
// // //                         </div>

// // //                         {/* Service Card 2 */}
// // //                         <div className="col-12 col-sm-6 col-lg-3">
// // //                           <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                             <div className="card-body d-flex flex-column align-items-center">
// // //                               <img
// // //                                 src={cake4}
// // //                                 alt="Cakes"
// // //                                 className="rounded mb-3"
// // //                                 style={{
// // //                                   height: "200px",
// // //                                   width: "100%",
// // //                                   objectFit: "cover",
// // //                                   border: "2px solid #E9BE5F"
// // //                                 }}
// // //                               />
// // //                               <h5 className="card-title light-text">Cakes</h5>
// // //                               <p className="card-text">Choose the perfect cake for your celebration from our selection.</p>
// // //                               <a href="/cakes" className="mt-auto light-text">
// // //                                 View more <i className="fas fa-arrow-right"></i>
// // //                               </a>
// // //                             </div>
// // //                           </div>
// // //                         </div>

// // //                         {/* Service Card 3 */}
// // //                         <div className="col-12 col-sm-6 col-lg-3">
// // //                           <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                             <div className="card-body d-flex flex-column align-items-center">
// // //                               <img
// // //                                 src={screening}
// // //                                 alt="Screening"
// // //                                 className="rounded mb-3"
// // //                                 style={{
// // //                                   height: "200px",
// // //                                   width: "100%",
// // //                                   objectFit: "cover",
// // //                                   border: "2px solid #E9BE5F"
// // //                                 }}
// // //                               />
// // //                               <h5 className="card-title light-text">Screening</h5>
// // //                               <p className="card-text">Bring your OTT accounts and relive the theatre magic!</p>
// // //                             </div>
// // //                           </div>
// // //                         </div>

// // //                         {/* Service Card 4 */}
// // //                         <div className="col-12 col-sm-6 col-lg-3">
// // //                           <div className="card h-100 text-center text-dark border-0 rounded-4 shadow-lg p-3 gradient45">
// // //                             <div className="card-body d-flex flex-column align-items-center">
// // //                               <img
// // //                                 src={roses}
// // //                                 alt="Bouquets"
// // //                                 className="rounded mb-3"
// // //                                 style={{
// // //                                   height: "200px",
// // //                                   width: "100%",
// // //                                   objectFit: "cover",
// // //                                   border: "2px solid #E9BE5F"
// // //                                 }}
// // //                               />
// // //                               <h5 className="card-title light-text">Bouquets</h5>
// // //                               <p className="card-text">Add a beautiful rose bouquet to enhance your celebration.</p>
// // //                             </div>
// // //                           </div>
// // //                         </div>
// // //                       </div>
// // //                     </div>
// // //                     <div className="text-center mt-1">
// // //                       <a
// // //                         href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets."
// // //                         target="_blank"
// // //                         rel="noopener noreferrer"
// // //                         className="chat-btn d-inline-flex align-items-center justify-content-center gap-2"
// // //                       >
// // //                         <i className="bi bi-whatsapp"></i>
// // //                         Chat With Us
// // //                       </a>
// // //                     </div>
// // //                   </div>

// // //                   <style jsx>{`

// // //                   .chat-btn {
// // //   background: #25D366;
// // //   color: white;
// // //   font-weight: 600;
// // //   padding: 10px 22px;
// // //   border-radius: 30px;
// // //   text-decoration: none;
// // //   transition: all 0.3s ease;
// // // }

// // // .chat-btn i {
// // //   font-size: 18px;
// // // }

// // // .chat-btn:hover {
// // //   background: #1ebe5d;
// // //   transform: translateY(-2px);
// // //   box-shadow: 0 6px 12px rgba(0,0,0,0.15);
// // // }
// // //     /* Carousel Styles */
// // //     .carousel-control-prev,
// // //     .carousel-control-next {
// // //       width: 40px;
// // //       height: 40px;
// // //       top: 50%;
// // //       transform: translateY(-50%);
// // //       opacity: 1;
// // //     }

// // //     .carousel-control-prev {
// // //       left: -20px;
// // //     }

// // //     .carousel-control-next {
// // //       right: -20px;
// // //     }

// // //     .carousel-indicators {
// // //       bottom: -30px;
// // //     }

// // //     .carousel-indicators button {
// // //       border: none;
// // //     }

// // //     /* Gradient Background for Cards */
// // //     .gradient45 {
// // //       background: linear-gradient(145deg, #ffffff 0%, #f8f8f8 100%);
// // //       transition: transform 0.3s ease, box-shadow 0.3s ease;
// // //     }

// // //     .gradient45:hover {
// // //       transform: translateY(-5px);
// // //       box-shadow: 0 8px 20px rgba(0,0,0,0.15) !important;
// // //     }

// // //     /* Responsive breakpoints */
// // //     @media (max-width: 575px) {
// // //       /* Mobile: 1 card */
// // //       .carousel-control-prev {
// // //         left: -5px;
// // //       }
// // //       .carousel-control-next {
// // //         right: -5px;
// // //       }
// // //       .carousel-control-prev span,
// // //       .carousel-control-next span {
// // //         padding: 8px !important;
// // //       }
// // //       .col-12 {
// // //         max-width: 100%;
// // //         flex: 0 0 100%;
// // //       }
// // //     }

// // //     @media (min-width: 576px) and (max-width: 1199px) {
// // //       /* Tablet/Medium: 2 cards */
// // //       .carousel-control-prev {
// // //         left: -10px;
// // //       }
// // //       .carousel-control-next {
// // //         right: -10px;
// // //       }
// // //       .col-md-6 {
// // //         flex: 0 0 50%;
// // //         max-width: 50%;
// // //       }
// // //     }

// // //     @media (min-width: 1200px) {
// // //       /* Large screens: 4 cards */
// // //       .carousel {
// // //         display: none !important;
// // //       }
// // //       .d-xl-flex {
// // //         display: flex !important;
// // //       }
// // //       .gradient45 {
// // //         min-height: 350px;
// // //       }
// // //     }

// // //     /* Light text color */
// // //     .light-text {
// // //       color: #800080;
// // //       font-weight: 600;
// // //     }

// // //     .light-text:hover {
// // //       color: #40008C;
// // //       text-decoration: underline;
// // //     }

// // //     /* Dark text color */
// // //     .dark-text {
// // //       color: #333;
// // //     }

// // //     /* Card text styling */
// // //     .card-text {
// // //       font-size: 14px;
// // //       color: #666;
// // //       margin: 10px 0;
// // //     }

// // //     .card-title {
// // //       font-size: 18px;
// // //       margin: 10px 0;
// // //     }

// // //     /* Ensure cards have equal height */
// // //     .card.h-100 {
// // //       display: flex;
// // //       flex-direction: column;
// // //     }

// // //     .card-body {
// // //       flex: 1;
// // //     }

// // //     /* Center content on mobile/tablet */
// // //     .justify-content-center {
// // //       justify-content: center !important;
// // //     }
// // //   `}</style>
// // //                 </section>

// // //                 {/* WHY US Section - Premium Design */}
// // //                 <section className="why-us-section position-relative" style={{
// // //                   background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
// // //                   padding: '80px 0',
// // //                   overflow: 'hidden'
// // //                 }}>
// // //                   {/* Decorative Background Elements */}
// // //                   <div className="position-absolute" style={{
// // //                     top: '-50px',
// // //                     right: '-50px',
// // //                     width: '200px',
// // //                     height: '200px',
// // //                     background: 'radial-gradient(circle, rgba(104,29,192,0.05) 0%, rgba(104,29,192,0) 70%)',
// // //                     borderRadius: '50%',
// // //                     zIndex: 0
// // //                   }}></div>
// // //                   <div className="position-absolute" style={{
// // //                     bottom: '-30px',
// // //                     left: '-30px',
// // //                     width: '150px',
// // //                     height: '150px',
// // //                     background: 'radial-gradient(circle, rgba(255,193,7,0.05) 0%, rgba(255,193,7,0) 70%)',
// // //                     borderRadius: '50%',
// // //                     zIndex: 0
// // //                   }}></div>

// // //                   <Container className="position-relative" style={{ zIndex: 2 }}>
// // //                     {/* Section Header with Premium Styling */}
// // //                     <div className="text-center mb-5">
// // //                       {/* <span className="badge bg-warning bg-opacity-15 text-warning px-4 py-2 mb-3 rounded-pill fw-semibold"
// // //                         style={{
// // //                           background: 'rgba(255, 193, 7, 0.15)',
// // //                           letterSpacing: '1px',
// // //                           fontSize: '0.9rem'
// // //                         }}>
// // //                         WHY CHOOSE US
// // //                       </span> */}
// // //                       <h3 className="display-4 fw-bold" style={{
// // //                         color: '#1a1a1a',
// // //                         fontSize: 'clamp(2rem, 5vw, 3.5rem)',
// // //                         lineHeight: '1.2'
// // //                       }}>
// // //                         Plan a Suprise to your <span style={{ color: '#681DC0' }}>Loved one</span>
// // //                       </h3>
// // //                       {/* <p className="text-secondary mt-3" style={{
// // //                         fontSize: 'clamp(1rem, 2vw, 1.2rem)',
// // //                         maxWidth: '700px',
// // //                         margin: '0 auto'
// // //                       }}>
// // //                         Discover what makes us the preferred choice for unforgettable moments
// // //                       </p> */}
// // //                     </div>

// // //                     {/* Main Content Card with Premium Design */}
// // //                     <div className="why-us-card position-relative gradient45" style={{
// // //                       // background: 'rgba(255, 255, 255, 0.95)',
// // //                       backdropFilter: 'blur(10px)',
// // //                       borderRadius: '40px',
// // //                       padding: 'clamp(30px, 5vw, 60px)',
// // //                       boxShadow: '0 30px 60px rgba(0,0,0,0.1), 0 10px 30px rgba(104,29,192,0.1)',
// // //                       border: '1px solid rgba(255,255,255,0.5)',
// // //                       transition: 'all 0.3s ease'
// // //                     }}>

// // //                       {/* Current Slide Content */}
// // //                       <div className="slide-content">
// // //                         <Row className="align-items-center g-5">
// // //                           {/* Left Side - Image with Premium Effects */}
// // //                           <Col lg={6} className="text-center text-lg-start">
// // //                             <div className="position-relative">
// // //                               {/* Image with gradient overlay */}
// // //                               <div className="image-wrapper position-relative" style={{
// // //                                 borderRadius: '30px',
// // //                                 overflow: 'hidden',
// // //                                 boxShadow: '0 20px 40px rgba(104,29,192,0.2)',
// // //                                 transform: 'perspective(1000px) rotateY(-2deg)',
// // //                                 transition: 'transform 0.5s ease'
// // //                               }}>
// // //                                 <img
// // //                                   src={whyUsSlides[index].image}
// // //                                   alt="Premium Experience"
// // //                                   className="img-fluid w-100"
// // //                                   style={{
// // //                                     height: 'clamp(300px, 40vw, 500px)',
// // //                                     objectFit: 'cover',
// // //                                     transition: 'transform 0.5s ease'
// // //                                   }}
// // //                                 />
// // //                                 {/* Gradient Overlay */}
// // //                                 <div className="position-absolute top-0 start-0 w-100 h-100" style={{
// // //                                   background: 'linear-gradient(45deg, rgba(104,29,192,0.2) 0%, rgba(255,193,7,0.2) 100%)',
// // //                                   mixBlendMode: 'overlay'
// // //                                 }}></div>
// // //                               </div>

// // //                               {/* Decorative Elements */}
// // //                               <div className="position-absolute" style={{
// // //                                 bottom: '-20px',
// // //                                 right: '-20px',
// // //                                 width: '80px',
// // //                                 height: '80px',
// // //                                 background: 'linear-gradient(135deg, #681DC0, #ffc107)',
// // //                                 borderRadius: '20px',
// // //                                 transform: 'rotate(45deg)',
// // //                                 zIndex: -1,
// // //                                 opacity: 0.3
// // //                               }}></div>
// // //                             </div>
// // //                           </Col>

// // //                           {/* Right Side - Text Content */}
// // //                           <Col lg={6}>
// // //                             <div className="ps-lg-4">
// // //                               {/* Title with Animation */}
// // //                               <h3 className="fw-bold mb-4" style={{
// // //                                 color: '#4a4242',
// // //                                 position: 'relative',
// // //                                 paddingBottom: '15px'
// // //                               }}>
// // //                                 {whyUsSlides[index].subtitle}
// // //                                 <span style={{
// // //                                   position: 'absolute',
// // //                                   bottom: 0,
// // //                                   left: 0,
// // //                                   width: '80px',
// // //                                   height: '4px',
// // //                                   background: 'linear-gradient(90deg, #681DC0, #ffc107)',
// // //                                   borderRadius: '2px'
// // //                                 }}></span>
// // //                               </h3>

// // //                               {/* Points with Icons */}
// // //                               <ul className="list-unstyled mt-4">
// // //                                 {whyUsSlides[index].points.map((point, i) => (
// // //                                   <li key={i} className="mb-4 d-flex align-items-start">
// // //                                     <div className="me-3" style={{
// // //                                       width: '32px',
// // //                                       height: '32px',
// // //                                       background: 'linear-gradient(135deg, rgba(104,29,192,0.1), rgba(255,193,7,0.1))',
// // //                                       borderRadius: '10px',
// // //                                       display: 'flex',
// // //                                       alignItems: 'center',
// // //                                       justifyContent: 'center',
// // //                                       color: '#681DC0'
// // //                                     }}>
// // //                                       <i className="fas fa-check-circle" style={{ fontSize: '1.2rem' }}></i>
// // //                                     </div>
// // //                                     <div>
// // //                                       <span style={{
// // //                                         fontSize: 'clamp(1rem, 2vw, 1.1rem)',
// // //                                         color: '#4a4a4a',
// // //                                         lineHeight: '1.6'
// // //                                       }}>
// // //                                         {point}
// // //                                       </span>
// // //                                     </div>
// // //                                   </li>
// // //                                 ))}
// // //                               </ul>

// // //                               {/* CTA Button with Premium Style */}
// // //                               <div className="mt-5 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 px-3">

// // //                                 {/* Book Button */}
// // //                                 <Button
// // //                                   onClick={() => window.location.href = "/locations"}
// // //                                   className="responsive-btn position-relative overflow-hidden"
// // //                                 >
// // //                                   <i className="fas fa-ticket-alt me-2"></i>
// // //                                   Book Your Experience
// // //                                 </Button>

// // //                                 {/* WhatsApp Button */}
// // //                                 <a
// // //                                   href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets."
// // //                                   target="_blank"
// // //                                   rel="noopener noreferrer"
// // //                                   className="responsive-btn whatsapp-btn text-center text-decoration-none"
// // //                                 >
// // //                                   <i className="bi bi-whatsapp me-2"></i>
// // //                                  Chat With Us
// // //                                 </a>

// // //                               </div>
// // //                             </div>
// // //                           </Col>
// // //                         </Row>
// // //                       </div>

// // //                       {/* Navigation Controls - Premium Design */}
// // //                       <div className="navigation-controls d-flex justify-content-between align-items-center mt-5 pt-4">
// // //                         {/* Arrow Navigation */}
// // //                         {/* <div className="d-flex gap-3">
// // //                           <button
// // //                             onClick={() => handleSelect(index === 0 ? whyUsSlides.length - 1 : index - 1)}
// // //                             className="nav-arrow prev-arrow"
// // //                             style={{
// // //                               width: '50px',
// // //                               height: '50px',
// // //                               borderRadius: '15px',
// // //                               background: '#fff',
// // //                               border: '1px solid rgba(104,29,192,0.2)',
// // //                               color: '#681DC0',
// // //                               display: 'flex',
// // //                               alignItems: 'center',
// // //                               justifyContent: 'center',
// // //                               fontSize: '1.2rem',
// // //                               cursor: 'pointer',
// // //                               transition: 'all 0.3s ease',
// // //                               boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
// // //                             }}
// // //                             onMouseEnter={(e) => {
// // //                               e.target.style.background = '#681DC0';
// // //                               e.target.style.color = '#fff';
// // //                               e.target.style.transform = 'scale(1.05)';
// // //                             }}
// // //                             onMouseLeave={(e) => {
// // //                               e.target.style.background = '#fff';
// // //                               e.target.style.color = '#681DC0';
// // //                               e.target.style.transform = 'scale(1)';
// // //                             }}
// // //                           >
// // //                             <i className="fas fa-arrow-left"></i>
// // //                           </button>
// // //                           <button
// // //                             onClick={() => handleSelect(index === whyUsSlides.length - 1 ? 0 : index + 1)}
// // //                             className="nav-arrow next-arrow"
// // //                             style={{
// // //                               width: '50px',
// // //                               height: '50px',
// // //                               borderRadius: '15px',
// // //                               background: '#fff',
// // //                               border: '1px solid rgba(104,29,192,0.2)',
// // //                               color: '#681DC0',
// // //                               display: 'flex',
// // //                               alignItems: 'center',
// // //                               justifyContent: 'center',
// // //                               fontSize: '1.2rem',
// // //                               cursor: 'pointer',
// // //                               transition: 'all 0.3s ease',
// // //                               boxShadow: '0 5px 15px rgba(0,0,0,0.05)'
// // //                             }}
// // //                             onMouseEnter={(e) => {
// // //                               e.target.style.background = '#681DC0';
// // //                               e.target.style.color = '#fff';
// // //                               e.target.style.transform = 'scale(1.05)';
// // //                             }}
// // //                             onMouseLeave={(e) => {
// // //                               e.target.style.background = '#fff';
// // //                               e.target.style.color = '#681DC0';
// // //                               e.target.style.transform = 'scale(1)';
// // //                             }}
// // //                           >
// // //                             <i className="fas fa-arrow-right"></i>
// // //                           </button>
// // //                         </div> */}

// // //                         {/* Slide Indicators */}
// // //                         <div className="d-flex gap-2">
// // //                           {whyUsSlides.map((_, i) => (
// // //                             <button
// // //                               key={i}
// // //                               onClick={() => handleSelect(i)}
// // //                               className="slide-indicator"
// // //                               style={{
// // //                                 width: i === index ? '40px' : '12px',
// // //                                 height: '12px',
// // //                                 borderRadius: '20px',
// // //                                 border: 'none',
// // //                                 background: i === index
// // //                                   ? 'linear-gradient(90deg, #681DC0, #ffc107)'
// // //                                   : 'rgba(104,29,192,0.2)',
// // //                                 cursor: 'pointer',
// // //                                 transition: 'all 0.3s ease',
// // //                                 boxShadow: i === index ? '0 5px 15px rgba(104,29,192,0.3)' : 'none'
// // //                               }}
// // //                               onMouseEnter={(e) => {
// // //                                 if (i !== index) {
// // //                                   e.target.style.background = 'rgba(104,29,192,0.4)';
// // //                                 }
// // //                               }}
// // //                               onMouseLeave={(e) => {
// // //                                 if (i !== index) {
// // //                                   e.target.style.background = 'rgba(104,29,192,0.2)';
// // //                                 }
// // //                               }}
// // //                             />
// // //                           ))}
// // //                         </div>

// // //                         {/* Slide Counter */}
// // //                         {/* <div className="slide-counter" style={{
// // //                           background: 'rgba(104,29,192,0.05)',
// // //                           padding: '8px 20px',
// // //                           borderRadius: '50px',
// // //                           color: '#681DC0',
// // //                           fontWeight: '600',
// // //                           fontSize: '1rem',
// // //                           letterSpacing: '1px'
// // //                         }}>
// // //                           <span style={{ fontSize: '1.3rem', fontWeight: '700' }}>{String(index + 1).padStart(2, '0')}</span>
// // //                           <span style={{ color: '#999', margin: '0 5px' }}>/</span>
// // //                           <span style={{ color: '#999' }}>{String(whyUsSlides.length).padStart(2, '0')}</span>
// // //                         </div> */}
// // //                       </div>
// // //                     </div>
// // //                   </Container>

// // //                   {/* Premium Responsive Styles */}
// // //                   <style jsx>{`
// // //                       .why-us-section {
// // //                         min-height: 70vh;
// // //                         display: flex;
// // //                         align-items: center;
// // //                       }

// // //                       /* Tablet Styles */
// // //                       @media (max-width: 991px) {
// // //                         .why-us-section {
// // //                           padding: 60px 0;
// // //                         }

// // //                         .why-us-section .why-us-card {
// // //                           padding: 30px !important;
// // //                         }

// // //                         .why-us-section .navigation-controls {
// // //                           flex-wrap: wrap;
// // //                           gap: 20px;
// // //                           justify-content: center !important;
// // //                         }

// // //                         .why-us-section .slide-counter {
// // //                           order: 1;
// // //                         }

// // //                         .why-us-section .d-flex.gap-3 {
// // //                           order: 2;
// // //                         }

// // //                         .why-us-section .d-flex.gap-2 {
// // //                           order: 3;
// // //                         }
// // //                       }

// // //                       /* Mobile Styles */
// // //                       @media (max-width: 576px) {
// // //                         .why-us-section {
// // //                           padding: 40px 0;
// // //                         }

// // //                         .why-us-section .why-us-card {
// // //                           padding: 20px !important;
// // //                           border-radius: 30px !important;
// // //                         }

// // //                         .why-us-section .image-wrapper {
// // //                           transform: none !important;
// // //                           box-shadow: 0 15px 30px rgba(104,29,192,0.15) !important;
// // //                         }

// // //                         .why-us-section .nav-arrow {
// // //                           width: 45px !important;
// // //                           height: 45px !important;
// // //                           border-radius: 12px !important;
// // //                         }

// // //                         .why-us-section .slide-indicator {
// // //                           height: 10px !important;
// // //                         }

// // //                         .why-us-section .slide-indicator[style*="width: 40px"] {
// // //                           width: 30px !important;
// // //                         }

// // //                         .why-us-section .badge {
// // //                           font-size: 0.8rem !important;
// // //                           padding: 6px 16px !important;
// // //                         }

// // //                         .why-us-section button {
// // //                           width: 100%;
// // //                           padding: 14px 20px !important;
// // //                           font-size: 1rem !important;
// // //                         }
// // //                       }

// // //                       /* Small Mobile Styles */
// // //                       @media (max-width: 375px) {
// // //                         .why-us-section .why-us-card {
// // //                           padding: 15px !important;
// // //                         }

// // //                         .why-us-section h3 {
// // //                           font-size: 1.3rem !important;
// // //                         }

// // //                         .why-us-section .navigation-controls {
// // //                           flex-direction: column;
// // //                         }
// // //                       }

// // //                       /* Hover Effects for Desktop */
// // //                       @media (min-width: 992px) {
// // //                         .why-us-section .image-wrapper:hover {
// // //                           transform: perspective(1000px) rotateY(-4deg) scale(1.02) !important;
// // //                         }

// // //                         .why-us-section .why-us-card:hover {
// // //                           box-shadow: 0 40px 80px rgba(104,29,192,0.15) !important;
// // //                         }
// // //                       }

// // //                       .responsive-btn {
// // //                       max-width: 420px;
// // //                       padding: 16px 28px;
// // //                       font-size: 1rem;
// // //                       font-weight: 600;
// // //                       border-radius: 50px;
// // //                       text-transform: uppercase;
// // //                       letter-spacing: 1px;
// // //                       transition: all 0.3s ease;
// // //                     }

// // //                     /* Book Button */
// // //                     .responsive-btn.btn {
// // //                       background: linear-gradient(135deg, #681DC0, #8a4fe3);
// // //                       border: none;
// // //                       color: white;
// // //                       box-shadow: 0 10px 20px rgba(104,29,192,0.3);
// // //                     }

// // //                     .responsive-btn.btn:hover {
// // //                       transform: translateY(-2px);
// // //                       box-shadow: 0 15px 30px rgba(104,29,192,0.4);
// // //                     }

// // //                     /* WhatsApp Button */
// // //                     .whatsapp-btn {
// // //                       background: #25D366;
// // //                       color: white;
// // //                       box-shadow: 0 10px 20px rgba(37,211,102,0.35);
// // //                     }

// // //                     .whatsapp-btn:hover {
// // //                       transform: translateY(-2px);
// // //                       box-shadow: 0 15px 30px rgba(37,211,102,0.45);
// // //                     }

// // //                     /* Mobile */
// // //                     @media (max-width: 576px) {
// // //                       .responsive-btn {
// // //                         font-size: 0.9rem;
// // //                         padding: 14px 20px;
// // //                       }
// // //                     }
// // //                     `}</style>
// // //                 </section>

// // //                 {slides && slides.length > 0 && (
// // //                   <section className="py-5 bg-white position-relative">
// // //                     <Container>
// // //                       <h2 className="text-center fw-bold mb-3 dark-text">
// // //                         What Our Customers Say
// // //                       </h2>

// // //                       <p className="text-center mb-5 fs-5 light-text">
// // //                         Real stories. Real celebrations. Real magic at Carnival Castle.
// // //                       </p>

// // //                       <Carousel controls interval={5000} pause="hover" fade={false} wrap>
// // //                         {slides.map((group, idx) => (
// // //                           <Carousel.Item key={idx}>
// // //                             <Row className="g-4 justify-content-center">
// // //                               {group.map((review, index) => (
// // //                                 <Col lg={4} md={6} sm={12} key={index}>
// // //                                   <div
// // //                                     className="review-card position-relative rounded-4 overflow-hidden shadow mb-4"
// // //                                     style={{ height: "400px" }}
// // //                                   >
// // //                                     <img
// // //                                       src={review.image}
// // //                                       alt="Review background"
// // //                                       className="w-100 h-100 object-fit-cover"
// // //                                       style={{ filter: "brightness(70%)" }}
// // //                                     />

// // //                                     {/* Bottom overlay card */}
// // //                                     <div
// // //                                       className="position-absolute bottom-0 start-50 translate-middle-x p-4 rounded-top-4"
// // //                                       style={{
// // //                                         height: "auto",
// // //                                         minHeight: "45%",
// // //                                         width: "90%",
// // //                                         backgroundColor: "rgba(233, 220, 255, 0.95)",
// // //                                         backdropFilter: "blur(4px)",
// // //                                       }}
// // //                                     >
// // //                                       <div className="d-flex align-items-center mb-3">
// // //                                         <img
// // //                                           src={review.avatar}
// // //                                           alt="avatar"
// // //                                           className="rounded-circle me-3 border-2 border-light"
// // //                                           width="60"
// // //                                           height="60"
// // //                                         />
// // //                                         <div>
// // //                                           <h6 className="mb-0 fw-bold text-dark">
// // //                                             {review.name}
// // //                                           </h6>
// // //                                           <small className="text-dark">
// // //                                             {review.location}
// // //                                           </small>
// // //                                         </div>
// // //                                       </div>

// // //                                       <div className="text-warning mb-2 fs-5">
// // //                                         {"★".repeat(review.rating)}
// // //                                         {"☆".repeat(5 - review.rating)}
// // //                                       </div>

// // //                                       <p
// // //                                         className="mb-2 text-dark"
// // //                                         style={{ fontSize: "0.9rem" }}
// // //                                       >
// // //                                         {review.description}
// // //                                       </p>

// // //                                       {review.occasion && (
// // //                                         <p
// // //                                           className="mb-0 text-dark"
// // //                                           style={{ fontSize: "0.85rem" }}
// // //                                         >
// // //                                           <strong>Occasion:</strong> {review.occasion}
// // //                                         </p>
// // //                                       )}
// // //                                     </div>
// // //                                   </div>
// // //                                 </Col>
// // //                               ))}
// // //                             </Row>
// // //                           </Carousel.Item>
// // //                         ))}
// // //                       </Carousel>
// // //                     </Container>
// // //                   </section>
// // //                 )}



// // //                 {/* Gallery */}
// // //                 <section className="pb-3 gradient45">
// // //                   <div className="container-md">
// // //                     <div className="section-wraper row d-flex align-items-center justify-content-center">
// // //                       <div className="col-md-12 section-header mb-0 mt-3">
// // //                         <h2 className="text-center fw-bold mb-3 dark-text">Gallery</h2>
// // //                         <p className="text-center mb-5 fs-5 light-text">See how our guests made memories at Carnival Castle.</p>
// // //                       </div>

// // //                       <div className="row align-items-center justify-content-center">
// // //                         <div className="container-md">
// // //                           <div>
// // //                             <Galleria
// // //                               ref={galleria}
// // //                               value={images}
// // //                               numVisible={7}
// // //                               style={{ maxWidth: "850px" }}
// // //                               activeIndex={activeIndex}
// // //                               onItemChange={(e) => setActiveIndex(e.index)}
// // //                               circular
// // //                               fullScreen
// // //                               showItemNavigators
// // //                               showThumbnails={false}
// // //                               item={itemTemplate}
// // //                               thumbnail={thumbnailTemplate}
// // //                             />
// // //                             <div>
// // //                               <div className="row mb-2">
// // //                                 {images.map((image, index) => {
// // //                                   return (
// // //                                     <div
// // //                                       className="col-lg-4 col-md-4 col-sm-6 col-12 mt-3 mb-4"
// // //                                       key={index}
// // //                                     >
// // //                                       <div
// // //                                         className="zoom-container gallery-img-wrapper"
// // //                                         style={{ cursor: "pointer" }}
// // //                                         onClick={() => {
// // //                                           setActiveIndex(index);
// // //                                           galleria.current.show();
// // //                                         }}
// // //                                       >
// // //                                         <img
// // //                                           src={URLS.Base + image.image}
// // //                                           alt={image.alt}
// // //                                           className="img-fluid gallery-img"
// // //                                         />

// // //                                         {/* Zoom Icon */}
// // //                                         <span className="zoom-icon">
// // //                                           <i className="fas fa-search-plus"></i>
// // //                                         </span>
// // //                                       </div>
// // //                                     </div>
// // //                                   );
// // //                                 })}
// // //                               </div>
// // //                             </div>
// // //                           </div>
// // //                         </div>
// // //                       </div>

// // //                       {/* View All Button - Centered at Bottom */}
// // //                       <div className="col-md-12 text-center mt-3 mb-4 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">

// // //                         {/* View Gallery Button */}
// // //                         <a
// // //                           href="/gallery"
// // //                           className="btn light-back fw-bold dark-back responsive-btn"
// // //                         >
// // //                           View Gallery <i className="bi bi-arrow-right ms-2"></i>
// // //                         </a>

// // //                         {/* WhatsApp Button */}
// // //                         <a
// // //                           href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets."
// // //                           target="_blank"
// // //                           rel="noopener noreferrer"
// // //                           className="btn whatsapp-btn fw-bold responsive-btn"
// // //                         >
// // //                           <i className="bi bi-whatsapp me-2"></i>
// // //                          Chat With Us
// // //                         </a>

// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                   <style>
// // //                     {`
// // //                     .gallery-img-wrapper{
// // //                       width:100%;
// // //                       height:400px;
// // //                       overflow:hidden;
// // //                       position:relative;
// // //                       border:1px solid #F5E7B6;
// // //                     }

// // //                     .gallery-img{
// // //                       width:100%;
// // //                       height:100%;
// // //                       object-fit:cover;
// // //                       transition:transform 0.4s ease;
// // //                     }

// // //                     .gallery-img-wrapper:hover .gallery-img{
// // //                       transform:scale(1.08);
// // //                     }

// // //                     /* Zoom Icon */
// // //                     .zoom-icon{
// // //                       position:absolute;
// // //                       top:50%;
// // //                       left:50%;
// // //                       transform:translate(-50%,-50%);
// // //                       background:rgba(0,0,0,0.5);
// // //                       color:#fff;
// // //                       padding:10px 12px;
// // //                       border-radius:50%;
// // //                       opacity:0;
// // //                       transition:0.3s;
// // //                     }

// // //                     .gallery-img-wrapper:hover .zoom-icon{
// // //                       opacity:1;
// // //                     }
// // //                     .responsive-btn {
// // //                       padding: 12px 26px;
// // //                       border-radius: 40px;
// // //                       font-size: 0.95rem;
// // //                       letter-spacing: 0.5px;
// // //                     }

// // //                     .whatsapp-btn {
// // //                       background: #25D366 !important;
// // //                       color: #fff;
// // //                       border: none;
// // //                     }

// // //                     .whatsapp-btn:hover {
// // //                       background: #1ebe5d;
// // //                       color: #fff;
// // //                     }
// // //                     `}
// // //                   </style>
// // //                 </section>


// // //                 {/* <section className="py-5 bg-light">
// // //                   <div className="container">
// // //                     <div className="text-center mb-5">
// // //                       <h2 className="display-5 fw-bold dark-text">Our Packages</h2>
// // //                       <p className="fs-5 light-text">
// // //                         <i>Choose Wisely</i>
// // //                       </p>
// // //                     </div>


// // //                     <div className="row g-4 justify-content-center d-none d-md-flex">
// // //                       {packages.map((pkg) => (
// // //                         <div className="col-xl-3 col-lg-4 col-md-6 col-sm-10" key={pkg.id}>
// // //                           <div className="card border-0 shadow rounded-4 h-100 text-center gradient45 position-relative">
// // //                             <div className="card-body d-flex flex-column p-4">

// // //                               <div className="mb-3">
// // //                                 <h4 className="fw-bold mb-1">{pkg.title}</h4>
// // //                                 <p
// // //                                   className="text-muted mb-0"
// // //                                   style={{ fontStyle: "italic", fontSize: "14px" }}
// // //                                 >
// // //                                   {pkg.subtitle}
// // //                                 </p>
// // //                               </div>


// // //                               <ul className="list-unstyled text-start flex-grow-1 mb-0 px-2">
// // //                                 {(showMore
// // //                                   ? Object.keys(pkg.detailedFeatures).slice(0, 7)
// // //                                   : Object.keys(pkg.detailedFeatures)
// // //                                 ).map((feature, idx) => (
// // //                                   <li key={idx} className="d-flex align-items-center mb-2">
// // //                                     <span
// // //                                       className={`me-2 fw-bold ${pkg.detailedFeatures[feature] ? "text-success" : "text-danger"
// // //                                         }`}
// // //                                     >
// // //                                       {pkg.detailedFeatures[feature] ? "✅" : "❌"}
// // //                                     </span>
// // //                                     <span className="text-dark">{feature}</span>
// // //                                   </li>
// // //                                 ))}
// // //                               </ul>


// // //                               {Object.keys(pkg.detailedFeatures).length > 7 && (
// // //                                 <button
// // //                                   className="btn btn-link p-0 my-1 fw-bold"
// // //                                   onClick={() => setShowMore(!showMore)}
// // //                                 >
// // //                                   {showMore[pkg.id]
// // //                                     ? "View Less"
// // //                                     : `View More`}
// // //                                 </button>
// // //                               )}



// // //                               {pkg?.price ? (
// // //                                 <p className="fw-semibold mb-4 mt-auto">
// // //                                   Starts from ₹{pkg.price}
// // //                                 </p>
// // //                               ) : null}


// // //                               <button
// // //                                 className="btn text-white w-100"
// // //                                 style={{ backgroundColor: "#a259ff", borderRadius: "10px" }}
// // //                                 onClick={() => navigateTheater("/locations")}
// // //                               >
// // //                                 {pkg.buttonText}
// // //                               </button>
// // //                             </div>
// // //                           </div>
// // //                         </div>
// // //                       ))}
// // //                     </div>


// // //                     <div
// // //                       id="packagesCarousel"
// // //                       className=" slide d-block d-md-none"
// // //                       data-bs-ride="carousel"
// // //                       data-bs-interval="3000"
// // //                       data-bs-wrap="true"
// // //                       data-bs-pause="false"
// // //                     >

// // //                       <div className="carousel-indicators">
// // //                         {packages.map((_, index) => (
// // //                           <button
// // //                             key={index}
// // //                             type="button"
// // //                             data-bs-target="#packagesCarousel"
// // //                             data-bs-slide-to={index}
// // //                             className={index === 0 ? "active" : ""}
// // //                             aria-current={index === 0 ? "true" : "false"}
// // //                             aria-label={`Slide ${index + 1}`}
// // //                           ></button>
// // //                         ))}
// // //                       </div>


// // //                       <div className="carousel-inner">
// // //                         {packages.map((pkg, index) => (
// // //                           <div
// // //                             className={`carousel-item ${index === 0 ? "active" : ""}`}
// // //                             key={pkg.id}
// // //                           >
// // //                             <div className="d-flex justify-content-center">
// // //                               <div className="col-10">
// // //                                 <div className="card border-0 shadow rounded-4 text-center gradient45">
// // //                                   <div className="card-body d-flex flex-column p-4">

// // //                                     <div className="mb-3">
// // //                                       <h4 className="fw-bold mb-1">{pkg.title}</h4>
// // //                                       <p
// // //                                         className="text-muted mb-0"
// // //                                         style={{ fontStyle: "italic", fontSize: "14px" }}
// // //                                       >
// // //                                         {pkg.subtitle}
// // //                                       </p>
// // //                                     </div>


// // //                                     <ul className="list-unstyled text-start flex-grow-1 mb-1 px-2">
// // //                                       {Object.keys(pkg.detailedFeatures).map((feature, idx) => (
// // //                                         <li key={idx} className="d-flex align-items-center mb-2">
// // //                                           <span
// // //                                             className={`me-2 fw-bold ${pkg.detailedFeatures[feature] ? "text-success" : "text-danger"
// // //                                               }`}
// // //                                           >
// // //                                             {pkg.detailedFeatures[feature] ? "✅" : "❌"}
// // //                                           </span>
// // //                                           <span className="text-dark">{feature}</span>
// // //                                         </li>
// // //                                       ))}
// // //                                     </ul>


// // //                                     {pkg?.price ? (
// // //                                       <p className="fw-semibold mb-4 mt-auto">
// // //                                         Starts from ₹{pkg.price}
// // //                                       </p>
// // //                                     ) : null}


// // //                                     <button
// // //                                       className="btn text-white w-100"
// // //                                       style={{ backgroundColor: "#a259ff", borderRadius: "10px" }}
// // //                                       onClick={() => navigateTheater("/locations")}
// // //                                     >
// // //                                       {pkg.buttonText}
// // //                                     </button>
// // //                                   </div>
// // //                                 </div>
// // //                               </div>
// // //                             </div>
// // //                           </div>
// // //                         ))}
// // //                       </div>


// // //                       <button
// // //                         className="carousel-control-prev"
// // //                         type="button"
// // //                         data-bs-target="#packagesCarousel"
// // //                         data-bs-slide="prev"
// // //                       >
// // //                         <span className="carousel-control-prev-icon" aria-hidden="true"></span>
// // //                         <span className="visually-hidden">Previous</span>
// // //                       </button>
// // //                       <button
// // //                         className="carousel-control-next"
// // //                         type="button"
// // //                         data-bs-target="#packagesCarousel"
// // //                         data-bs-slide="next"
// // //                       >
// // //                         <span className="carousel-control-next-icon" aria-hidden="true"></span>
// // //                         <span className="visually-hidden">Next</span>
// // //                       </button>
// // //                     </div>
// // //                   </div>
// // //                 </section> */}

// // //                 <HomePackagesSection navigateTheater={navigate} />



// // //                 <section className="py-5 bg-white">
// // //                   <div className="container">
// // //                     <div className="row justify-content-between align-items-center rounded-4 p-4 shadow lighter-back">
// // //                       {/* Text Column */}
// // //                       <div className="col-12 col-md-8 mb-3 mb-md-0">
// // //                         <h4 className="fw-bold dark-text mb-2">Follow Our Journey on Instagram</h4>
// // //                         <p className="text-muted m-0">Get inspired by our latest creations and behind-the-scenes moments.</p>
// // //                       </div>

// // //                       {/* Button Column */}
// // //                       <div className="col-12 col-md-4 text-md-end">
// // //                         <a
// // //                           href="https://www.instagram.com/accounts/login/?next=%2Fcarnival_castle_hyderabad%2F&source=omni_redirect"
// // //                           target="_blank"
// // //                           rel="noopener noreferrer"
// // //                           className="d-inline-flex align-items-center gap-2 px-4 py-2 rounded-pill text-decoration-none fw-semibold"
// // //                           style={{
// // //                             background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
// // //                             color: "#fff",
// // //                             boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
// // //                           }}
// // //                         >
// // //                           <i className="fab fa-instagram"></i> carnival_castle_hyderabad
// // //                         </a>
// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 </section>



// // //                 <CouponSection />


// // //                 {/* <section className="py-5 position-relative text-dark" style={{ backgroundColor: "#E6D8F5" }}>
// // //                   <Container fluid="lg">
// // //                     <Row className="align-items-center">

// // //                       <Col lg={3} className="text-center text-lg-start mb-4 mb-lg-0">
// // //                         <h2 className="fw-bold mt-3 dark-text">Our Theatres</h2>
// // //                         <p className="light-text fs-6">
// // //                           Real stories. Real celebrations. Real magic at Carnival Castle.
// // //                         </p>
// // //                       </Col>


// // //                       <Col lg={9}>
// // //                         <div className="d-flex align-items-center justify-content-center overflow-auto gap-3">

// // //                           {testimonials
// // //                             .filter((item) => item.videoId !== selected.videoId)
// // //                             .map((user, idx) => (
// // //                               <div
// // //                                 key={idx}
// // //                                 className="side-card d-flex align-items-center justify-content-center rounded shadow"
// // //                                 style={{
// // //                                   width: "80px",
// // //                                   height: "280px",
// // //                                   backgroundImage: `url(${user.thumbnail})`,
// // //                                   backgroundSize: "cover",
// // //                                   backgroundPosition: "center",
// // //                                   cursor: "pointer",
// // //                                   position: "relative",
// // //                                 }}
// // //                                 onClick={() => setSelected(user)}
// // //                               >
// // //                                 <h6 className="vertical-text text-white fw-bold m-0">{user.name}</h6>
// // //                                 <div className="overlay"></div>
// // //                               </div>
// // //                             ))}


// // //                           <div
// // //                             className="main-video-card position-relative rounded shadow overflow-hidden"
// // //                             style={{
// // //                               width: "300px",
// // //                               height: "400px",
// // //                               backgroundColor: "#000",
// // //                             }}
// // //                           >
// // //                             <iframe
// // //                               width="100%"
// // //                               height="80%"
// // //                               src={`https://www.youtube.com/embed/${selected.videoId}?autoplay=1&mute=1`}
// // //                               title={selected.name}
// // //                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
// // //                               allowFullScreen
// // //                             ></iframe>


// // //                             <div className="position-absolute bottom-0 start-0 end-0 p-3">
// // //                               <div className="bg-white d-inline-block px-3 py-2 rounded-4 w-100 shadow-sm">
// // //                                 <strong className="dark-text">{selected.name}</strong><br />
// // //                                 <small className="text-dark">{selected.role}</small>
// // //                               </div>
// // //                             </div>
// // //                           </div>
// // //                         </div>
// // //                       </Col>
// // //                     </Row>
// // //                   </Container>


// // //                   <style jsx>{`
// // //         .side-card {
// // //           position: relative;
// // //           overflow: hidden;
// // //         }

// // //         .vertical-text {
// // //           writing-mode: vertical-rl;
// // //           text-orientation: mixed;
// // //           transform: rotate(180deg);
// // //           font-size: 1rem;
// // //           z-index: 2;
// // //         }

// // //         .overlay {
// // //           position: absolute;
// // //           top: 0;
// // //           left: 0;
// // //           right: 0;
// // //           bottom: 0;
// // //           background: rgba(0, 0, 0, 0.4);
// // //           z-index: 1;
// // //         }

// // //         .main-video-card iframe {
// // //           border: none;
// // //         }
// // //       `}</style>
// // //                 </section> */}



// // //                 {/* FAQS */}
// // //                 <section className="pb-3 bg-white">
// // //                   <div className="container">
// // //                     <div className="section-wraper row d-flex align-items-center">

// // //                       <div className="row justify-content-center">
// // //                         <div className="col-xl-6 col-lg-8">
// // //                           <div className="section-title text-center mb-5 pt-3">
// // //                             <h2 className="dark-text">
// // //                               Frequently Asked Questions
// // //                             </h2>
// // //                           </div>
// // //                         </div>
// // //                       </div>

// // //                       <div className="row justify-content-center">
// // //                         <div className="col-md-8">

// // //                           <Accordion defaultActiveKey="0">
// // //                             {(showAllFaqs ? Faqs : Faqs?.slice(0, 4))?.map((data, i) => (
// // //                               <Accordion.Item
// // //                                 className="mt-3"
// // //                                 eventKey={i.toString()}
// // //                                 key={i}
// // //                                 style={{ background: "white" }}
// // //                               >
// // //                                 <Accordion.Header>
// // //                                   <b>
// // //                                     {i + 1}. {data.question}
// // //                                   </b>
// // //                                 </Accordion.Header>

// // //                                 <Accordion.Body>
// // //                                   {data.answer}
// // //                                 </Accordion.Body>
// // //                               </Accordion.Item>
// // //                             ))}
// // //                           </Accordion>

// // //                           {Faqs?.length > 4 && (
// // //                             <div className="text-center mt-4">

// // //                               {/* View More Button */}
// // //                               <button
// // //                                 className="btn btn-outline-dark fw-semibold mb-3"
// // //                                 onClick={() => setShowAllFaqs(!showAllFaqs)}
// // //                               >
// // //                                 {showAllFaqs ? "View Less" : "View More"}
// // //                               </button>

// // //                               {/* WhatsApp Button */}
// // //                               <div>
// // //                                 <a
// // //                                   href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets."
// // //                                   target="_blank"
// // //                                   rel="noopener noreferrer"
// // //                                   className="btn fw-bold whatsapp-btn responsive-btn"
// // //                                 >
// // //                                   <i className="bi bi-whatsapp me-2"></i>
// // //                                   Chat With Us
// // //                                 </a>
// // //                               </div>

// // //                             </div>
// // //                           )}

// // //                         </div>

// // //                         {/* <div className="col-md-12 text-center mt-3 mb-4">
// // //           <a
// // //             href="/locations"
// // //             className="btn btn-primary fw-bold dark-back"
// // //           >
// // //             Book Now
// // //           </a>
// // //         </div> */}

// // //                       </div>
// // //                     </div>
// // //                   </div>
// // //                 </section>

// // //                 <section className="pt-5 bg-white">
// // //                   <div
// // //                     className="container-fluid text-center py-5"
// // //                     style={{ backgroundColor: "#e7d2f3" }}
// // //                   >
// // //                     <h2 className="fw-bold mb-5 dark-text">Our Branches</h2>

// // //                     <div className="d-flex flex-wrap justify-content-center gap-3">
// // //                       {addresses.map((addr, idx) => (
// // //                         <a
// // //                           key={idx}
// // //                           href={addr.addressLine2}
// // //                           target="_blank"
// // //                           rel="noopener noreferrer"
// // //                           style={{
// // //                             display: "inline-flex",
// // //                             alignItems: "center",
// // //                             gap: "10px",
// // //                             background: "#fff",
// // //                             border: "1.5px solid rgba(109,40,217,0.15)",
// // //                             borderRadius: "999px",
// // //                             padding: "10px 20px 10px 12px",
// // //                             textDecoration: "none",
// // //                             boxShadow: "0 4px 16px rgba(109,40,217,0.12), 0 1px 4px rgba(0,0,0,0.05)",
// // //                             transition: "all 0.2s ease",
// // //                             cursor: "pointer",
// // //                           }}
// // //                           onMouseEnter={e => {
// // //                             e.currentTarget.style.transform = "translateY(-2px)";
// // //                             e.currentTarget.style.boxShadow = "0 8px 24px rgba(109,40,217,0.22), 0 2px 6px rgba(0,0,0,0.06)";
// // //                             e.currentTarget.style.borderColor = "rgba(109,40,217,0.35)";
// // //                           }}
// // //                           onMouseLeave={e => {
// // //                             e.currentTarget.style.transform = "translateY(0)";
// // //                             e.currentTarget.style.boxShadow = "0 4px 16px rgba(109,40,217,0.12), 0 1px 4px rgba(0,0,0,0.05)";
// // //                             e.currentTarget.style.borderColor = "rgba(109,40,217,0.15)";
// // //                           }}
// // //                         >
// // //                           {/* Icon bubble */}
// // //                           <span style={{
// // //                             width: "34px", height: "34px",
// // //                             borderRadius: "999px",
// // //                             background: "linear-gradient(135deg,#6d28d9,#a855f7)",
// // //                             display: "flex", alignItems: "center", justifyContent: "center",
// // //                             flexShrink: 0,
// // //                             boxShadow: "0 2px 8px rgba(109,40,217,0.3)",
// // //                           }}>
// // //                             <i className="bi bi-geo-alt-fill" style={{ color: "#fff", fontSize: "14px" }} />
// // //                           </span>

// // //                           {/* Text */}
// // //                           <span style={{ textAlign: "left" }}>
// // //                             <span style={{
// // //                               display: "block",
// // //                               fontWeight: 700,
// // //                               fontSize: "13px",
// // //                               color: "#1a1a2e",
// // //                               lineHeight: 1.3,
// // //                             }}>
// // //                               {addr.name}
// // //                             </span>

// // //                           </span>

// // //                           {/* Arrow */}
// // //                           <span style={{ color: "#a855f7", fontSize: "12px", marginLeft: "4px" }}>↗</span>
// // //                         </a>
// // //                       ))}
// // //                     </div>
// // //                   </div>

// // //                   <style jsx>{`
// // //     .text-purple { color: #5b179b; }
// // //   `}</style>
// // //                 </section>


// // //                 {/* <Modal
// // //                   size="md"
// // //                   show={lgShow}
// // //                   onHide={handleClose}
// // //                   aria-labelledby="example-modal-sizes-title-lg"
// // //                   centered
// // //                 >
// // //                   <div style={{ position: "relative", width: "100%" }}>
// // //                     <img
// // //                       src={URLS.Base + PopUp.image}
// // //                       alt="image"
// // //                       style={{ width: "100%", objectFit: "cover" }}
// // //                     />
// // //                     <button
// // //                       style={{
// // //                         position: "absolute",
// // //                         top: "10px",
// // //                         right: "10px",
// // //                         background: "rgba(0, 0, 0, 0.5)",
// // //                         border: "none",
// // //                         color: "white",
// // //                         padding: "5px 10px",
// // //                         borderRadius: "5px",
// // //                         cursor: "pointer",
// // //                       }}
// // //                       onClick={handleClose}
// // //                     >
// // //                       &times;
// // //                     </button>
// // //                   </div>
// // //                 </Modal> */}

// // //                 <PopupModal
// // //                   show={showPopup}
// // //                   handleClose={() => setShowPopup(false)}
// // //                   image={popupImage}
// // //                 />
// // //                 <ToastContainer />
// // //                 <Footer />
// // //               </>
// // //             </div>
// // //           </div>
// // //         </>
// // //       )}
// // //     </>
// // //   )
// // // }

// // // export default Home;

// // import React, { useState, useEffect, useRef } from "react";
// // import { ToastContainer, toast } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import Accordion from "react-bootstrap/Accordion";
// // import Modal from "react-bootstrap/Modal";
// // import Slider from "react-slick";
// // import { URLS } from "../Url";
// // import Footer from "./Footer";
// // import Header from "./Header";
// // import axios from "axios";
// // import { Helmet } from "react-helmet";
// // import { Galleria } from "primereact/galleria";
// // import { useNavigate } from "react-router-dom";
// // import CouponSection from "./Coupons";
// // import HomePackagesSection from "./PackageSection";
// // import PopupModal from "./PopUpModal";

// // // ─── Brand Tokens ────────────────────────────────────────────────────────────
// // const C = {
// //   primary:      "#5E0E73",
// //   primaryLight: "#6E1A85",
// //   primaryPale:  "#F3E5F7",
// //   cream:        "#E8E1D6",
// //   beige:        "#D6CFC4",
// //   gold:         "#C9A84C",
// //   goldLight:    "#E8D5A0",
// //   dark:         "#1A0030",
// //   white:        "#FFFFFF",
// // };

// // // ─── Fetch popup helper ───────────────────────────────────────────────────────
// // export const fetchPopupImage = async () => {
// //   try {
// //     const res = await fetch(
// //       "https://api.carnivalcastle.com/v1/carnivalApi/admin/popup/getpopupimage?type=CarnivalCastle"
// //     );
// //     const data = await res.json();
// //     if (data.success && data.data?.length > 0) return data.data[0];
// //     return null;
// //   } catch { return null; }
// // };

// // // ─── Occasion descriptions ────────────────────────────────────────────────────
// // const occasionDesc = (name) => {
// //   const map = {
// //     "Anniversary":        "Celebrate your love in a private, luxurious theatre with personalised ambiance, delicious food, and exceptional picture quality.",
// //     "Bride To Be":        "Special private screening for the bride-to-be — personalised decor, scrumptious food, and a luxurious theatre experience.",
// //     "Groom To Be":        "Make the groom's last night memorable with a private screening, great food, and intimate theatre experience.",
// //     "Dad To Be":          "Celebrate the soon-to-be father in a private luxurious setting with custom decor and exceptional service.",
// //     "Mom To Be":          "Celebrate the expecting mother in a private theatre with amazing decor, personalised services, and a relaxing experience.",
// //     "Love Proposal":      "Plan the perfect surprise proposal — magical atmosphere, rose petals, candles, and a personalised message.",
// //     "Marriage Proposal":  "Make it official in the most cinematic way. Custom decor, your favourite song, and a frozen-in-time moment.",
// //     "Farewell":           "Bid farewell in style with a private screening, delicious food, and the perfect ambiance.",
// //     "Bon voyage":         "Send off a loved one with a special event — private screening with gourmet food and personalised decor.",
// //   };
// //   return map[name] || "Carnival Castle Private Theatres — intimate, luxurious, and unforgettable for every special occasion.";
// // };

// // // ═══════════════════════════════════════════════════════════════════════════════
// // function Home() {
// //   // ── State ──────────────────────────────────────────────────────────────────
// //   const [isLoading,        setIsLoading]        = useState(true);
// //   const [Faqs,             setFaqs]             = useState([]);
// //   const [Sliders,          setSliders]          = useState([]);
// //   const [Testimonial,      setTestimonial]      = useState([]);
// //   const [Highlights,       setHighlights]       = useState([]);
// //   const [Offers,           setOffers]           = useState([]);
// //   const [Contact,          setContact]          = useState({});
// //   const [PopUp1,           setPopUp1]           = useState({});
// //   const [images,           setImages]           = useState([]);
// //   const [occasions,        setOccasions]        = useState([]);
// //   const [addresses,        setAddresses]        = useState([]);
// //   const [testimonials,     setTestimonials]     = useState([]);
// //   const [slides,           setSlides]           = useState([]);
// //   const [banner,           setBanner]           = useState(null);
// //   const [currentBannerIdx, setCurrentBannerIdx] = useState(0);
// //   const [showAllFaqs,      setShowAllFaqs]      = useState(false);
// //   const [showPopup,        setShowPopup]        = useState(false);
// //   const [popupImage,       setPopupImage]       = useState("");
// //   const [lgShow,           setLgShow]           = useState(false);
// //   const [form,             setform]             = useState({ name:"", email:"", mobileNumber:"", description:"", eventName:"" });
// //   const [whyIndex,         setWhyIndex]         = useState(0);
// //   const [hoveredOcc,       setHoveredOcc]       = useState(null);

// //   const galleria      = useRef(null);
// //   const [activeGalleria, setActiveGalleria] = useState(0);
// //   const navigate      = useNavigate();
// //   const whyIntervalRef = useRef(null);

// //   // ── whyUs slides data ─────────────────────────────────────────────────────
// //   const whyUsSlides = [
// //     {
// //       image: Highlights?.image ? URLS.Base + Highlights.image : "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=900&q=80",
// //       title: "Why Choose CarnivalCastle Private Theatre?",
// //       subtitle: "At CarnivalCastle, we believe every celebration deserves a cinematic experience — intimate, exclusive and unforgettable.",
// //       points: [
// //         "Perfect for Every Occasion: Themed decorations, cakes, fog effects & photography.",
// //         "Luxurious Ambience: Recliners, premium sound, elegant decor.",
// //         "Budget-Friendly Luxury: Combo offers & rewards for every budget.",
// //         "Prime Location in Hyderabad: Easily accessible, cozy, and convenient.",
// //         "End-to-End Convenience: WhatsApp support, décor add-ons & great food.",
// //       ],
// //     },
// //     {
// //       image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg",
// //       title: "Celebrate Cinematically!",
// //       subtitle: "Experience celebrations like never before — where entertainment meets exclusivity.",
// //       points: [
// //         "Customizable Packages: Tailor your party exactly how you like it.",
// //         "Gourmet Snacks & Beverages: From popcorn to premium platters.",
// //         "Full HD Projector & Sound: A real theatre vibe, privately yours.",
// //         "Cozy for Everyone: Perfect for couples, families, and friends.",
// //         "Hassle-Free Booking: Fast, flexible & fully digital!",
// //       ],
// //     },
// //     {
// //       image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg",
// //       title: "Make Every Moment Magical",
// //       subtitle: "From surprise proposals to baby showers — bring your vision to life in an immersive theatre setting.",
// //       points: [
// //         "Baby Showers, Anniversaries & More: Celebrate every milestone.",
// //         "Themed Decor & Props: Transform the space into your dream setting.",
// //         "Memorable Photo Zones: Instagram-worthy backdrops included.",
// //         "Night or Day Slots: Flexible celebration timings.",
// //         "Personalized Assistance: Our team helps plan every detail.",
// //       ],
// //     },
// //   ];

// //   // ── Fetch everything ──────────────────────────────────────────────────────
// //   useEffect(() => {
// //     // Main modules
// //     axios.post(URLS.AllModules, {}).then((res) => {
// //       if (res.status === 200) {
// //         setFaqs(res.data.faqs);
// //         setContact(res.data.contactus?.[0] || {});
// //         setSliders(res.data.homesliders);
// //         setTestimonial(res.data.testimonials);
// //         setHighlights(res.data.highlight?.[0] || {});
// //         setOffers(res.data.offer);
// //         const popup = res.data.popup?.[0];
// //         setPopUp1(popup || {});
// //         setLgShow(popup?.popupBoolean || false);
// //         setIsLoading(false);
// //       }
// //     }).catch(() => setIsLoading(false));

// //     // Gallery
// //     axios.post(URLS.GetAllGallery, {}).then((res) => {
// //       if (res.status === 200) setImages(res.data.gallerys?.slice(0, 6) || []);
// //     });

// //     // Occasions
// //     axios.post(URLS.GetAllOccation, {}).then((res) => {
// //       if (res.status === 200) setOccasions(res.data?.occasions || []);
// //     });

// //     // Addresses
// //     axios.get("https://api.carnivalcastle.com/v1/carnivalApi/admin/address/alladdress")
// //       .then((res) => { if (res.data?.success) setAddresses(res.data.data || []); });

// //     // Video Testimonials
// //     axios.post("https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle")
// //       .then((res) => {
// //         if (res.data?.success && Array.isArray(res.data.testimoni)) {
// //           const videoT = res.data.testimoni.filter(t => t.status === "active" && t.videoId?.trim());
// //           setTestimonials(videoT);
// //           // Text slides
// //           const formatted = res.data.testimoni.filter(t => t.status === "active").map(t => ({
// //             name:        t.name,
// //             location:    t.role || "Customer",
// //             rating:      Number(t.rating) || 5,
// //             description: t.description || "",
// //             image:       `https://api.carnivalcastle.com/${t.image}`,
// //             avatar:      `https://api.carnivalcastle.com/${t.profileImage}`,
// //             occasion:    t.type === "Yes" ? "Special Celebration" : "",
// //           }));
// //           const grouped = [];
// //           for (let i = 0; i < formatted.length; i += 3) grouped.push(formatted.slice(i, i + 3));
// //           setSlides(grouped);
// //         }
// //       });

// //     // Banner
// //     axios.get("https://api.carnivalcastle.com/v1/carnivalApi/admin/get-banners?type=carnivalcastle")
// //       .then((res) => { if (res.data.success && res.data.banners.length > 0) setBanner(res.data.banners[0]); });

// //     // Popup
// //     fetchPopupImage().then((popup) => {
// //       if (popup?.modalEnabled) { setPopupImage(popup.image); setShowPopup(true); }
// //     });

// //     // Local popup
// //     if (!localStorage.getItem("popupShown")) setLgShow(true);
// //   }, []);

// //   // Banner auto-slide
// //   useEffect(() => {
// //     if (!banner?.desktopImages?.length) return;
// //     const t = setInterval(() => setCurrentBannerIdx(p => (p + 1) % banner.desktopImages.length), 3500);
// //     return () => clearInterval(t);
// //   }, [banner]);

// //   // Why us auto-rotate
// //   useEffect(() => {
// //     whyIntervalRef.current = setInterval(() => setWhyIndex(i => (i + 1) % whyUsSlides.length), 6000);
// //     return () => clearInterval(whyIntervalRef.current);
// //   }, []);

// //   // ── Handlers ──────────────────────────────────────────────────────────────
// //   const handleChange  = (e) => setform(f => ({ ...f, [e.target.name]: e.target.value }));
// //   const handleSubmit  = (e) => {
// //     e.preventDefault();
// //     axios.post(URLS.AddEnquiry, form).then((res) => {
// //       if (res.status === 200) {
// //         toast.success(res.data.message);
// //         setform({ name:"", email:"", mobileNumber:"", description:"", eventName:"" });
// //       }
// //     }).catch(err => { if (err.response?.status === 400) toast.error(err.response.data.message); });
// //   };

// //   const handleWhySelect = (i) => {
// //     clearInterval(whyIntervalRef.current);
// //     setWhyIndex(i);
// //     whyIntervalRef.current = setInterval(() => setWhyIndex(j => (j + 1) % whyUsSlides.length), 6000);
// //   };

// //   // ── Slick settings ────────────────────────────────────────────────────────
// //   const bannerSettings = {
// //     dots: false, infinite: true, speed: 1000, fade: true,
// //     slidesToShow: 1, slidesToScroll: 1, autoplay: true, autoplaySpeed: 3500,
// //   };
// //   const occasionSettings = {
// //     dots: false, infinite: true, speed: 500, slidesToShow: 3,
// //     slidesToScroll: 1, autoplay: true, autoplaySpeed: 3000,
// //     responsive: [
// //       { breakpoint: 992, settings: { slidesToShow: 2 } },
// //       { breakpoint: 576, settings: { slidesToShow: 1 } },
// //     ],
// //   };
// //   const servicesSettings = {
// //     dots: false, infinite: true, arrows: true, speed: 600,
// //     slidesToShow: 4, slidesToScroll: 1, autoplay: true, autoplaySpeed: 3500,
// //     responsive: [
// //       { breakpoint: 1200, settings: { slidesToShow: 3 } },
// //       { breakpoint: 768,  settings: { slidesToShow: 2 } },
// //       { breakpoint: 480,  settings: { slidesToShow: 1 } },
// //     ],
// //   };

// //   const galleryItemTemplate = (item) => (
// //     <img src={URLS.Base + item.image} alt={item.alt} style={{ width: "100%", display: "block" }} />
// //   );
// //   const galleryThumbTemplate = (item) => (
// //     <img src={URLS.Base + item.image} alt={item.alt} style={{ display: "block" }} />
// //   );

// //   // mobileImage fallback
// //   const mobileImg = banner?.mobileImages?.[currentBannerIdx]
// //     ? `https://api.carnivalcastle.com/${banner.mobileImages[currentBannerIdx]}`
// //     : "";
// //   const desktopImg = banner?.desktopImages?.[currentBannerIdx]
// //     ? `https://api.carnivalcastle.com/${banner.desktopImages[currentBannerIdx]}`
// //     : "";

// //   const serviceCards = [
// //     { label: "Food & Beverages", img: "https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80", href: "/Food", desc: "Choose the perfect food combo for your celebration." },
// //     { label: "Cakes",            img: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80", href: "/cakes", desc: "Choose the perfect cake from our selection." },
// //     { label: "Screening",        img: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80", href: null,   desc: "Bring your OTT accounts and relive the theatre magic!" },
// //     { label: "Bouquets",         img: "https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=600&q=80", href: null,   desc: "Add a beautiful rose bouquet to enhance your celebration." },
// //   ];

// //   // ── Loading screen ────────────────────────────────────────────────────────
// //   if (isLoading) return (
// //     <div style={{ backgroundColor: C.dark, height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
// //       <img src="assets/img/giff.gif" style={{ height: 300 }} alt="loading" />
// //       <p style={{ color: C.gold, marginTop: 12, fontWeight: 600 }}>Loading…</p>
// //     </div>
// //   );

// //   // ════════════════════════════════════════════════════════════════════════════
// //   return (
// //     <>
// //       <Helmet>
// //         <title>Carnival Castle | Best Private Theaters for Celebrations in Hyderabad</title>
// //         <meta name="description" content="Experience the magic of celebrations at Carnival Castle Private Theatres in Hyderabad. Perfect for Birthdays, Anniversaries, Bride To Be, Surprise Parties, etc" />
// //       </Helmet>

// //       <style>{`
// //         /* ── Brand tokens ── */
// //         :root {
// //           --primary:       ${C.primary};
// //           --primary-light: ${C.primaryLight};
// //           --primary-pale:  ${C.primaryPale};
// //           --cream:         ${C.cream};
// //           --beige:         ${C.beige};
// //           --gold:          ${C.gold};
// //           --gold-light:    ${C.goldLight};
// //           --dark:          ${C.dark};
// //         }

// //         /* ── Typography ── */
// //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
// //         body { font-family: 'DM Sans', sans-serif; background: var(--cream); }
// //         .pf { font-family: 'Playfair Display', serif !important; }

// //         /* ── Utilities ── */
// //         .cc-primary    { color: var(--primary) !important; }
// //         .cc-gold       { color: var(--gold) !important; }
// //         .cc-bg-primary { background: var(--primary) !important; }
// //         .cc-bg-cream   { background: var(--cream) !important; }
// //         .cc-bg-dark    { background: var(--dark) !important; }

// //         .cc-btn {
// //           background: linear-gradient(135deg, var(--primary), var(--primary-light));
// //           color: #fff; border: none; border-radius: 50px;
// //           padding: 12px 28px; font-weight: 700; font-size: 14px;
// //           cursor: pointer; transition: all .25s ease;
// //           box-shadow: 0 6px 20px rgba(94,14,115,.35);
// //           font-family: 'DM Sans', sans-serif;
// //           text-decoration: none; display: inline-block;
// //         }
// //         .cc-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 28px rgba(94,14,115,.45); color:#fff; }
// //         .cc-btn-outline {
// //           background: transparent;
// //           color: var(--primary); border: 2px solid var(--primary);
// //           border-radius: 50px; padding: 11px 26px;
// //           font-weight: 700; font-size: 14px; cursor: pointer;
// //           transition: all .25s ease; font-family: 'DM Sans', sans-serif;
// //           text-decoration: none; display: inline-block;
// //         }
// //         .cc-btn-outline:hover { background: var(--primary); color:#fff; }
// //         .cc-btn-gold {
// //           background: linear-gradient(135deg, var(--gold), #A07830);
// //           color: #fff; border: none; border-radius: 50px;
// //           padding: 12px 28px; font-weight: 700; font-size: 14px;
// //           cursor: pointer; transition: all .25s; text-decoration:none; display:inline-block;
// //           box-shadow: 0 6px 20px rgba(201,168,76,.35);
// //         }
// //         .cc-btn-gold:hover { transform: translateY(-2px); color:#fff; }
// //         .wa-btn {
// //           background: #25D366; color:#fff; border:none; border-radius:50px;
// //           padding:12px 28px; font-weight:700; font-size:14px; cursor:pointer;
// //           transition:all .25s; text-decoration:none; display:inline-flex; align-items:center; gap:8px;
// //           box-shadow:0 6px 20px rgba(37,211,102,.3);
// //         }
// //         .wa-btn:hover { background:#1ebe5d; transform:translateY(-2px); color:#fff; }

// //         /* ── Section common ── */
// //         .cc-section { padding: 72px 0; }
// //         .cc-section-sm { padding: 48px 0; }
// //         .cc-section-dark { background: var(--dark); }
// //         .cc-section-cream { background: var(--cream); }
// //         .cc-section-beige { background: var(--beige); }
// //         .cc-section-pale  { background: var(--primary-pale); }

// //         .cc-tag {
// //           display: inline-block; font-size: 11px; font-weight: 700;
// //           letter-spacing: 3px; text-transform: uppercase;
// //           color: var(--gold); margin-bottom: 10px;
// //         }
// //         .cc-heading {
// //           font-family: 'Playfair Display', serif;
// //           font-size: clamp(28px, 4vw, 46px);
// //           font-weight: 700; line-height: 1.2;
// //           color: var(--dark);
// //         }
// //         .cc-heading-white { color: #fff; }
// //         .cc-heading span  { color: var(--primary); }
// //         .cc-sub { color: #777; font-size: 16px; line-height: 1.7; max-width: 560px; margin: 12px auto 0; }

// //         /* ── Scroll reveal ── */
// //         .cc-reveal { opacity: 0; transform: translateY(32px); transition: opacity .65s ease, transform .65s ease; }
// //         .cc-reveal.in { opacity: 1; transform: translateY(0); }
// //         .cc-reveal-d1 { transition-delay: .1s !important; }
// //         .cc-reveal-d2 { transition-delay: .2s !important; }
// //         .cc-reveal-d3 { transition-delay: .3s !important; }
// //         .cc-reveal-d4 { transition-delay: .4s !important; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            HERO / BANNER
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .cc-hero { position: relative; height: 88vh; min-height: 500px; overflow: hidden; }
// //         .cc-hero-img {
// //           position: absolute; inset: 0; width: 100%; height: 100%;
// //           object-fit: cover; transition: opacity 1s ease;
// //         }
// //         .cc-hero-overlay {
// //           position: absolute; inset: 0;
// //           background: linear-gradient(135deg, rgba(26,0,48,.82) 0%, rgba(94,14,115,.45) 60%, rgba(26,0,48,.3) 100%);
// //         }
// //         .cc-hero-content {
// //           position: absolute; top:50%; left:50%;
// //           transform: translate(-50%, -50%);
// //           text-align: center; width: 90%; max-width: 800px; z-index: 2;
// //         }
// //         .cc-hero-title {
// //           font-family: 'Playfair Display', serif;
// //           font-size: clamp(34px, 6vw, 76px);
// //           font-weight: 900; color: #fff; line-height: 1.08;
// //           text-shadow: 0 4px 24px rgba(0,0,0,.4);
// //         }
// //         .cc-hero-title span {
// //           background: linear-gradient(135deg, var(--gold-light), var(--cream));
// //           -webkit-background-clip: text; -webkit-text-fill-color: transparent;
// //         }
// //         .cc-hero-sub { color: rgba(255,255,255,.8); font-size: clamp(14px,2vw,18px); margin: 16px 0 32px; }
// //         .cc-hero-dots { position: absolute; bottom: 28px; left: 50%; transform: translateX(-50%); display: flex; gap: 8px; z-index: 2; }
// //         .cc-hero-dot { width: 8px; height: 8px; border-radius: 50%; background: rgba(255,255,255,.4); border: none; cursor: pointer; transition: all .3s; }
// //         .cc-hero-dot.active { background: var(--gold); width: 24px; border-radius: 4px; }
// //         @media(max-width:768px){ .cc-hero { height: 70vh; } }

// //         /* ══════════════════════════════════════════════════════════════════
// //            ANNOUNCEMENT BAR
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .cc-announce { background: var(--primary); padding: 8px 0; overflow: hidden; }
// //         .cc-announce marquee { color: #fff; font-weight: 600; font-size: 13px; letter-spacing: .5px; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            OFFER BANNER
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .cc-offer {
// //           margin: 40px auto; max-width: 1200px; border-radius: 24px;
// //           background: linear-gradient(135deg, #1A0030 0%, var(--primary) 55%, #1A0030 100%);
// //           padding: 44px 56px; display: flex; align-items: center; justify-content: space-between;
// //           box-shadow: 0 20px 60px rgba(94,14,115,.4); position: relative; overflow: hidden;
// //         }
// //         .cc-offer::before {
// //           content: ''; position: absolute; inset: 0;
// //           background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E");
// //         }
// //         .cc-offer-badge { background: var(--gold); color: #1A0030; font-size: 10px; font-weight: 800; letter-spacing: 2px; text-transform: uppercase; padding: 5px 14px; border-radius: 50px; display: inline-block; margin-bottom: 14px; }
// //         .cc-offer-headline { font-family: 'Playfair Display', serif; font-size: clamp(32px,5vw,58px); font-weight: 900; color: #fff; line-height: 1; margin-bottom: 6px; }
// //         .cc-offer-headline span { background: linear-gradient(135deg,var(--gold-light),var(--cream)); -webkit-background-clip:text; -webkit-text-fill-color:transparent; }
// //         .cc-offer-sub { color: rgba(255,255,255,.7); font-size: 15px; margin-bottom: 18px; }
// //         .cc-offer-sub b { color: var(--gold-light); }
// //         .cc-offer-code { display: inline-flex; align-items: center; gap: 10px; background: rgba(255,255,255,.08); border: 1.5px dashed rgba(201,168,76,.5); padding: 10px 20px; border-radius: 10px; color: #fff; font-size: 14px; font-weight: 600; }
// //         .cc-offer-code span { background: var(--gold); color: #1A0030; padding: 3px 12px; border-radius: 6px; font-family: monospace; font-size: 13px; letter-spacing: 1px; }
// //         .cc-offer-ring { width: 180px; height: 180px; border-radius: 50%; border: 1.5px solid rgba(201,168,76,.3); display: flex; align-items: center; justify-content: center; flex-direction: column; text-align: center; animation: spin-slow 20s linear infinite; flex-shrink: 0; background: rgba(201,168,76,.08); }
// //         .cc-offer-ring-n { font-family: 'Playfair Display', serif; font-size: 48px; font-weight: 900; color: var(--gold); line-height: 1; }
// //         .cc-offer-ring-s { color: rgba(255,255,255,.5); font-size: 12px; margin-top: 2px; }
// //         @keyframes spin-slow { from{transform:rotate(0deg);}to{transform:rotate(360deg);} }
// //         @media(max-width:768px){ .cc-offer { margin:24px 16px; padding:32px 24px; flex-direction:column; gap:24px; text-align:center; } .cc-offer-ring{display:none;} }

// //         /* ══════════════════════════════════════════════════════════════════
// //            OCCASIONS
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .occ-card { position: relative; border-radius: 18px; overflow: hidden; cursor: pointer; height: 300px; transition: transform .35s, box-shadow .35s; }
// //         .occ-card:hover { transform: translateY(-7px); box-shadow: 0 20px 56px rgba(94,14,115,.22); }
// //         .occ-card img { width: 100%; height: 100%; object-fit: cover; transition: transform .5s; }
// //         .occ-card:hover img { transform: scale(1.07); }
// //         .occ-card-overlay { position: absolute; inset: 0; background: linear-gradient(to top, rgba(26,0,48,.95) 0%, rgba(26,0,48,.25) 60%, transparent 100%); display: flex; flex-direction: column; justify-content: flex-end; padding: 20px; transition: background .35s; }
// //         .occ-card:hover .occ-card-overlay { background: linear-gradient(to top, rgba(94,14,115,.96) 0%, rgba(110,26,133,.5) 60%, transparent 100%); }
// //         .occ-badge { display: inline-block; background: var(--gold); color: #1A0030; font-size: 9px; font-weight: 800; letter-spacing: 1px; text-transform: uppercase; padding: 3px 10px; border-radius: 50px; margin-bottom: 8px; }
// //         .occ-icon { font-size: 26px; margin-bottom: 4px; }
// //         .occ-title { font-family: 'Playfair Display', serif; color: #fff; font-size: 18px; font-weight: 700; }
// //         .occ-desc { color: rgba(255,255,255,.75); font-size: 12px; line-height: 1.6; max-height: 0; overflow: hidden; transition: max-height .4s ease, margin-top .3s; }
// //         .occ-card:hover .occ-desc { max-height: 80px; margin-top: 8px; }
// //         .occ-book { opacity: 0; transform: translateY(8px); transition: opacity .3s, transform .3s; background: var(--gold); color: #1A0030; border: none; border-radius: 50px; font-size: 11px; font-weight: 700; padding: 6px 14px; cursor: pointer; margin-top: 8px; font-family: 'DM Sans', sans-serif; }
// //         .occ-card:hover .occ-book { opacity: 1; transform: translateY(0); }
// //         .occ-proceed { margin: 28px auto 0; display: flex; flex-direction: column; align-items: center; gap: 12px; max-width: 460px; }
// //         .occ-proceed button, .occ-proceed a { width: 100%; text-align: center; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            SERVICES
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .svc-card { border-radius: 18px; overflow: hidden; position: relative; cursor: pointer; transition: transform .35s, box-shadow .35s; }
// //         .svc-card:hover { transform: translateY(-6px); box-shadow: 0 16px 48px rgba(94,14,115,.18); }
// //         .svc-img { width: 100%; height: 220px; object-fit: cover; transition: transform .5s; display: block; }
// //         .svc-card:hover .svc-img { transform: scale(1.06); }
// //         .svc-body { background: var(--cream); padding: 18px; }
// //         .svc-title { font-family: 'Playfair Display', serif; font-size: 17px; font-weight: 700; color: var(--primary); margin-bottom: 6px; }
// //         .svc-desc  { font-size: 13px; color: #888; line-height: 1.5; }
// //         .svc-link  { font-size: 12px; color: var(--primary); font-weight: 700; text-decoration: none; display: inline-block; margin-top: 10px; }
// //         .svc-link:hover { color: var(--primary-light); }

// //         /* ══════════════════════════════════════════════════════════════════
// //            WHY US
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .why-card { background: #fff; border-radius: 28px; padding: clamp(28px,4vw,52px); box-shadow: 0 24px 60px rgba(94,14,115,.1); border: 1px solid rgba(94,14,115,.07); }
// //         .why-img-wrap { border-radius: 22px; overflow: hidden; box-shadow: 0 16px 40px rgba(94,14,115,.18); }
// //         .why-img { width: 100%; height: clamp(260px,35vw,440px); object-fit: cover; transition: transform .5s; }
// //         .why-img-wrap:hover .why-img { transform: scale(1.03); }
// //         .why-underline { position: relative; padding-bottom: 14px; }
// //         .why-underline::after { content:''; position:absolute; bottom:0; left:0; width:72px; height:3px; background: linear-gradient(90deg,var(--primary),var(--gold)); border-radius:2px; }
// //         .why-point { display: flex; align-items: flex-start; gap: 12px; margin-bottom: 16px; }
// //         .why-point-icon { width: 30px; height: 30px; border-radius: 8px; background: var(--primary-pale); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
// //         .why-point-icon i { color: var(--primary); font-size: 13px; }
// //         .why-point-text { font-size: 14px; color: #555; line-height: 1.6; }
// //         .why-dot { width: 10px; height: 10px; border-radius: 50%; border: none; cursor: pointer; transition: all .3s; }
// //         .why-dot.active { width: 32px; border-radius: 5px; background: linear-gradient(90deg, var(--primary), var(--gold)) !important; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            TESTIMONIALS – TEXT CARDS
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .testi-card { position: relative; border-radius: 18px; overflow: hidden; height: 400px; transition: transform .35s; }
// //         .testi-card:hover { transform: translateY(-5px); }
// //         .testi-card img.testi-bg { width: 100%; height: 100%; object-fit: cover; filter: brightness(65%); display: block; }
// //         .testi-glass {
// //           position: absolute; bottom: 0; left: 50%; transform: translateX(-50%);
// //           width: 92%; padding: 18px 18px 20px;
// //           background: rgba(232,225,214,.94); backdrop-filter: blur(8px);
// //           border-radius: 16px 16px 0 0;
// //         }
// //         .testi-stars { color: var(--gold); letter-spacing: 1px; font-size: 14px; }
// //         .testi-desc { font-size: 12px; color: #333; line-height: 1.6; margin: 6px 0; }
// //         .testi-name { font-weight: 700; font-size: 14px; color: var(--primary); }
// //         .testi-role { font-size: 11px; color: #888; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            VIDEO TESTIMONIALS
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .vtesti-wrap { max-width: 900px; margin: 0 auto; }
// //         .vtesti-main { border-radius: 18px; overflow: hidden; box-shadow: 0 16px 48px rgba(94,14,115,.25); }
// //         .vtesti-side { border-radius: 14px; overflow: hidden; opacity: .65; transition: opacity .3s; cursor: pointer; }
// //         .vtesti-side:hover { opacity: .85; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            GALLERY
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .gal-item { position: relative; border-radius: 14px; overflow: hidden; height: 260px; cursor: pointer; }
// //         .gal-item img { width: 100%; height: 100%; object-fit: cover; transition: transform .45s; }
// //         .gal-item:hover img { transform: scale(1.08); }
// //         .gal-item:hover .gal-zoom { opacity: 1; }
// //         .gal-zoom { position: absolute; inset: 0; background: rgba(94,14,115,.35); display: flex; align-items: center; justify-content: center; opacity: 0; transition: opacity .3s; }
// //         .gal-zoom i { color: #fff; font-size: 28px; }
// //         @media(max-width:768px){ .gal-item{height:200px;} }

// //         /* ══════════════════════════════════════════════════════════════════
// //            FAQ
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .cc-faq .accordion-item { background: #fff; border: 1px solid rgba(94,14,115,.1); border-radius: 14px !important; margin-bottom: 10px; overflow: hidden; }
// //         .cc-faq .accordion-button { font-weight: 600; color: var(--dark); background: #fff; border-radius: 14px !important; }
// //         .cc-faq .accordion-button:not(.collapsed) { color: var(--primary); background: var(--primary-pale); box-shadow: none; }
// //         .cc-faq .accordion-button:focus { box-shadow: none; }
// //         .cc-faq .accordion-button::after { filter: hue-rotate(250deg); }

// //         /* ══════════════════════════════════════════════════════════════════
// //            BRANCHES
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .branch-pill {
// //           display: inline-flex; align-items: center; gap: 10px;
// //           background: #fff; border: 1.5px solid rgba(94,14,115,.12);
// //           border-radius: 999px; padding: 10px 20px 10px 12px;
// //           text-decoration: none; cursor: pointer;
// //           box-shadow: 0 4px 16px rgba(94,14,115,.1);
// //           transition: all .25s ease;
// //         }
// //         .branch-pill:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(94,14,115,.2); border-color: rgba(94,14,115,.3); }
// //         .branch-icon { width: 34px; height: 34px; border-radius: 50%; background: linear-gradient(135deg,var(--primary),var(--primary-light)); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            ENQUIRY FORM
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .enq-form { background: #fff; border-radius: 24px; padding: 36px; box-shadow: 0 16px 48px rgba(94,14,115,.1); }
// //         .enq-form input, .enq-form textarea, .enq-form select {
// //           background: var(--cream); border: 1.5px solid rgba(94,14,115,.12);
// //           border-radius: 10px; padding: 12px 16px; font-size: 14px;
// //           font-family: 'DM Sans', sans-serif; outline: none;
// //           transition: border-color .2s, box-shadow .2s; width: 100%;
// //           color: var(--dark);
// //         }
// //         .enq-form input:focus, .enq-form textarea:focus, .enq-form select:focus {
// //           border-color: var(--primary); box-shadow: 0 0 0 3px rgba(94,14,115,.08);
// //         }
// //         .enq-label { font-size: 11px; font-weight: 700; color: #999; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 5px; display: block; }

// //         /* ══════════════════════════════════════════════════════════════════
// //            INSTAGRAM STRIP
// //         ═══════════════════════════════════════════════════════════════════ */
// //         .ig-strip { border-radius: 20px; padding: 28px 36px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px; }
// //         .ig-strip { background: linear-gradient(135deg, var(--primary-pale), var(--beige)); border: 1px solid rgba(94,14,115,.1); }

// //         /* ══════════════════════════════════════════════════════════════════
// //            RESPONSIVE OVERRIDES
// //         ═══════════════════════════════════════════════════════════════════ */
// //         @media(max-width:576px){
// //           .cc-section { padding: 48px 0; }
// //           .enq-form { padding: 24px 18px; }
// //           .cc-offer-code { flex-wrap: wrap; justify-content: center; }
// //           .ig-strip { padding: 24px 20px; text-align: center; justify-content: center; }
// //           .why-card { padding: 24px 18px; }
// //         }

// //         /* Slick arrow color override */
// //         .slick-prev:before, .slick-next:before { color: var(--primary) !important; font-size: 24px !important; }
// //       `}</style>

// //       <div className="home-page">
// //         <div className="main-wrapper">
// //           <Header />

// //           {/* ── ANNOUNCEMENT BAR ───────────────────────────────────────── */}
// //           {PopUp1?.modalEnabled && (
// //             <div className="cc-announce">
// //               <marquee>{PopUp1.title}</marquee>
// //             </div>
// //           )}

// //           {/* ── HERO BANNER ────────────────────────────────────────────── */}
// //           {banner && (
// //             <section className="cc-hero">
// //               {banner.desktopImages.map((img, i) => (
// //                 <img
// //                   key={i}
// //                   src={`https://api.carnivalcastle.com/${img}`}
// //                   alt=""
// //                   className="cc-hero-img"
// //                   style={{ opacity: i === currentBannerIdx ? 1 : 0, zIndex: i === currentBannerIdx ? 1 : 0 }}
// //                 />
// //               ))}
// //               <div className="cc-hero-overlay" style={{ zIndex: 2 }} />
// //               <div className="cc-hero-content" style={{ zIndex: 3 }}>
// //                 <p style={{ fontSize: 11, letterSpacing: 4, textTransform: "uppercase", color: C.goldLight, marginBottom: 12, fontWeight: 600 }}>
// //                   ✦ Private Theatre Celebrations ✦
// //                 </p>
// //                 <h1 className="cc-hero-title" dangerouslySetInnerHTML={{ __html: banner.title || "Your Special Moment <span>Deserves a Stage</span>" }} />
// //                 <p className="cc-hero-sub">{banner.description || "Book a private theatre — just for you and your loved ones"}</p>
// //                 <div style={{ display: "flex", gap: 14, justifyContent: "center", flexWrap: "wrap" }}>
// //                   <a href="/locations" className="cc-btn-gold">🎉 Book Now</a>
// //                   <a href="tel:8977917555" className="cc-btn-outline" style={{ borderColor: "rgba(255,255,255,.5)", color: "#fff" }}>📞 Call to Book</a>
// //                 </div>
// //               </div>
// //               <div className="cc-hero-dots">
// //                 {banner.desktopImages.map((_, i) => (
// //                   <button key={i} className={`cc-hero-dot${i === currentBannerIdx ? " active" : ""}`} onClick={() => setCurrentBannerIdx(i)} />
// //                 ))}
// //               </div>
// //               <style>{`@media(max-width:768px){.cc-hero-img{object-position:center;} .cc-hero-img[data-mobile]{content:url(${mobileImg});}}`}</style>
// //             </section>
// //           )}

// //           {/* ── OFFER BANNER ───────────────────────────────────────────── */}
// //           <div className="container">
// //             <div className="cc-offer cc-reveal">
// //               <div>
// //                 <span className="cc-offer-badge">🎁 Limited Time Offer</span>
// //                 <div className="cc-offer-headline">Get Upto <span>40% Off</span></div>
// //                 <div className="cc-offer-headline" style={{ fontSize: "clamp(18px,2.5vw,26px)", marginTop: 4 }}>+ <span>Extra 10%</span> on Weekday Bookings</div>
// //                 <p className="cc-offer-sub">Min Booking Value: <b>₹2,499</b></p>
// //                 <div className="cc-offer-code">🏷️ Use Code: <span>CASTLE10</span></div>
// //               </div>
// //               <div className="cc-offer-ring">
// //                 <div className="cc-offer-ring-n">40%</div>
// //                 <div className="cc-offer-ring-s">OFF TODAY</div>
// //               </div>
// //             </div>
// //           </div>

// //           {/* ── OCCASIONS ──────────────────────────────────────────────── */}
// //           <section className="cc-section cc-section-cream" id="occasions">
// //             <div className="container">
// //               <div className="text-center cc-reveal" style={{ marginBottom: 48 }}>
// //                 <span className="cc-tag">✦ What We Offer ✦</span>
// //                 <h2 className="cc-heading">Occasions We <span>Celebrate</span></h2>
// //                 <p className="cc-sub">Private theatre experiences crafted for your most special moments — from surprise birthdays to romantic proposals.</p>
// //               </div>

// //               {occasions.length > 0 ? (
// //                 <Slider {...occasionSettings}>
// //                   {occasions.map((occ, i) => (
// //                     <div key={i} style={{ padding: "0 10px" }}>
// //                       <div className="occ-card" onClick={() => navigate("/locations")}>
// //                         <img src={URLS.Base + occ.image} alt={occ.name} />
// //                         <div className="occ-card-overlay">
// //                           <span className="occ-badge">Book Now</span>
// //                           <div className="occ-title">{occ.name}</div>
// //                           <p className="occ-desc">{occasionDesc(occ.name)}</p>
// //                           <button className="occ-book">Reserve →</button>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </Slider>
// //               ) : (
// //                 <div className="row g-3">
// //                   {["Birthday Celebration","Love Proposal","Anniversary","Bride To Be","Groom To Be","Birthday Surprise"].map((n,i) => (
// //                     <div key={i} className="col-6 col-md-4">
// //                       <div className="occ-card" style={{ background: C.primaryPale, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={() => navigate("/locations")}>
// //                         <div style={{ textAlign:"center", padding:24 }}>
// //                           <div style={{ fontSize:36 }}>🎉</div>
// //                           <div className="occ-title" style={{ color: C.dark, marginTop: 8 }}>{n}</div>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //               )}

// //               <div className="occ-proceed">
// //                 <a href="/locations" className="cc-btn" style={{ width:"100%", textAlign:"center" }}>Proceed to Book →</a>
// //                 <a href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets." target="_blank" rel="noopener noreferrer" className="wa-btn" style={{ width:"100%", justifyContent:"center" }}>
// //                   <i className="bi bi-whatsapp"></i> Chat With Us
// //                 </a>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── SERVICES ───────────────────────────────────────────────── */}
// //           <section className="cc-section" style={{ background: "#fff" }}>
// //             <div className="container">
// //               <div className="text-center cc-reveal" style={{ marginBottom: 48 }}>
// //                 <span className="cc-tag">✦ Our Services ✦</span>
// //                 <h2 className="cc-heading">Everything You <span>Need</span></h2>
// //                 <p className="cc-sub">Cakes, food, screening, bouquets — all curated to make your event perfect.</p>
// //               </div>
// //               <Slider {...servicesSettings}>
// //                 {serviceCards.map((s, i) => (
// //                   <div key={i} style={{ padding: "0 10px" }}>
// //                     <div className="svc-card">
// //                       <img src={s.img} alt={s.label} className="svc-img" />
// //                       <div className="svc-body">
// //                         <div className="svc-title">{s.label}</div>
// //                         <p className="svc-desc">{s.desc}</p>
// //                         {s.href && <a href={s.href} className="svc-link">View more →</a>}
// //                       </div>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </Slider>
// //               <div className="text-center mt-4">
// //                 <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn" style={{ margin: "0 auto" }}>
// //                   <i className="bi bi-whatsapp"></i> Chat With Us
// //                 </a>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── WHY CHOOSE US ──────────────────────────────────────────── */}
// //           <section className="cc-section cc-section-beige">
// //             <div className="container">
// //               <div className="text-center cc-reveal" style={{ marginBottom: 48 }}>
// //                 <span className="cc-tag">✦ Why Choose Us ✦</span>
// //                 <h2 className="cc-heading">Plan a Surprise for your <span>Loved One</span></h2>
// //               </div>
// //               <div className="why-card cc-reveal">
// //                 <div className="row align-items-center g-5">
// //                   {/* Image */}
// //                   <div className="col-lg-6">
// //                     <div className="why-img-wrap">
// //                       <img src={whyUsSlides[whyIndex].image} alt="Why CarnivalCastle" className="why-img" />
// //                     </div>
// //                   </div>
// //                   {/* Content */}
// //                   <div className="col-lg-6">
// //                     <h3 className="cc-heading why-underline" style={{ fontSize: "clamp(20px,2.5vw,28px)", marginBottom: 24, color: C.dark }}>
// //                       {whyUsSlides[whyIndex].subtitle}
// //                     </h3>
// //                     <ul style={{ listStyle: "none", padding: 0 }}>
// //                       {whyUsSlides[whyIndex].points.map((pt, i) => (
// //                         <li key={i} className="why-point">
// //                           <div className="why-point-icon"><i className="fas fa-check-circle" /></div>
// //                           <span className="why-point-text">{pt}</span>
// //                         </li>
// //                       ))}
// //                     </ul>
// //                     <div style={{ display:"flex", gap:12, flexWrap:"wrap", marginTop:28 }}>
// //                       <a href="/locations" className="cc-btn"><i className="fas fa-ticket-alt me-2"></i>Book Your Experience</a>
// //                       <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"></i>Chat With Us</a>
// //                     </div>
// //                     {/* Dots */}
// //                     <div style={{ display:"flex", gap:8, marginTop:28 }}>
// //                       {whyUsSlides.map((_,i) => (
// //                         <button key={i} className={`why-dot${i===whyIndex?" active":""}`}
// //                           style={{ background: i===whyIndex ? "var(--primary)" : "rgba(94,14,115,.2)" }}
// //                           onClick={() => handleWhySelect(i)}
// //                         />
// //                       ))}
// //                     </div>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── VIDEO TESTIMONIALS ────────────────────────────────────── */}
// //           {testimonials.length > 0 && (
// //             <section className="cc-section" style={{ background: "#fff" }}>
// //               <div className="container">
// //                 <div className="text-center cc-reveal" style={{ marginBottom: 48 }}>
// //                   <span className="cc-tag">✦ Testimonials ✦</span>
// //                   <h2 className="cc-heading">Real Stories, <span>Real Magic</span></h2>
// //                   <p className="cc-sub">See what our guests experienced at CarnivalCastle.</p>
// //                 </div>
// //                 <div
// //                   id="vtCarousel"
// //                   className="carousel slide carousel-fade vtesti-wrap cc-reveal"
// //                   data-bs-ride="false"
// //                 >
// //                   <div className="carousel-inner">
// //                     {testimonials.map((item, idx) => {
// //                       const prev = idx === 0 ? testimonials.length - 1 : idx - 1;
// //                       const next = idx === testimonials.length - 1 ? 0 : idx + 1;
// //                       const pImg = testimonials[prev]?.profileImage?.replace(/\\/g,"/");
// //                       const nImg = testimonials[next]?.profileImage?.replace(/\\/g,"/");
// //                       const pUrl = pImg?.startsWith("uploads/") ? `https://api.carnivalcastle.com/${pImg}` : pImg;
// //                       const nUrl = nImg?.startsWith("uploads/") ? `https://api.carnivalcastle.com/${nImg}` : nImg;
// //                       return (
// //                         <div key={idx} className={`carousel-item${idx===0?" active":""}`}>
// //                           <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:16, padding:"0 8px" }}>
// //                             {/* Side prev */}
// //                             <div className="vtesti-side d-none d-md-block" style={{ width:130, height:190, backgroundImage:`url(${pUrl})`, backgroundSize:"cover", backgroundPosition:"center" }}>
// //                               <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"flex-end", justifyContent:"center", padding:8 }}>
// //                                 <span style={{ background:"rgba(0,0,0,.7)", color:"#fff", fontSize:11, padding:"3px 8px", borderRadius:6 }}>{testimonials[prev]?.name}</span>
// //                               </div>
// //                             </div>
// //                             {/* Main */}
// //                             <div className="vtesti-main" style={{ flex:"1 1 auto", maxWidth:420 }}>
// //                               <iframe width="100%" height="300"
// //                                 src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1`}
// //                                 title={item.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
// //                               <div style={{ background: C.cream, padding:"14px 16px" }}>
// //                                 <div style={{ fontWeight:700, color: C.primary }}>{item.name}</div>
// //                                 <div style={{ fontSize:12, color:"#888" }}>{item.role}</div>
// //                               </div>
// //                             </div>
// //                             {/* Side next */}
// //                             <div className="vtesti-side d-none d-md-block" style={{ width:130, height:190, backgroundImage:`url(${nUrl})`, backgroundSize:"cover", backgroundPosition:"center" }}>
// //                               <div style={{ width:"100%", height:"100%", display:"flex", alignItems:"flex-end", justifyContent:"center", padding:8 }}>
// //                                 <span style={{ background:"rgba(0,0,0,.7)", color:"#fff", fontSize:11, padding:"3px 8px", borderRadius:6 }}>{testimonials[next]?.name}</span>
// //                               </div>
// //                             </div>
// //                           </div>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                   {/* Indicators */}
// //                   <div className="d-flex justify-content-center gap-2 mt-4">
// //                     {testimonials.map((_, i) => (
// //                       <button key={i} type="button" data-bs-target="#vtCarousel" data-bs-slide-to={i}
// //                         className={i===0?"active":""}
// //                         style={{ width: i===0?26:10, height:10, borderRadius:999, border:"none", background: i===0?C.primary:"rgba(94,14,115,.2)", transition:"all .3s" }}
// //                       />
// //                     ))}
// //                   </div>
// //                 </div>
// //               </div>
// //             </section>
// //           )}

// //           {/* ── TEXT REVIEW CARDS ─────────────────────────────────────── */}
// //           {slides.length > 0 && (
// //             <section className="cc-section cc-section-pale">
// //               <div className="container">
// //                 <div className="text-center cc-reveal" style={{ marginBottom: 48 }}>
// //                   <span className="cc-tag">✦ Customer Love ✦</span>
// //                   <h2 className="cc-heading">What Our <span>Guests Say</span></h2>
// //                   <p className="cc-sub">Real celebrations, real smiles — from our private theatre family.</p>
// //                 </div>
// //                 <div id="reviewCarousel" className="carousel slide cc-reveal" data-bs-interval="5000" data-bs-ride="carousel">
// //                   <div className="carousel-inner">
// //                     {slides.map((group, gIdx) => (
// //                       <div key={gIdx} className={`carousel-item${gIdx===0?" active":""}`}>
// //                         <div className="row g-4 justify-content-center">
// //                           {group.map((rv, rIdx) => (
// //                             <div key={rIdx} className="col-lg-4 col-md-6">
// //                               <div className="testi-card">
// //                                 <img src={rv.image} alt="" className="testi-bg" />
// //                                 <div className="testi-glass">
// //                                   <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
// //                                     <img src={rv.avatar} alt="" style={{ width:44, height:44, borderRadius:"50%", objectFit:"cover", border:`2px solid ${C.primary}` }} />
// //                                     <div>
// //                                       <div className="testi-name">{rv.name}</div>
// //                                       <div className="testi-role">{rv.location}</div>
// //                                     </div>
// //                                   </div>
// //                                   <div className="testi-stars">{"★".repeat(rv.rating)}{"☆".repeat(5-rv.rating)}</div>
// //                                   <p className="testi-desc">{rv.description}</p>
// //                                   {rv.occasion && <div style={{ fontSize:11, color: C.primary, fontWeight:600 }}>🎉 {rv.occasion}</div>}
// //                                 </div>
// //                               </div>
// //                             </div>
// //                           ))}
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                   <div className="d-flex justify-content-center gap-2 mt-4">
// //                     {slides.map((_, i) => (
// //                       <button key={i} type="button" data-bs-target="#reviewCarousel" data-bs-slide-to={i}
// //                         style={{ width: i===0?26:10, height:10, borderRadius:999, border:"none", background: i===0?C.primary:"rgba(94,14,115,.2)", cursor:"pointer" }}
// //                       />
// //                     ))}
// //                   </div>
// //                 </div>
// //               </div>
// //             </section>
// //           )}

// //           {/* ── GALLERY ────────────────────────────────────────────────── */}
// //           <section className="cc-section cc-section-cream" id="gallery">
// //             <div className="container">
// //               <div className="text-center cc-reveal" style={{ marginBottom: 48 }}>
// //                 <span className="cc-tag">✦ Gallery ✦</span>
// //                 <h2 className="cc-heading">See the <span>Magic</span> in Action</h2>
// //                 <p className="cc-sub">Real moments captured at CarnivalCastle Private Theatres.</p>
// //               </div>
// //               <Galleria ref={galleria} value={images} numVisible={6}
// //                 style={{ maxWidth: 850 }} activeIndex={activeGalleria}
// //                 onItemChange={e => setActiveGalleria(e.index)}
// //                 circular fullScreen showItemNavigators showThumbnails={false}
// //                 item={galleryItemTemplate} thumbnail={galleryThumbTemplate}
// //               />
// //               <div className="row g-3 cc-reveal">
// //                 {images.map((img, i) => (
// //                   <div key={i} className="col-6 col-md-4">
// //                     <div className="gal-item" onClick={() => { setActiveGalleria(i); galleria.current.show(); }}>
// //                       <img src={URLS.Base + img.image} alt={img.alt} />
// //                       <div className="gal-zoom"><i className="fas fa-search-plus" /></div>
// //                     </div>
// //                   </div>
// //                 ))}
// //               </div>
// //               <div style={{ display:"flex", gap:12, justifyContent:"center", marginTop:32, flexWrap:"wrap" }}>
// //                 <a href="/gallery" className="cc-btn">View Gallery →</a>
// //                 <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"></i>Chat With Us</a>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── PACKAGES ───────────────────────────────────────────────── */}
// //           <HomePackagesSection navigateTheater={navigate} />

// //           {/* ── COUPONS ────────────────────────────────────────────────── */}
// //           <CouponSection />

// //           {/* ── ENQUIRY FORM ───────────────────────────────────────────── */}
// //           <section className="cc-section" style={{ background: "#fff" }}>
// //             <div className="container">
// //               <div className="row align-items-center g-5">
// //                 {/* Left */}
// //                 <div className="col-lg-5 cc-reveal">
// //                   <span className="cc-tag">✦ Get In Touch ✦</span>
// //                   <h2 className="cc-heading" style={{ marginBottom: 20 }}>Plan Your <span>Perfect Event</span></h2>
// //                   <p style={{ color:"#777", lineHeight:1.8, marginBottom:28 }}>
// //                     Tell us about your occasion and we'll get back to you within 2 hours with a personalised plan.
// //                   </p>
// //                   {[
// //                     { icon:"📞", label:"Call Us", value:"+91 8341428342", href:"tel:8341428342" },
// //                     { icon:"💬", label:"WhatsApp", value:"+91 8341428342", href:"https://wa.me/918341428342" },
// //                     { icon:"📧", label:"Email", value:Contact.email || "hello@carnivalcastle.com", href:`mailto:${Contact.email}` },
// //                     { icon:"📍", label:"Address", value:Contact.address || "Hyderabad, Telangana", href:null },
// //                   ].map((it,i) => (
// //                     <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:14, marginBottom:18 }}>
// //                       <div style={{ width:42, height:42, borderRadius:12, background:C.primaryPale, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18, flexShrink:0 }}>{it.icon}</div>
// //                       <div>
// //                         <div style={{ fontSize:11, color:"#aaa", textTransform:"uppercase", letterSpacing:1, marginBottom:2 }}>{it.label}</div>
// //                         {it.href ? <a href={it.href} style={{ color:C.dark, fontWeight:500, fontSize:14, textDecoration:"none" }}>{it.value}</a>
// //                           : <span style={{ color:C.dark, fontWeight:500, fontSize:14 }}>{it.value}</span>}
// //                       </div>
// //                     </div>
// //                   ))}
// //                 </div>
// //                 {/* Form */}
// //                 <div className="col-lg-7 cc-reveal cc-reveal-d2">
// //                   <div className="enq-form">
// //                     <h3 className="pf" style={{ fontSize:24, fontWeight:700, color:C.dark, marginBottom:4 }}>We'd Love To Hear <span style={{color:C.primary}}>From You!</span></h3>
// //                     <p style={{ color:"#aaa", fontSize:13, marginBottom:24 }}>Fill in the form below and our team will respond promptly.</p>
// //                     <form onSubmit={handleSubmit}>
// //                       <div className="row g-3">
// //                         <div className="col-md-6">
// //                           <label className="enq-label">Name</label>
// //                           <input name="name" value={form.name} onChange={handleChange} placeholder="Your full name" required />
// //                         </div>
// //                         <div className="col-md-6">
// //                           <label className="enq-label">Email</label>
// //                           <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@email.com" required />
// //                         </div>
// //                         <div className="col-md-6">
// //                           <label className="enq-label">Phone</label>
// //                           <input name="mobileNumber" value={form.mobileNumber} onChange={handleChange} placeholder="+91 00000 00000" required />
// //                         </div>
// //                         <div className="col-md-6">
// //                           <label className="enq-label">Event Type</label>
// //                           <input name="eventName" value={form.eventName} onChange={handleChange} placeholder="Birthday, Proposal…" />
// //                         </div>
// //                         <div className="col-12">
// //                           <label className="enq-label">Message</label>
// //                           <textarea name="description" value={form.description} onChange={handleChange} rows={4} placeholder="Tell us about your event…" />
// //                         </div>
// //                         <div className="col-12">
// //                           <button type="submit" className="cc-btn" style={{ width:"100%", padding:"14px", fontSize:15 }}>Send Message →</button>
// //                         </div>
// //                       </div>
// //                     </form>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── FAQ ────────────────────────────────────────────────────── */}
// //           <section className="cc-section cc-section-beige">
// //             <div className="container">
// //               <div className="text-center cc-reveal" style={{ marginBottom: 44 }}>
// //                 <span className="cc-tag">✦ FAQ ✦</span>
// //                 <h2 className="cc-heading">Got <span>Questions?</span></h2>
// //                 <p className="cc-sub">Everything you need to know about celebrating with CarnivalCastle.</p>
// //               </div>
// //               <div className="row justify-content-center">
// //                 <div className="col-md-9 cc-faq cc-reveal">
// //                   <Accordion defaultActiveKey="0">
// //                     {(showAllFaqs ? Faqs : Faqs?.slice(0, 5))?.map((faq, i) => (
// //                       <Accordion.Item key={i} eventKey={String(i)} className="mt-2">
// //                         <Accordion.Header><b>{i + 1}. {faq.question}</b></Accordion.Header>
// //                         <Accordion.Body>{faq.answer}</Accordion.Body>
// //                       </Accordion.Item>
// //                     ))}
// //                   </Accordion>
// //                   {Faqs?.length > 5 && (
// //                     <div className="text-center mt-4" style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
// //                       <button className="cc-btn-outline" onClick={() => setShowAllFaqs(p => !p)}>
// //                         {showAllFaqs ? "View Less" : "View More FAQs"}
// //                       </button>
// //                       <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn">
// //                         <i className="bi bi-whatsapp"></i> Chat With Us
// //                       </a>
// //                     </div>
// //                   )}
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── BRANCHES ───────────────────────────────────────────────── */}
// //           <section className="cc-section-sm" style={{ background: C.primaryPale }}>
// //             <div className="container text-center">
// //               <h2 className="cc-heading cc-reveal" style={{ marginBottom: 32 }}>Our <span>Branches</span></h2>
// //               <div style={{ display:"flex", flexWrap:"wrap", gap:14, justifyContent:"center" }} className="cc-reveal">
// //                 {addresses.map((addr, i) => (
// //                   <a key={i} href={addr.addressLine2} target="_blank" rel="noopener noreferrer" className="branch-pill">
// //                     <div className="branch-icon"><i className="bi bi-geo-alt-fill" style={{ color:"#fff", fontSize:14 }} /></div>
// //                     <div style={{ textAlign:"left" }}>
// //                       <div style={{ fontWeight:700, fontSize:13, color:C.dark, lineHeight:1.3 }}>{addr.name}</div>
// //                     </div>
// //                     <span style={{ color:C.primary, fontSize:12 }}>↗</span>
// //                   </a>
// //                 ))}
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── INSTAGRAM STRIP ────────────────────────────────────────── */}
// //           <section className="cc-section-sm" style={{ background:"#fff" }}>
// //             <div className="container">
// //               <div className="ig-strip cc-reveal">
// //                 <div>
// //                   <h4 className="pf" style={{ fontWeight:700, color:C.dark, marginBottom:4 }}>Follow Our Journey on Instagram</h4>
// //                   <p style={{ color:"#888", margin:0, fontSize:14 }}>Get inspired by our latest creations and behind-the-scenes moments.</p>
// //                 </div>
// //                 <a href="https://www.instagram.com/carnival_castle_hyderabad/" target="_blank" rel="noopener noreferrer"
// //                   style={{ display:"inline-flex", alignItems:"center", gap:8, padding:"11px 22px", borderRadius:50, textDecoration:"none", fontWeight:600, color:"#fff",
// //                     background:"linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",
// //                     boxShadow:"0 6px 20px rgba(0,0,0,.15)" }}>
// //                   <i className="fab fa-instagram" /> carnival_castle_hyderabad
// //                 </a>
// //               </div>
// //             </div>
// //           </section>

// //           {/* ── POPUP MODAL ────────────────────────────────────────────── */}
// //           <PopupModal show={showPopup} handleClose={() => setShowPopup(false)} image={popupImage} />

// //           <ToastContainer />
// //           <Footer />
// //         </div>
// //       </div>

// //       {/* ── Scroll reveal observer ──────────────────────────────────────── */}
// //       <ScrollReveal />
// //     </>
// //   );
// // }

// // // ─── Scroll Reveal Helper ────────────────────────────────────────────────────
// // function ScrollReveal() {
// //   useEffect(() => {
// //     const obs = new IntersectionObserver(
// //       entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("in"); }),
// //       { threshold: 0.1 }
// //     );
// //     document.querySelectorAll(".cc-reveal").forEach(el => obs.observe(el));
// //     return () => obs.disconnect();
// //   }, []);
// //   return null;
// // }

// // export default Home;

// import React, { useState, useEffect, useRef } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Accordion from "react-bootstrap/Accordion";
// import Slider from "react-slick";
// import { URLS } from "../Url";
// import Footer from "./Footer";
// import Header from "./Header";
// import axios from "axios";
// import { Helmet } from "react-helmet";
// import { Galleria } from "primereact/galleria";
// import { useNavigate } from "react-router-dom";
// import CouponSection from "./Coupons";
// import HomePackagesSection from "./PackageSection";
// import PopupModal from "./PopUpModal";
// import TestimonalsSection from './TestimonialsSection';
// import BookingProcess from "./BookingProcess";
// import ReelsSection from "./ReelsSection";
// import VideoTestimonialsSpotlight from "./Videotestimonialsspotlight";
// import theme1 from "./images/banner1.png";
// import theme2 from  './images/theme2.jpeg';
// import theme3 from './images/theme3.jpeg';
// import theme4 from "./images/theme4.jpeg";
// import theme5 from "./images/theme5.jpeg";
// import theme6 from "./images/theme6.jpeg";
// import theme7 from "./images/theme7.jpeg";


// /* ─── Brand palette ─────────────────────────────────────────────────────── */
// const C = {
//   primary:      "#5E0E73",
//   primaryLight: "#6E1A85",
//   primaryPale:  "#F3E5F7",
//   cream:        "#E8E1D6",
//   beige:        "#D6CFC4",
//   gold:         "#C9A84C",
//   goldLight:    "#E8D5A0",
//   dark:         "#1A0030",
//   dark2:        "#120020",
// };

// /* ─── Popup fetch ────────────────────────────────────────────────────────── */
// export const fetchPopupImage = async () => {
//   try {
//     const r = await fetch("https://api.carnivalcastle.com/v1/carnivalApi/admin/popup/getpopupimage?type=CarnivalCastle");
//     const d = await r.json();
//     return d.success && d.data?.length > 0 ? d.data[0] : null;
//   } catch { return null; }
// };

// /* ─── Occasion descriptions ──────────────────────────────────────────────── */
// const occDesc = n => ({
//   "Anniversary":       "Celebrate your love in a private, luxurious theatre with personalised ambiance and exceptional quality.",
//   "Bride To Be":       "Special private screening for the bride-to-be — personalised decor, scrumptious food, luxurious experience.",
//   "Groom To Be":       "Make the groom's last bachelor night memorable with a private screening and intimate theatre experience.",
//   "Dad To Be":         "Celebrate the soon-to-be father in a private setting with custom decor and exceptional service.",
//   "Mom To Be":         "Celebrate the expecting mother with amazing decor, personalised services, and a relaxing experience.",
//   "Love Proposal":     "The perfect surprise proposal — rose petals, candles, and a personalised message on the big screen.",
//   "Marriage Proposal": "Make it official the most cinematic way. Custom decor, your favourite song, frozen in time.",
//   "Farewell":          "Bid farewell in style with a private screening and the perfect personalised ambiance.",
//   "Bon voyage":        "Send off a loved one with a special private screening, gourmet food and personalised decor.",
// }[n] || "CarnivalCastle Private Theatres — intimate, luxurious and unforgettable for every special occasion.");

// /* ─── Static data ────────────────────────────────────────────────────────── */
// const WHY_CARDS = [
//   { icon:"🏆", img:"https://images.unsplash.com/photo-1531498860502-7c67cf519b9e?w=400&q=80", title:"Trained & Certified Staff",  desc:"Every partner clears 6 quality filters before joining our team." },
//   { icon:"📱", img:"https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400&q=80", title:"Easy Booking",              desc:"Book your entire event in under 3 minutes — no complex procedures." },
//   { icon:"💸", img:"https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=400&q=80", title:"Unbeatable Pricing",       desc:"Premium quality experiences starting at just ₹1,999. No hidden fees." },
//   { icon:"🔒", img:"https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&q=80", title:"Safe & Secure",            desc:"Your data, payments and bookings are fully encrypted and protected." },
// ];

// const STAND_OUT = [
//   { 
//     icon: "🎯", 
//     title: "Dedicated Event Supervision",   
//     desc: "A personal coordinator manages every detail smoothly so you can enjoy your special moments stress-free." 
//   },
//   { 
//     icon: "📱", 
//     title: "Instant Event Updates",     
//     desc: "Stay informed with live updates, schedules, and coordination progress throughout the event." 
//   },
//   { 
//     icon: "✨", 
//     title: "Premium Guest Experience",   
//     desc: "From welcoming guests to handling special requests, we ensure every attendee feels valued." 
//   },
//   { 
//     icon: "🛡️", 
//     title: "Reliable & Professional Team",     
//     desc: "Experienced coordinators trained to handle timelines, vendors, and unexpected situations with ease." 
//   },
// ];

// const EXTRA_FEATS = [
//   { icon:"🍽️", title:"Customisable Menus",     desc:"Tailor every dish to your event theme, dietary needs and guest preferences." },
//   { icon:"📉", title:"Dynamic Pricing",        desc:"Price per plate decreases as your guest count increases — save more together." },
//   { icon:"👔", title:"Personal Order Exec",    desc:"A single dedicated contact for all order details, ensuring smooth personalised service." },
//   { icon:"📦", title:"Order Status Updates",   desc:"Real-time updates on your order from preparation all the way through to delivery." },
// ];

// const THEMES = [
//   { name:"Royal Maharaja",   bookings:"312 bookings",  tags:["Ethnic","Grand","Gold"],  img:theme1 },
//   { name:"Midnight Galaxy",  bookings:"189 bookings",  tags:["Dark","Stars","Neon"],   img:theme2 },
//   { name:"Pastel Wonderland",bookings:"276 bookings",  tags:["Cute","Soft","Kids"],    img:theme3 },
//   { name:"Enchanted Forest", bookings:"234 bookings",  tags:["Nature","Lush","Boho"],  img:theme4 },
//   { name:"Vintage Garden",   bookings:"158 bookings",  tags:["Rustic","Flowers","Outdoor"], img:theme5 },
// ];

// const SELLERS = [
//   { name:"Black Forest Cake",    meta:"1 Kg • Serves 8–10",   price:"₹1,299", orig:"₹1,699", label:"Bestseller", img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=500&q=80" },
//   { name:"Fog Entry (1 Pot)",    meta:"Dramatic entry effect", price:"₹499",   orig:"₹799",  label:"Top Rated",  img:"https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=500&q=80" },
//   { name:"Rose Bouquet (12 Roses)", meta:"Fresh floral bouquet", price:"₹849", orig:"₹1,199", label:"Trending", img:"https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=500&q=80" },
//   { name:"Cold Fire Entry (6 pcs)", meta:"Cinematic fire effect", price:"₹699", orig:"₹999", label:"Premium",   img:"https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=500&q=80" },
// ];

// const REELS = [
//   { views:"124K", title:"Royal Birthday Setup",   img:"https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=400&q=80" },
//   { views:"89K",  title:"Surprise Proposal",      img:"https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=400&q=80" },
//   { views:"67K",  title:"Anniversary Night",       img:"https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=400&q=80" },
//   { views:"203K", title:"Fog Entry Magic",         img:"https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&q=80" },
//   { views:"45K",  title:"Cake Cutting Moment",    img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=400&q=80" },
//   { views:"91K",  title:"Floral Decor Setup",     img:"https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=400&q=80" },
//   { views:"78K",  title:"Kids Birthday Party",    img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=400&q=80" },
// ];

// const SERVICE_CARDS = [
//   { label:"Food & Beverages", img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80", href:"/Food",  desc:"Choose the perfect food combo for your celebration." },
//   { label:"Cakes",            img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80", href:"/cakes", desc:"Choose the perfect cake from our delicious selection." },
//   { label:"Screening",        img:"https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80", href:null,    desc:"Bring your OTT account and relive the theatre magic!" },
//   { label:"Bouquets",         img:"https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=600&q=80", href:null,    desc:"Add a beautiful rose bouquet to your celebration." },
// ];

// const EVENT_TYPES = ["Birthday Celebration","Love Proposal","Marriage Proposal","Anniversary","Bride To Be","Groom To Be","Birthday Surprise","Mom To Be","Dad To Be","Farewell Party","Baby Shower","Kitty Party"];

// /* ══════════════════════════════════════════════════════════════════════════ */
// function Home() {

//   /* ── state ── */
//   const [isLoading,     setIsLoading]     = useState(true);
//   const [Faqs,          setFaqs]          = useState([]);
//   const [Highlights,    setHighlights]    = useState({});
//   const [Contact,       setContact]       = useState({});
//   const [PopUp1,        setPopUp1]        = useState({});
//   const [images,        setImages]        = useState([]);
//   const [occasions,     setOccasions]     = useState([]);
//   const [addresses,     setAddresses]     = useState([]);
//   const [testimonials,  setTestimonials]  = useState([]);
//   const [slides,        setSlides]        = useState([]);
//   const [banner,        setBanner]        = useState(null);
//   const [bannerIdx,     setBannerIdx]     = useState(0);
//   const [showAllFaqs,   setShowAllFaqs]   = useState(false);
//   const [showPopup,     setShowPopup]     = useState(false);
//   const [popupImage,    setPopupImage]    = useState("");
//   const [whyIdx,        setWhyIdx]        = useState(0);
//   const [reelOff,       setReelOff]       = useState(0);
//   const [themeOff,      setThemeOff]      = useState(0);
//   const [activeGal,     setActiveGal]     = useState(0);
//   const [form, setform] = useState({ name:"", email:"", mobileNumber:"", description:"", eventName:"" });
//   const [formStep, setFormStep] = useState(0); // multi-step form

//   const galleria   = useRef(null);
//   const navigate   = useNavigate();
//   const whyRef     = useRef(null);

//   /* ── whyUs slides ── */
//   // const WHY_SLIDES = [
//   //   { image: Highlights?.image ? URLS.Base + Highlights.image : "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg",
//   //     subtitle:"At CarnivalCastle, we believe every celebration deserves a cinematic experience — intimate, exclusive and unforgettable.",
//   //     points:["Perfect for Every Occasion: Themed decorations, cakes, fog effects & photography.","Luxurious Ambience: Recliners, premium sound, elegant decor.","Budget-Friendly Luxury: Combo offers & rewards for every budget.","Prime Location in Hyderabad: Easily accessible, cozy, and convenient.","End-to-End Convenience: WhatsApp support, décor add-ons & great food."] },
//   //   { image:"https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg",
//   //     subtitle:"Experience celebrations like never before in our private theatres — where entertainment meets exclusivity.",
//   //     points:["Customizable Packages: Tailor your party exactly how you like it.","Gourmet Snacks & Beverages: From popcorn to premium platters.","Full HD Projector & Sound: A real theatre vibe, privately yours.","Cozy for Everyone: Perfect for couples, families, and friends.","Hassle-Free Booking: Fast, flexible & fully digital!"] },
//   //   { image:"https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg",
//   //     subtitle:"From surprise proposals to baby showers — bring your vision to life in an immersive, themed theatre setting.",
//   //     points:["Baby Showers, Anniversaries & More: Celebrate every milestone.","Themed Decor & Props: Transform the space into your dream setting.","Memorable Photo Zones: Instagram-worthy backdrops included.","Night or Day Slots: Flexible celebration timings.","Personalized Assistance: Our team helps plan every detail."] },
//   // ];


//   const WHY_SLIDES = [
//   {
//     image: Highlights?.image ? URLS.Base + Highlights.image : "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg",
//     subtitle: "Every celebration deserves an intimate, cinematic experience.",
//     points: [
//       "Themed décor, cakes, fog effects & photography.",
//       "Premium recliners, sound & elegant ambience.",
//       "Combo offers & rewards for every budget.",
//       "WhatsApp support, décor add-ons & great food.",
//     ],
//   },
//   {
//     image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132797148-DSC07601.jpg",
//     subtitle: "Private theatres where entertainment meets exclusivity.",
//     points: [
//       "Customizable packages tailored to your party.",
//       "Gourmet snacks — from popcorn to premium platters.",
//       "Full HD projector & surround sound, all yours.",
//       "Fast, flexible & fully digital booking.",
//     ],
//   },
//   {
//     image: "https://api.carnivalcastle.com/uploads/galleryImg/1728132803817-DSC07593.jpg",
//     subtitle: "Bring your vision to life — from proposals to baby showers.",
//     points: [
//       "Birthdays, anniversaries, baby showers & more.",
//       "Themed décor & Instagram-worthy photo zones.",
//       "Flexible day & night slots.",
//       "Personalized team assistance for every detail.",
//     ],
//   },
// ];

//   /* ── fetches ── */
//   useEffect(() => {
//     axios.post(URLS.AllModules, {}).then(r => {
//       if (r.status === 200) {
//         setFaqs(r.data.faqs); setContact(r.data.contactus?.[0] || {});
//         setHighlights(r.data.highlight?.[0] || {}); setPopUp1(r.data.popup?.[0] || {});
//         setIsLoading(false);
//       }
//     }).catch(() => setIsLoading(false));
//     axios.post(URLS.GetAllGallery, {}).then(r => { if (r.status===200) setImages(r.data.gallerys?.slice(0,6)||[]); });
//     axios.post(URLS.GetAllOccation, {}).then(r => { if (r.status===200) setOccasions(r.data?.occasions||[]); });
//     axios.get("https://api.carnivalcastle.com/v1/carnivalApi/admin/address/alladdress").then(r => { if (r.data?.success) setAddresses(r.data.data||[]); });
//     axios.post("https://api.carnivalcastle.com/v1/carnivalApi/admin/testimonial/getalltestimoni?websiteFor=carnivalcastle").then(r => {
//       if (r.data?.success && Array.isArray(r.data.testimoni)) {
//         setTestimonials(r.data.testimoni.filter(t => t.status==="active" && t.videoId?.trim()));
//         const fmt = r.data.testimoni.filter(t=>t.status==="active").map(t=>({ name:t.name, location:t.role||"Customer", rating:Number(t.rating)||5, description:t.description||"", image:`https://api.carnivalcastle.com/${t.image}`, avatar:`https://api.carnivalcastle.com/${t.profileImage}`, occasion:t.type==="Yes"?"Special Celebration":"" }));
//         const grouped=[]; for(let i=0;i<fmt.length;i+=3) grouped.push(fmt.slice(i,i+3)); setSlides(grouped);
//       }
//     });
//     axios.get("https://api.carnivalcastle.com/v1/carnivalApi/admin/get-banners?type=carnivalcastle").then(r => { if(r.data.success&&r.data.banners.length>0) setBanner(r.data.banners[0]); });
//     fetchPopupImage().then(p => { if(p?.modalEnabled){setPopupImage(p.image);setShowPopup(true);} });
//   }, []);

//   useEffect(() => { if(!banner?.desktopImages?.length) return; const t=setInterval(()=>setBannerIdx(p=>(p+1)%banner.desktopImages.length),3500); return()=>clearInterval(t); }, [banner]);
//   useEffect(() => { whyRef.current=setInterval(()=>setWhyIdx(i=>(i+1)%WHY_SLIDES.length),6000); return()=>clearInterval(whyRef.current); }, []);
//   useEffect(() => { const t=setInterval(()=>setReelOff(o=>(o+1)%REELS.length),2800); return()=>clearInterval(t); }, []);
//   useEffect(() => { const t=setInterval(()=>setThemeOff(o=>(o+1)%THEMES.length),3500); return()=>clearInterval(t); }, []);

//   /* ── handlers ── */
//   const handleChange = e => setform(f=>({...f,[e.target.name]:e.target.value}));
//   const handleSubmit = e => {
//     e.preventDefault();
//     axios.post(URLS.AddEnquiry, form).then(r => {
//       if (r.status===200) { toast.success(r.data.message); setform({name:"",email:"",mobileNumber:"",description:"",eventName:""}); setFormStep(0); }
//     }).catch(err => { if(err.response?.status===400) toast.error(err.response.data.message); });
//   };
//   const handleWhySelect = i => { clearInterval(whyRef.current); setWhyIdx(i); whyRef.current=setInterval(()=>setWhyIdx(j=>(j+1)%WHY_SLIDES.length),6000); };

//   /* ── slick configs ── */
//   const occSlick = { dots:false,infinite:true,speed:500,slidesToShow:3,slidesToScroll:1,autoplay:true,autoplaySpeed:3000, responsive:[{breakpoint:992,settings:{slidesToShow:2}},{breakpoint:576,settings:{slidesToShow:1}}] };
//   const svcSlick = { dots:false,infinite:true,arrows:true,speed:600,slidesToShow:4,slidesToScroll:1,autoplay:true,autoplaySpeed:3500, responsive:[{breakpoint:1200,settings:{slidesToShow:3}},{breakpoint:768,settings:{slidesToShow:2}},{breakpoint:480,settings:{slidesToShow:1}}] };
//   const reelTx   = `translateX(calc(-${reelOff*(180+14)}px))`;
//   const themeTx  = `translateX(calc(-${themeOff*(280+18)}px))`;

//   const galItem  = item => <img src={URLS.Base+item.image} alt={item.alt} style={{width:"100%",display:"block"}} />;
//   const galThumb = item => <img src={URLS.Base+item.image} alt={item.alt} style={{display:"block"}} />;

//   /* ── Loading ── */
//   if (isLoading) return (
//     <div style={{background:C.dark,height:"100vh",display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>
//       <img src="assets/img/giff.gif" style={{height:280}} alt="loading"/>
//       <p style={{color:C.gold,marginTop:12,fontWeight:600,letterSpacing:2}}>Loading…</p>
//     </div>
//   );

//   /* ══════════════════════════════════════════════════════════════════════════ */
//   return (
//     <>
//       <Helmet>
//         <title>Carnival Castle | Best Private Theaters for Celebrations in Hyderabad</title>
//         <meta name="description" content="Experience the magic of celebrations at Carnival Castle Private Theatres in Hyderabad. Perfect for Birthdays, Anniversaries, Bride To Be, Surprise Parties, etc"/>
//       </Helmet>

//       {/* ──────────────── GLOBAL STYLES ────────────────────────────────── */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600&display=swap');
//         :root{--p:${C.primary};--pl:${C.primaryLight};--pp:${C.primaryPale};--cream:${C.cream};--beige:${C.beige};--gold:${C.gold};--gl:${C.goldLight};--dark:${C.dark};--dark2:${C.dark2};}
//         body{font-family:'DM Sans',sans-serif!important;background:var(--cream);}
//         .pf{font-family:'Playfair Display',serif!important;}

//         /* buttons */
//         .cc-btn{background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;box-shadow:0 6px 20px rgba(94,14,115,.35);text-decoration:none;display:inline-block;}
//         .cc-btn:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(94,14,115,.45);color:#fff;}
//         .cc-btn-outline{background:transparent;color:var(--p);border:2px solid var(--p);border-radius:50px;padding:11px 26px;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;text-decoration:none;display:inline-block;}
//         .cc-btn-outline:hover{background:var(--p);color:#fff;}
//         .cc-btn-gold{background:linear-gradient(135deg,var(--gold),#A07830);color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;text-decoration:none;display:inline-block;box-shadow:0 6px 20px rgba(201,168,76,.35);}
//         .cc-btn-gold:hover{transform:translateY(-2px);color:#fff;}
//         .wa-btn{background:#25D366;color:#fff;border:none;border-radius:50px;padding:13px 28px;font-weight:700;font-size:14px;cursor:pointer;transition:all .25s;text-decoration:none;display:inline-flex;align-items:center;gap:8px;box-shadow:0 6px 20px rgba(37,211,102,.3);}
//         .wa-btn:hover{background:#1ebe5d;transform:translateY(-2px);color:#fff;}

//         /* layout */
//         .cc-sec{padding:72px 0;}
//         .cc-sec-sm{padding:48px 0;}
//         .cc-sec-dark{background:var(--dark)!important;}
//         .cc-sec-dark2{background:var(--dark2)!important;}
//         .cc-sec-cream{background:var(--cream)!important;}
//         .cc-sec-beige{background:var(--beige)!important;}
//         .cc-sec-pale{background:var(--pp)!important;}
//         .cc-sec-white{background:#fff!important;}

//         /* headings */
//         .cc-tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:3px;text-transform:uppercase;color:var(--gold);margin-bottom:10px;}
//         .cc-tag-light{color:var(--gl)!important;}
//         .cc-h{font-family:'Playfair Display',serif;font-size:clamp(26px,4vw,44px);font-weight:700;line-height:1.2;color:var(--dark);}
//         .cc-h-white{color:#fff!important;}
//         .cc-h span{color:var(--p);}
//         .cc-h span.gold{color:var(--gold)!important;-webkit-text-fill-color:unset!important;}
//         .cc-sub{color:#777;font-size:15px;line-height:1.7;max-width:540px;margin:10px auto 0;}
//         .cc-sub-light{color:rgba(255,255,255,.55)!important;}

//         /* scroll reveal */
//         .rv{opacity:0;transform:translateY(32px);transition:opacity .65s ease,transform .65s ease;}
//         .rv.in{opacity:1;transform:translateY(0);}
//         .rv.d1{transition-delay:.1s!important;}.rv.d2{transition-delay:.2s!important;}.rv.d3{transition-delay:.3s!important;}.rv.d4{transition-delay:.4s!important;}

//         /* hero */
//         .cc-hero{position:relative;height:88vh;min-height:500px;overflow:hidden;}
//         .cc-hero-img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transition:opacity 1s ease;}
//         .cc-hero-ovl{position:absolute;inset:0;background:linear-gradient(135deg,rgba(26,0,48,.85) 0%,rgba(94,14,115,.45) 55%,rgba(26,0,48,.3) 100%);}
//         .cc-hero-cnt{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center;width:90%;max-width:800px;z-index:3;}
//         .cc-hero-h{font-family:'Playfair Display',serif;font-size:clamp(32px,6vw,72px);font-weight:900;color:#fff;line-height:1.08;text-shadow:0 4px 24px rgba(0,0,0,.4);}
//         .cc-hero-h span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
//         .cc-hero-sub{color:rgba(255,255,255,.8);font-size:clamp(14px,2vw,18px);margin:14px 0 28px;}
//         .cc-hdot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,.4);border:none;cursor:pointer;transition:all .3s;}
//         .cc-hdot.on{background:var(--gold);width:24px;border-radius:4px;}
//         @media(max-width:768px){.cc-hero{height:70vh;}}

//         /* announce */
//         .cc-announce{background:var(--p);padding:9px 0;}
//         .cc-announce marquee{color:#fff;font-weight:600;font-size:13px;}

//         /* offer */
//         .cc-offer{border-radius:22px;background:linear-gradient(135deg,var(--dark) 0%,var(--p) 55%,var(--dark) 100%);padding:44px 52px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 20px 60px rgba(94,14,115,.4);position:relative;overflow:hidden;margin:40px 0;}
//         .cc-offer::before{content:'';position:absolute;inset:0;background:url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4z'/%3E%3C/g%3E%3C/svg%3E");}
//         .cc-offer-h{font-family:'Playfair Display',serif;font-size:clamp(30px,5vw,56px);font-weight:900;color:#fff;line-height:1;margin-bottom:6px;}
//         .cc-offer-h span{background:linear-gradient(135deg,var(--gl),var(--cream));-webkit-background-clip:text;-webkit-text-fill-color:transparent;}
//         .cc-offer-code{display:inline-flex;align-items:center;gap:10px;background:rgba(255,255,255,.08);border:1.5px dashed rgba(201,168,76,.5);padding:10px 18px;border-radius:10px;color:#fff;font-size:14px;font-weight:600;}
//         .cc-offer-code b{background:var(--gold);color:var(--dark);padding:3px 12px;border-radius:6px;font-family:monospace;}
//         .cc-ring{width:175px;height:175px;border-radius:50%;border:1.5px solid rgba(201,168,76,.3);display:flex;align-items:center;justify-content:center;flex-direction:column;text-align:center;animation:spinslow 20s linear infinite;flex-shrink:0;background:rgba(201,168,76,.07);}
//         @keyframes spinslow{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}
//         @media(max-width:768px){.cc-offer{margin:24px 16px;padding:28px 22px;flex-direction:column;gap:20px;text-align:center;}.cc-ring{display:none;}}

//         /* occasion cards */
//         .occ-card{position:relative;border-radius:18px;overflow:hidden;cursor:pointer;height:300px;transition:transform .35s,box-shadow .35s;}
//         .occ-card:hover{transform:translateY(-7px);box-shadow:0 20px 56px rgba(94,14,115,.22);}
//         .occ-card img{width:100%;height:100%;object-fit:cover;transition:transform .5s;}
//         .occ-card:hover img{transform:scale(1.07);}
//         .occ-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.96) 0%,rgba(26,0,48,.25) 55%,transparent 100%);display:flex;flex-direction:column;justify-content:flex-end;padding:20px;transition:background .35s;}
//         .occ-card:hover .occ-ovl{background:linear-gradient(to top,rgba(94,14,115,.97) 0%,rgba(110,26,133,.5) 55%,transparent 100%);}
//         .occ-badge{display:inline-block;background:var(--gold);color:var(--dark);font-size:9px;font-weight:800;letter-spacing:1px;text-transform:uppercase;padding:3px 10px;border-radius:50px;margin-bottom:8px;}
//         .occ-title{font-family:'Playfair Display',serif;color:#fff;font-size:18px;font-weight:700;}
//         .occ-desc{color:rgba(255,255,255,.75);font-size:12px;line-height:1.6;max-height:0;overflow:hidden;transition:max-height .4s ease,margin-top .3s;}
//         .occ-card:hover .occ-desc{max-height:80px;margin-top:8px;}
//         .occ-bk{opacity:0;transform:translateY(8px);transition:opacity .3s,transform .3s;background:var(--gold);color:var(--dark);border:none;border-radius:50px;font-size:11px;font-weight:700;padding:6px 14px;cursor:pointer;margin-top:8px;font-family:'DM Sans',sans-serif;}
//         .occ-card:hover .occ-bk{opacity:1;transform:translateY(0);}

//         /* services */
//         .svc-card{border-radius:18px;overflow:hidden;cursor:pointer;transition:transform .35s,box-shadow .35s;}
//         .svc-card:hover{transform:translateY(-6px);box-shadow:0 16px 48px rgba(94,14,115,.18);}
//         .svc-img{width:100%;height:220px;object-fit:cover;transition:transform .5s;display:block;}
//         .svc-card:hover .svc-img{transform:scale(1.06);}
//         .svc-body{background:var(--cream);padding:18px;}
//         .svc-title{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;color:var(--p);margin-bottom:5px;}
//         .svc-desc{font-size:13px;color:#888;line-height:1.5;}

//         /* why dark cards */
//         .why-dk-card{background:rgba(255,255,255,.04);border:1px solid rgba(155,59,184,.2);border-radius:20px;display:flex;align-items:stretch;overflow:hidden;transition:transform .35s,box-shadow .35s,border-color .35s;position:relative;}
//         .why-dk-card:hover{transform:translateY(-6px);box-shadow:0 20px 60px rgba(94,14,115,.25);border-color:rgba(155,59,184,.5);}
//         .why-dk-img{width:110px;flex-shrink:0;object-fit:cover;filter:grayscale(20%);transition:filter .35s,transform .35s;}
//         .why-dk-card:hover .why-dk-img{filter:grayscale(0%);transform:scale(1.04);}
//         .why-dk-body{padding:22px 18px;display:flex;flex-direction:column;justify-content:center;}
//         .why-dk-title{font-size:16px;font-weight:700;color:var(--gl);margin-bottom:6px;}
//         .why-dk-desc{color:rgba(255,255,255,.6);font-size:13px;line-height:1.6;}

//         /* standout features slider */
//         .stand-card{flex-shrink:0;width:260px;background:rgba(255,255,255,.04);border:1px solid rgba(155,59,184,.15);border-radius:20px;padding:26px 20px;transition:transform .3s,border-color .3s,box-shadow .3s;}
//         .stand-card:hover{transform:translateY(-6px);border-color:rgba(155,59,184,.5);box-shadow:0 16px 48px rgba(94,14,115,.2);}
//         .stand-icon{width:52px;height:52px;border-radius:14px;background:linear-gradient(135deg,rgba(201,168,76,.15),rgba(94,14,115,.15));border:1px solid rgba(201,168,76,.2);display:flex;align-items:center;justify-content:center;font-size:22px;margin-bottom:14px;transition:transform .3s;}
//         .stand-card:hover .stand-icon{transform:scale(1.1) rotate(5deg);}
//         .stand-title{color:#fff;font-size:16px;font-weight:700;margin-bottom:6p x;}
//         .stand-desc{color:rgba(255,255,255,.5);font-size:13px;line-height:1.55;}

//         /* feat grid cards */
//         .feat-card{background:rgba(255,255,255,.03);border:1px solid rgba(201,168,76,.2);border-radius:18px;padding:22px;display:flex;align-items:flex-start;gap:14px;transition:transform .3s,background .3s,border-color .3s;}
//         .feat-card:hover{transform:translateY(-4px);background:rgba(201,168,76,.05);border-color:rgba(201,168,76,.4);}

//         /* why us (light) */
//         .why-lt-card{background:#fff;border-radius:28px;padding:clamp(24px,4vw,48px);box-shadow:0 20px 56px rgba(94,14,115,.09);border:1px solid rgba(94,14,115,.07);}
//         .why-lt-img{border-radius:20px;overflow:hidden;box-shadow:0 16px 40px rgba(94,14,115,.18);}
//         .why-lt-img img{width:100%;height:clamp(250px,35vw,440px);object-fit:cover;transition:transform .5s;display:block;}
//         .why-lt-img:hover img{transform:scale(1.03);}
//         .why-underline{position:relative;padding-bottom:12px;}
//         .why-underline::after{content:'';position:absolute;bottom:0;left:0;width:64px;height:3px;background:linear-gradient(90deg,var(--p),var(--gold));border-radius:2px;}
//         .why-pt{display:flex;align-items:flex-start;gap:12px;margin-bottom:14px;}
//         .why-pt-ic{width:30px;height:30px;border-radius:8px;background:var(--pp);display:flex;align-items:center;justify-content:center;flex-shrink:0;}
//         .why-dot{width:10px;height:10px;border-radius:50%;border:none;cursor:pointer;transition:all .3s;}
//         .why-dot.on{width:32px;border-radius:5px;background:linear-gradient(90deg,var(--p),var(--gold))!important;}

//         /* reels */
//         .reel-card{flex-shrink:0;width:180px;aspect-ratio:9/16;border-radius:16px;overflow:hidden;position:relative;background:#2D1B69;cursor:pointer;transition:transform .3s;}
//         .reel-card:hover{transform:scale(1.04);}
//         .reel-thumb{width:100%;height:100%;object-fit:cover;opacity:.8;}
//         .reel-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.8) 0%,transparent 50%);display:flex;flex-direction:column;justify-content:flex-end;padding:14px;}
//         .reel-play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:42px;height:42px;border-radius:50%;background:rgba(255,255,255,.18);backdrop-filter:blur(8px);border:2px solid rgba(255,255,255,.5);display:flex;align-items:center;justify-content:center;font-size:15px;transition:background .2s;}
//         .reel-card:hover .reel-play{background:var(--p);}
//         .reel-views{color:var(--gl);font-size:11px;font-weight:600;}
//         .reel-title{color:#fff;font-size:11px;margin-top:2px;}

//         /* themes */
//         .theme-card{flex-shrink:0;width:280px;border-radius:18px;overflow:hidden;position:relative;cursor:pointer;transition:transform .3s;}
//         .theme-card:hover{transform:translateY(-6px);}
//         .theme-img{width:100%;height:340px;object-fit:cover;transition:transform .5s;display:block;}
//         .theme-card:hover .theme-img{transform:scale(1.06);}
//         .theme-ovl{position:absolute;inset:0;background:linear-gradient(to top,rgba(26,0,48,.92) 0%,transparent 55%);display:flex;flex-direction:column;justify-content:flex-end;padding:22px;}
//         .theme-name{font-family:'Playfair Display',serif;color:#fff;font-size:19px;font-weight:700;margin-bottom:4px;}
//         .theme-booked{color:var(--gl);font-size:12px;font-weight:500;}
//         .theme-tag{background:rgba(255,255,255,.12);backdrop-filter:blur(4px);color:rgba(255,255,255,.8);font-size:10px;padding:3px 10px;border-radius:50px;border:1px solid rgba(255,255,255,.15);}

//         /* sellers */
//         .seller-card{border-radius:18px;overflow:hidden;background:var(--cream);box-shadow:0 4px 20px rgba(94,14,115,.08);border:1px solid rgba(94,14,115,.08);transition:transform .3s,box-shadow .3s;cursor:pointer;}
//         .seller-card:hover{transform:translateY(-6px);box-shadow:0 16px 48px rgba(94,14,115,.15);}
//         .seller-img-w{position:relative;aspect-ratio:1;overflow:hidden;}
//         .seller-img{width:100%;height:100%;object-fit:cover;transition:transform .4s;}
//         .seller-card:hover .seller-img{transform:scale(1.08);}
//         .seller-lbl{position:absolute;top:10px;left:10px;background:linear-gradient(135deg,var(--p),var(--pl));color:#fff;font-size:9px;font-weight:700;letter-spacing:1px;text-transform:uppercase;padding:3px 10px;border-radius:50px;}
//         .seller-info{padding:16px;}
//         .seller-name{font-family:'Playfair Display',serif;font-size:16px;font-weight:700;color:var(--dark);margin-bottom:3px;}
//         .seller-meta{font-size:11px;color:#999;margin-bottom:8px;}
//         .seller-price{font-size:19px;font-weight:700;color:var(--p);}
//         .seller-price s{font-size:12px;color:#bbb;font-weight:400;margin-right:5px;}
//         .seller-add{float:right;background:var(--pp);color:var(--p);border:none;padding:7px 14px;border-radius:50px;font-size:11px;font-weight:700;cursor:pointer;transition:background .2s,color .2s;}
//         .seller-add:hover{background:var(--p);color:#fff;}

//         /* testimonials */
//         .testi-card{position:relative;border-radius:18px;overflow:hidden;height:400px;transition:transform .35s;}
//         .testi-card:hover{transform:translateY(-5px);}
//         .testi-card img.t-bg{width:100%;height:100%;object-fit:cover;filter:brightness(62%);display:block;}
//         .t-glass{position:absolute;bottom:0;left:50%;transform:translateX(-50%);width:92%;padding:16px 16px 18px;background:rgba(232,225,214,.93);backdrop-filter:blur(8px);border-radius:16px 16px 0 0;}
//         .t-stars{color:var(--gold);letter-spacing:1px;font-size:13px;}
//         .t-desc{font-size:12px;color:#333;line-height:1.6;margin:5px 0;}
//         .t-name{font-weight:700;font-size:13px;color:var(--p);}
//         .t-role{font-size:11px;color:#888;}

//         /* gallery */
//         .gal-item{position:relative;border-radius:14px;overflow:hidden;height:250px;cursor:pointer;}
//         .gal-item img{width:100%;height:100%;object-fit:cover;transition:transform .45s;}
//         .gal-item:hover img{transform:scale(1.08);}
//         .gal-zoom{position:absolute;inset:0;background:rgba(94,14,115,.35);display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s;}
//         .gal-item:hover .gal-zoom{opacity:1;}
//         .gal-zoom i{color:#fff;font-size:26px;}
//         @media(max-width:768px){.gal-item{height:190px;}}

//         /* FAQ */
//         .cc-faq .accordion-item{background:#fff;border:1px solid rgba(94,14,115,.1)!important;border-radius:14px!important;margin-bottom:10px;overflow:hidden;}
//         .cc-faq .accordion-button{font-weight:600;color:var(--dark);background:#fff;border-radius:14px!important;font-size:14px;}
//         .cc-faq .accordion-button:not(.collapsed){color:var(--p);background:var(--pp);box-shadow:none;}
//         .cc-faq .accordion-button:focus{box-shadow:none;}

//         /* branches */
//         .branch-pill{display:inline-flex;align-items:center;gap:10px;background:#fff;border:1.5px solid rgba(94,14,115,.12);border-radius:999px;padding:10px 20px 10px 12px;text-decoration:none;cursor:pointer;box-shadow:0 4px 16px rgba(94,14,115,.1);transition:all .25s ease;}
//         .branch-pill:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(94,14,115,.2);border-color:rgba(94,14,115,.3);}
//         .branch-ic{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,var(--p),var(--pl));display:flex;align-items:center;justify-content:center;flex-shrink:0;}

//         /* ── PREMIUM FORM ── */
//         .enq-wrap{background:var(--dark);border-radius:28px;overflow:hidden;box-shadow:0 24px 60px rgba(94,14,115,.4);}
//         .enq-left{background:linear-gradient(160deg,var(--p) 0%,var(--dark) 100%);padding:48px 36px;display:flex;flex-direction:column;justify-content:space-between;}
//         .enq-right{background:#fff;padding:44px 40px;}
//         .enq-step-bar{display:flex;gap:6px;margin-bottom:28px;}
//         .enq-step{flex:1;height:4px;border-radius:2px;background:rgba(255,255,255,.15);transition:background .3s;}
//         .enq-step.done{background:var(--gold);}
//         .enq-field{margin-bottom:20px;}
//         .enq-label{display:block;font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px;}
//         .enq-input{width:100%;background:var(--cream);border:1.5px solid rgba(94,14,115,.12);border-radius:12px;padding:14px 18px;font-size:14px;font-family:'DM Sans',sans-serif;outline:none;transition:border-color .2s,box-shadow .2s;color:var(--dark);}
//         .enq-input:focus{border-color:var(--p);box-shadow:0 0 0 3px rgba(94,14,115,.08);}
//         .enq-select{appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%235E0E73' stroke-width='2' fill='none'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 16px center;}
//         .enq-occasion-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:20px;}
//         .enq-occ-chip{padding:10px 12px;border-radius:10px;border:1.5px solid rgba(94,14,115,.15);background:var(--cream);font-size:12px;font-weight:600;color:var(--dark);cursor:pointer;text-align:center;transition:all .2s;}
//         .enq-occ-chip:hover,.enq-occ-chip.sel{background:var(--pp);border-color:var(--p);color:var(--p);}
//         .enq-contact-info{display:flex;align-items:center;gap:12px;padding:14px 16px;background:rgba(255,255,255,.07);border-radius:14px;margin-bottom:12px;}
//         .enq-ci-icon{width:40px;height:40px;border-radius:10px;background:rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;font-size:17px;flex-shrink:0;}
//         .enq-ci-label{font-size:10px;color:rgba(255,255,255,.5);text-transform:uppercase;letter-spacing:.5px;margin-bottom:2px;}
//         .enq-ci-val{font-size:13px;color:#fff;font-weight:500;}
//         @media(max-width:991px){.enq-left{padding:32px 24px;}.enq-right{padding:28px 20px;}}
//         @media(max-width:576px){.cc-sec{padding:48px 0;}.enq-occasion-grid{grid-template-columns:1fr 1fr 1fr;}}

//         /* slick arrows */
//         .slick-prev:before,.slick-next:before{color:var(--p)!important;font-size:24px!important;}

//         /* ig strip */
//         .ig-strip{border-radius:20px;padding:26px 32px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:16px;background:linear-gradient(135deg,var(--pp),var(--beige));border:1px solid rgba(94,14,115,.1);}
//         @media(max-width:576px){.ig-strip{padding:20px 18px;text-align:center;justify-content:center;}}
//       `}</style>

//       {/* ─── ScrollReveal watcher ─────────────────────────────────────── */}
//       <ScrollRevealWatcher />

//       <div className="home-page">
//         <div className="main-wrapper">
//           <Header />

//           {/* ══ 1. ANNOUNCE BAR ══════════════════════════════════════════ */}
//           {PopUp1?.modalEnabled && (
//             <div className="cc-announce">
//               <marquee>{PopUp1.title}</marquee>
//             </div>
//           )}

//           {/* ══ 2. HERO BANNER ═══════════════════════════════════════════ */}
//           {banner && (
//             <section className="cc-hero">
//               {banner.desktopImages.map((img,i) => (
//                 <img key={i} src={`https://api.carnivalcastle.com/${img}`} alt="" className="cc-hero-img"
//                   style={{opacity:i===bannerIdx?1:0,zIndex:i===bannerIdx?1:0}} />
//               ))}
//               <div className="cc-hero-ovl" style={{zIndex:2}} />
//               <div className="cc-hero-cnt">
//                 <p style={{fontSize:11,letterSpacing:4,textTransform:"uppercase",color:C.goldLight,marginBottom:12,fontWeight:600}}>✦ Private Theatre Celebrations ✦</p>
//                 <h1 className="cc-hero-h" dangerouslySetInnerHTML={{__html:banner.title||"Your Special Moment <span>Deserves a Stage</span>"}} />
//                 <p className="cc-hero-sub">{banner.description||"Book a private theatre — just for you and your loved ones"}</p>
//                 <div style={{display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap"}}>
//                   <a href="/locations" className="cc-btn-gold">🎉 Book Now</a>
//                   <a href="tel:8977917555" className="cc-btn-outline" style={{borderColor:"rgba(255,255,255,.5)",color:"#fff"}}>📞 Call to Book</a>
//                 </div>
//               </div>
//               <div style={{position:"absolute",bottom:28,left:"50%",transform:"translateX(-50%)",display:"flex",gap:8,zIndex:3}}>
//                 {banner.desktopImages.map((_,i)=><button key={i} className={`cc-hdot${i===bannerIdx?" on":""}`} onClick={()=>setBannerIdx(i)}/>)}
//               </div>
//             </section>
//           )}

//           {/* ══ 3. OFFER BANNER ══════════════════════════════════════════ */}
//           <div className="container">
//             <div className="cc-offer rv">
//               <div>
//                 <span style={{background:C.gold,color:C.dark,fontSize:10,fontWeight:800,letterSpacing:2,textTransform:"uppercase",padding:"5px 14px",borderRadius:50,display:"inline-block",marginBottom:14}}>🎁 Limited Time Offer</span>
//                 <div className="cc-offer-h">Get Upto <span>40% Off</span></div>
//                 <div className="cc-offer-h" style={{fontSize:"clamp(18px,2.5vw,26px)",marginTop:4}}>+ <span>Extra 10%</span> on Weekday Bookings</div>
//                 <p style={{color:"rgba(255,255,255,.7)",marginBottom:18,marginTop:6}}>Min Booking Value: <b style={{color:C.goldLight}}>₹2,499</b></p>
//                 <div className="cc-offer-code">🏷️ Use Code: <b>CASTLE10</b></div>
//               </div>
//               <div className="cc-ring">
//                 <div style={{fontFamily:"'Playfair Display',serif",fontSize:46,fontWeight:900,color:C.gold,lineHeight:1}}>40%</div>
//                 <div style={{color:"rgba(255,255,255,.5)",fontSize:12,marginTop:2}}>OFF TODAY</div>
//               </div>
//             </div>
//           </div>


// {/* 
//       <section className="cc-sec cc-sec-dark">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag cc-tag-light">✦ Our Reels ✦</span>
//                 <h2 className="cc-h cc-h-white">See the <span className="gold">Magic</span> Happen</h2>
//                 <p className="cc-sub cc-sub-light">Watch real events — the energy, the joy, the unforgettable moments.</p>
//               </div>
//               <div style={{overflow:"hidden"}}>
//                 <div style={{display:"flex",gap:14,transition:"transform .6s cubic-bezier(.25,1,.5,1)",transform:reelTx}}>
//                   {[...REELS,...REELS].map((r,i) => (
//                     <div key={i} className="reel-card">
//                       <img src={r.img} alt={r.title} className="reel-thumb"/>
//                       <div className="reel-ovl">
//                         <div className="reel-play">▶</div>
//                         <div className="reel-views">👁 {r.views}</div>
//                         <div className="reel-title">{r.title}</div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div style={{display:"flex",justifyContent:"center",gap:12,marginTop:28}}>
//                 <button onClick={()=>setReelOff(o=>Math.max(0,o-1))} style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.15)",color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>‹</button>
//                 <button onClick={()=>setReelOff(o=>(o+1)%REELS.length)} style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.15)",color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>›</button>
//               </div>
//             </div>
//           </section> */}
//           <ReelsSection />

//           <VideoTestimonialsSpotlight/>

//              {/* ══ 12. MOST BOOKED THEMES ═══════════════════════════════════ */}
//           <section className="cc-sec cc-sec-dark">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag cc-tag-light">✦ Trending Now ✦</span>
//                 <h2 className="cc-h cc-h-white">Most Booked <span className="gold">Themes</span></h2>
//                 <p className="cc-sub cc-sub-light">Discover the themes our guests love most — each one a complete visual world.</p>
//               </div>
//               <div style={{overflow:"hidden"}}>
//                 <div style={{display:"flex",gap:18,transition:"transform .6s cubic-bezier(.25,1,.5,1)",transform:themeTx}}>
//                   {[...THEMES,...THEMES].map((t,i) => (
//                     <div key={i} className="theme-card" onClick={()=>navigate("/locations")}>
//                       <img src={t.img} alt={t.name} className="theme-img"/>
//                       <div className="theme-ovl">
//                         <div className="theme-name">{t.name}</div>
//                         <div className="theme-booked">🔥 {t.bookings}</div>
//                         <div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:8}}>
//                           {t.tags.map((tg,j)=><span key={j} className="theme-tag">{tg}</span>)}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               <div style={{display:"flex",justifyContent:"center",gap:12,marginTop:28}}>
//                 <button onClick={()=>setThemeOff(o=>Math.max(0,o-1))} style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.15)",color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>‹</button>
//                 <button onClick={()=>setThemeOff(o=>(o+1)%THEMES.length)} style={{width:44,height:44,borderRadius:"50%",background:"rgba(255,255,255,.08)",border:"1px solid rgba(255,255,255,.15)",color:"#fff",fontSize:18,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>›</button>
//               </div>
//             </div>
//           </section>
//           {/* ══ 4. OCCASIONS ═════════════════════════════════════════════ */}
//           {/* <section className="cc-sec cc-sec-cream" id="occasions">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag">✦ What We Offer ✦</span>
//                 <h2 className="cc-h">Occasions We <span>Celebrate</span></h2>
//                 <p className="cc-sub">Private theatre experiences crafted for your most special moments.</p>
//               </div>
//               {occasions.length > 0 ? (
//                 <Slider {...occSlick}>
//                   {occasions.map((occ,i) => (
//                     <div key={i} style={{padding:"0 10px"}}>
//                       <div className="occ-card" onClick={()=>navigate("/locations")}>
//                         <img src={URLS.Base+occ.image} alt={occ.name} />
//                         <div className="occ-ovl">
//                           <span className="occ-badge">Book Now</span>
//                           <div className="occ-title">{occ.name}</div>
//                           <p className="occ-desc">{occDesc(occ.name)}</p>
//                           <button className="occ-bk">Reserve →</button>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </Slider>
//               ) : (
//                 <div style={{textAlign:"center",padding:"48px 0",color:"#aaa"}}>Loading occasions…</div>
//               )}
//               <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:12,marginTop:32,maxWidth:400,margin:"32px auto 0"}}>
//                 <a href="/locations" className="cc-btn" style={{width:"100%",textAlign:"center"}}>Proceed to Book →</a>
//                 <a href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets." target="_blank" rel="noopener noreferrer" className="wa-btn" style={{width:"100%",justifyContent:"center"}}><i className="bi bi-whatsapp"/>Chat With Us</a>
//               </div>
//             </div>
//           </section> */}
//          <BookingProcess/>

// {/* ══ OCCASIONS ══════════════════════════════════════════════════════ */}
// <section className="occ-sec" id="occasions">
//   <div className="container">
//     <div className="text-center rv" style={{ marginBottom: 52 }}>
//       {/* <span className="occ-tag-light">✦ What We Offer ✦</span> */}
//       <h2 className="cc-h cc-h-white">
//         Occasions We <span style={{ color: "#C9A84C" }}>Celebrate</span>
//       </h2>
//       <p className="cc-sub" style={{ color: "rgba(255,255,255,.6)", margin: "10px auto 0" }}>
//         Private theatre experiences crafted for your most special moments.
//       </p>
//     </div>

//     {/* Slider wrapper */}
//     <div style={{ position: "relative", overflow: "hidden", padding: "8px 0 12px" }}>
//       <div id="occ-track" className="occ-track">
//         {occasions.length > 0
//           ? occasions.map((occ, i) => (
//               <OccCard key={i} occ={occ} navigate={navigate} />
//             ))
//           : (
//             <div style={{ padding: "48px 0", color: "rgba(255,255,255,.4)", width: "100%", textAlign: "center" }}>
//               Loading occasions…
//             </div>
//           )
//         }
//       </div>
//     </div>

//     {/* Dots */}
//     <div id="occ-dots" className="occ-dots-row" />

//     {/* Arrows */}
//     <div style={{ display: "flex", justifyContent: "center", gap: 12, marginTop: 16 }}>
//       <button id="occ-prev" className="occ-arrow">‹</button>
//       <button id="occ-next" className="occ-arrow">›</button>
//     </div>

//     {/* CTAs */}
//     <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, maxWidth: 420, margin: "36px auto 0" }}>
//       <a href="/locations" className="occ-cta-book">
//         <span className="occ-cta-shine" />
//         <span style={{ fontSize: 16 }}>🎉</span>
//         <span>Proceed to Book</span>
//         <span className="occ-cta-arr">→</span>
//       </a>
//       <a
//         href="https://wa.me/918341428342?text=Hello%2C%20I%20want%20to%20book%20tickets."
//         target="_blank" rel="noopener noreferrer"
//         className="wa-btn"
//         style={{ width: "100%", justifyContent: "center" }}
//       >
//         <i className="bi bi-whatsapp" /> Chat With Us
//       </a>
//     </div>
//   </div>

//   <style>{`
//     /* ══ SECTION ══ */
//     .occ-sec {
//       padding: 80px 0;
//       background: linear-gradient(160deg, #1A0030 0%, #3D0B57 40%, #5E0E73 70%, #1A0030 100%);
//       overflow: hidden;
//       position: relative;
//     }
//     .occ-sec::before {
//       content: '';
//       position: absolute; inset: 0;
//       background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23fff' fill-opacity='0.025'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E");
//       pointer-events: none;
//     }
//     .occ-tag-light {
//       display: inline-block;
//       font-size: 11px; font-weight: 700;
//       letter-spacing: 3px; text-transform: uppercase;
//       color: #C9A84C; margin-bottom: 10px;
//     }

//     /* ══ TRACK ══ */
//     .occ-track {
//       display: flex;
//       gap: 20px;
//       transition: transform .6s cubic-bezier(.25,1,.5,1);
//       will-change: transform;
//     }

//     /* ══ CARD ══ */
//     .occ-card {
//       flex-shrink: 0;
//       width: calc((100% - 40px) / 3);
//       border-radius: 22px;
//       overflow: hidden;
//       cursor: pointer;
//       position: relative;
//       height: 340px;
//       transition: transform .35s cubic-bezier(.25,1,.5,1), box-shadow .35s;
//       box-shadow: 0 8px 32px rgba(0,0,0,.35);
//     }
//     .occ-card img {
//       width: 100%; height: 100%;
//       object-fit: cover; object-position: center;
//       display: block;
//       transition: transform .5s cubic-bezier(.25,1,.5,1), filter .4s;
//       filter: brightness(1);
//     }

//     /* ── always-visible title strip ── */
//     .occ-always {
//       position: absolute;
//       bottom: 0; left: 0; right: 0;
//       padding: 52px 20px 18px;
//       background: linear-gradient(to top, rgba(26,0,48,.92) 0%, transparent 100%);
//       transition: opacity .35s;
//       pointer-events: none;
//     }
//     .occ-title-always {
//       font-family: 'Playfair Display', serif;
//       color: #fff; font-size: 19px; font-weight: 700;
//     }

//     /* ── hover overlay ── */
//     .occ-ovl {
//       position: absolute; inset: 0;
//       background: linear-gradient(to top,
//         rgba(26,0,48,.97) 0%,
//         rgba(94,14,115,.65) 50%,
//         rgba(26,0,48,.2) 100%);
//       display: flex; align-items: flex-end;
//       padding: 22px 20px;
//       opacity: 0;
//       transition: opacity .38s;
//     }
//     .occ-ovl-inner {
//       width: 100%;
//       transform: translateY(14px);
//       transition: transform .4s cubic-bezier(.25,1,.5,1);
//     }
//     .occ-occ-name {
//       font-family: 'Playfair Display', serif;
//       color: #fff; font-size: 18px; font-weight: 700;
//       margin-bottom: 6px;
//     }
//     .occ-desc {
//       color: rgba(255,255,255,.75); font-size: 12px;
//       line-height: 1.6; margin-bottom: 0;
//     }

//     /* ══ GOLD BOOK NOW — on each card ══ */
//     .occ-book-gold {
//       position: relative;
//       display: inline-flex;
//       align-items: center;
//       gap: 7px;
//       margin-top: 14px;
//       padding: 11px 26px;
//       border-radius: 50px;
//       border: none;
//       cursor: pointer;
//       overflow: hidden;
//       background: linear-gradient(135deg,
//         #B8860B 0%, #C9A84C 28%, #F5D87A 52%,
//         #C9A84C 74%, #9A6E10 100%);
//       background-size: 200% 200%;
//       animation: gold-bg 3s ease infinite;
//       color: #1A0030;
//       font-family: 'DM Sans', sans-serif;
//       font-size: 13px; font-weight: 800;
//       letter-spacing: .5px;
//       box-shadow:
//         0 6px 24px rgba(201,168,76,.5),
//         0 2px 8px rgba(0,0,0,.2),
//         inset 0 1px 0 rgba(255,255,255,.35);
//       transition: transform .25s cubic-bezier(.25,1,.5,1), box-shadow .25s;
//     }
//     .occ-book-gold:hover {
//       transform: translateY(-2px) scale(1.05);
//       box-shadow:
//         0 10px 36px rgba(201,168,76,.65),
//         0 4px 12px rgba(0,0,0,.25),
//         inset 0 1px 0 rgba(255,255,255,.4);
//     }
//     @keyframes gold-bg {
//       0%   { background-position: 0% 50%; }
//       50%  { background-position: 100% 50%; }
//       100% { background-position: 0% 50%; }
//     }

//     /* shine sweep */
//     .occ-book-shine {
//       position: absolute;
//       top: 0; left: -80%;
//       width: 55%; height: 100%;
//       background: linear-gradient(120deg, transparent 0%, rgba(255,255,255,.6) 50%, transparent 100%);
//       transform: skewX(-20deg);
//       animation: book-shine 2.6s ease infinite;
//     }
//     @keyframes book-shine {
//       0%        { left: -80%; opacity: 0; }
//       8%        { opacity: 1; }
//       48%       { left: 130%; opacity: 1; }
//       49%, 100% { left: 130%; opacity: 0; }
//     }

//     /* bounce icon */
//     .occ-book-icon {
//       font-size: 14px;
//       display: inline-block;
//       animation: icon-pop .85s ease infinite alternate;
//     }
//     @keyframes icon-pop {
//       from { transform: rotate(-6deg) scale(1); }
//       to   { transform: rotate(6deg) scale(1.15); }
//     }

//     .occ-book-label { position: relative; z-index: 1; }
//     .occ-book-arr {
//       position: relative; z-index: 1;
//       font-size: 14px;
//       transition: transform .25s;
//     }
//     .occ-book-gold:hover .occ-book-arr { transform: translateX(4px); }

//     /* sparkles */
//     .sparkle-zone {
//       position: absolute; inset: 0;
//       pointer-events: none; overflow: hidden; border-radius: 22px;
//       z-index: 3;
//     }
//     .sparkle {
//       position: absolute;
//       background: #C9A84C;
//       clip-path: polygon(50% 0%,61% 35%,98% 35%,68% 57%,79% 91%,50% 70%,21% 91%,32% 57%,2% 35%,39% 35%);
//       opacity: 0;
//       animation: occ-sparkle 1.4s ease-in-out infinite;
//     }
//     @keyframes occ-sparkle {
//       0%   { transform: scale(0) rotate(0deg);    opacity: 0; }
//       50%  { transform: scale(1.2) rotate(180deg); opacity: 1; }
//       100% { transform: scale(0) rotate(360deg);  opacity: 0; }
//     }

//     /* ══ DESKTOP HOVER ══ */
//     @media(hover: hover) and (pointer: fine) {
//       .occ-card:hover {
//         transform: translateY(-10px) scale(1.01);
//         box-shadow: 0 28px 72px rgba(0,0,0,.5);
//       }
//       .occ-card:hover img {
//         transform: scale(1.08);
//         filter: brightness(.72);
//       }
//       .occ-card:hover .occ-always  { opacity: 0; }
//       .occ-card:hover .occ-ovl     { opacity: 1; }
//       .occ-card:hover .occ-ovl-inner { transform: translateY(0); }
//     }

//     /* ══ MOBILE TOUCH ══ */
//     .occ-card.touched {
//       transform: translateY(-6px) scale(1.01);
//       box-shadow: 0 20px 56px rgba(0,0,0,.45);
//     }
//     .occ-card.touched img {
//       transform: scale(1.06);
//       filter: brightness(.72);
//     }
//     .occ-card.touched .occ-always   { opacity: 0; }
//     .occ-card.touched .occ-ovl      { opacity: 1; }
//     .occ-card.touched .occ-ovl-inner { transform: translateY(0); }

//     /* ══ DOTS ══ */
//     .occ-dots-row {
//       display: flex; justify-content: center;
//       gap: 8px; margin-top: 24px;
//     }
//     .occ-dot {
//       width: 8px; height: 8px; border-radius: 50%;
//       background: rgba(255,255,255,.25);
//       border: none; cursor: pointer; transition: all .3s;
//     }
//     .occ-dot.on {
//       width: 28px; border-radius: 4px;
//       background: linear-gradient(90deg, #C9A84C, #E8D5A0);
//     }

//     /* ══ ARROWS ══ */
//     .occ-arrow {
//       width: 44px; height: 44px; border-radius: 50%;
//       background: rgba(255,255,255,.1);
//       border: 1.5px solid rgba(255,255,255,.25);
//       color: #fff; font-size: 20px; cursor: pointer;
//       display: flex; align-items: center; justify-content: center;
//       transition: all .25s; backdrop-filter: blur(8px);
//     }
//     .occ-arrow:hover {
//       background: #C9A84C; color: #1A0030; border-color: #C9A84C;
//     }

//     /* ══ BOTTOM CTA BOOK BTN ══ */
//     .occ-cta-book {
//       position: relative;
//       display: inline-flex; align-items: center; gap: 10px;
//       width: 100%; justify-content: center;
//       padding: 15px 32px; border-radius: 50px;
//       background: linear-gradient(135deg,
//         #B8860B 0%, #C9A84C 28%, #F5D87A 52%,
//         #C9A84C 74%, #9A6E10 100%);
//       background-size: 200% 200%;
//       animation: gold-bg 3s ease infinite;
//       color: #1A0030;
//       font-family: 'DM Sans', sans-serif;
//       font-size: 15px; font-weight: 800;
//       letter-spacing: .5px;
//       text-decoration: none;
//       overflow: hidden;
//       box-shadow:
//         0 8px 32px rgba(201,168,76,.45),
//         0 2px 8px rgba(0,0,0,.2),
//         inset 0 1px 0 rgba(255,255,255,.35);
//       transition: transform .25s, box-shadow .25s;
//     }
//     .occ-cta-book:hover {
//       transform: translateY(-3px) scale(1.02);
//       box-shadow: 0 14px 44px rgba(201,168,76,.6), inset 0 1px 0 rgba(255,255,255,.4);
//       color: #1A0030;
//     }
//     .occ-cta-shine {
//       position: absolute; top: 0; left: -80%;
//       width: 55%; height: 100%;
//       background: linear-gradient(120deg, transparent 0%, rgba(255,255,255,.55) 50%, transparent 100%);
//       transform: skewX(-20deg);
//       animation: book-shine 2.8s ease infinite;
//     }
//     .occ-cta-arr { font-size: 16px; transition: transform .25s; }
//     .occ-cta-book:hover .occ-cta-arr { transform: translateX(5px); }

//     /* ══ RESPONSIVE ══ */
//     @media(max-width: 768px) {
//       .occ-card { width: calc(100vw - 72px); height: 300px; }
//     }
//     @media(min-width: 769px) and (max-width: 1024px) {
//       .occ-card { width: calc((100% - 20px) / 2); }
//     }
//   `}</style>

//   <OccSliderController occasions={occasions} navigate={navigate} />
// </section>
//           {/* <section className="cc-sec cc-sec-white">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag">✦ Our Services ✦</span>
//                 <h2 className="cc-h">Everything You <span>Need</span></h2>
//                 <p className="cc-sub">Cakes, food, screening, bouquets — all curated to make your event perfect.</p>
//               </div>
//               <Slider {...svcSlick}>
//                 {SERVICE_CARDS.map((s,i) => (
//                   <div key={i} style={{padding:"0 10px"}}>
//                     <div className="svc-card">
//                       <img src={s.img} alt={s.label} className="svc-img" />
//                       <div className="svc-body">
//                         <div className="svc-title">{s.label}</div>
//                         <p className="svc-desc">{s.desc}</p>
//                         {s.href && <a href={s.href} style={{fontSize:12,color:C.primary,fontWeight:700,textDecoration:"none",display:"inline-block",marginTop:8}}>View more →</a>}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </Slider>
//               <div className="text-center mt-4">
//                 <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn" style={{margin:"0 auto"}}><i className="bi bi-whatsapp"/>Chat With Us</a>
//               </div>
//             </div>
//           </section> */}


// <section className="cc-sec cc-sec-white" style={{ overflow: "hidden" }}>
//   <div className="container">
//     <div className="text-center rv" style={{ marginBottom: 52 }}>
//       <span className="cc-tag">✦ Our Services ✦</span>
//       <h2 className="cc-h">Everything You <span>Need</span></h2>
//       <p className="cc-sub">Cakes, food, screening, bouquets — all curated to make your event absolutely perfect.</p>
//     </div>

//     {/* Ornament divider */}
//     <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:52 }}>
//       <div style={{ flex:1, height:1, background:"linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent)" }} />
//       <div style={{ width:8, height:8, background:"#C9A84C", transform:"rotate(45deg)", flexShrink:0 }} />
//       <div style={{ flex:1, height:1, background:"linear-gradient(90deg,rgba(94,14,115,.15),transparent)" }} />
//     </div>

//     {/* Cards grid */}
//     <div className="svc-grid rv">
//       {SERVICE_CARDS.map((s, i) => (
//         <div key={i} className="svc-card-premium">
//           <div className="svc-img-wrap">
//             <img src={s.img} alt={s.label} className="svc-img-premium" />
//             <div className="svc-glow-ovl" />
//             <div className="svc-num-badge">0{i + 1}</div>
//             <div className="svc-pill-tag">{["✨ Popular","🎂 Custom","🎬 Cinematic","🌹 Fresh"][i]}</div>
//           </div>
//           <div className="svc-body-premium">
//             <div className="svc-float-icon">{["🍽️","🎂","🎬","🌹"][i]}</div>
//             <div className="svc-title-premium">{s.label}</div>
//             <span className="svc-anim-line" />
//             <p className="svc-desc-premium">{s.desc}</p>
//             {s.href && (
//               <a href={s.href} className="svc-view-link">
//                 View More <span className="svc-link-arr">→</span>
//               </a>
//             )}
//           </div>
//         </div>
//       ))}
//     </div>

//     {/* CTA */}
//     <div className="text-center" style={{ marginTop: 8 }}>
//       <a
//         href="https://wa.me/918341428342"
//         target="_blank" rel="noopener noreferrer"
//         className="wa-btn"
//         style={{ margin: "0 auto" }}
//       >
//         <i className="bi bi-whatsapp" /> Chat With Us
//       </a>
//     </div>
//   </div>

//   <style>{`
//     /* ── Grid ── */
//     .svc-grid {
//       display: grid;
//       grid-template-columns: repeat(4, 1fr);
//       gap: 24px;
//       margin-bottom: 48px;
//     }
//     @media(max-width:1024px) { .svc-grid { grid-template-columns: repeat(2, 1fr); gap: 20px; } }
//     @media(max-width:540px)  { .svc-grid { grid-template-columns: 1fr; gap: 16px; } }

//     /* ── Card ── */
//     .svc-card-premium {
//       border-radius: 22px;
//       overflow: hidden;
//       background: #fff;
//       border: 1px solid rgba(94,14,115,.08);
//       box-shadow: 0 4px 24px rgba(94,14,115,.07);
//       transition: transform .4s cubic-bezier(.25,1,.5,1), box-shadow .4s;
//       cursor: pointer;
//       position: relative;
//     }
//     .svc-card-premium:hover {
//       transform: translateY(-12px);
//       box-shadow: 0 32px 72px rgba(94,14,115,.2);
//     }

//     /* ── Image ── */
//     .svc-img-wrap { position: relative; height: 220px; overflow: hidden; }
//     .svc-img-premium {
//       width: 100%; height: 100%; object-fit: cover; display: block;
//       transition: transform .55s cubic-bezier(.25,1,.5,1);
//     }
//     .svc-card-premium:hover .svc-img-premium { transform: scale(1.1); }

//     /* ── Glow overlay ── */
//     .svc-glow-ovl {
//       position: absolute; inset: 0;
//       background: linear-gradient(to top, rgba(94,14,115,.45) 0%, transparent 55%);
//       opacity: 0; transition: opacity .35s;
//     }
//     .svc-card-premium:hover .svc-glow-ovl { opacity: 1; }

//     /* ── Number badge ── */
//     .svc-num-badge {
//       position: absolute; top: 14px; right: 14px;
//       width: 34px; height: 34px; border-radius: 50%;
//       background: rgba(26,0,48,.65); backdrop-filter: blur(8px);
//       border: 1.5px solid rgba(201,168,76,.5);
//       display: flex; align-items: center; justify-content: center;
//       font-family: 'Playfair Display', serif; font-size: 13px;
//       font-weight: 700; color: #E8D5A0;
//       transition: background .3s;
//     }
//     .svc-card-premium:hover .svc-num-badge { background: rgba(94,14,115,.85); }

//     /* ── Pill tag (slides up on hover) ── */
//     .svc-pill-tag {
//       position: absolute; bottom: 14px; left: 14px;
//       background: linear-gradient(135deg, #C9A84C, #E8D5A0);
//       color: #1A0030; font-size: 9px; font-weight: 800;
//       letter-spacing: 1.5px; text-transform: uppercase;
//       padding: 4px 12px; border-radius: 50px;
//       transform: translateY(8px); opacity: 0;
//       transition: transform .35s, opacity .35s;
//     }
//     .svc-card-premium:hover .svc-pill-tag { transform: translateY(0); opacity: 1; }

//     /* ── Body ── */
//     .svc-body-premium { padding: 28px 20px 22px; position: relative; }

//     /* ── Float icon ── */
//     .svc-float-icon {
//       position: absolute; top: -18px; left: 20px;
//       width: 36px; height: 36px; border-radius: 10px;
//       background: linear-gradient(135deg, #5E0E73, #6E1A85);
//       display: flex; align-items: center; justify-content: center;
//       font-size: 16px;
//       box-shadow: 0 6px 16px rgba(94,14,115,.35);
//       transition: transform .3s;
//     }
//     .svc-card-premium:hover .svc-float-icon { transform: rotate(-8deg) scale(1.1); }

//     /* ── Title ── */
//     .svc-title-premium {
//       font-family: 'Playfair Display', serif;
//       font-size: 18px; font-weight: 700; color: #1A0030;
//       margin-bottom: 0; transition: color .25s;
//     }
//     .svc-card-premium:hover .svc-title-premium { color: #5E0E73; }

//     /* ── Animated underline ── */
//     .svc-anim-line {
//       display: block; width: 0; height: 2px;
//       background: linear-gradient(90deg, #5E0E73, #C9A84C);
//       border-radius: 2px; margin: 8px 0 10px;
//       transition: width .4s cubic-bezier(.25,1,.5,1);
//     }
//     .svc-card-premium:hover .svc-anim-line { width: 48px; }

//     /* ── Desc ── */
//     .svc-desc-premium { font-size: 13px; color: #888; line-height: 1.6; }

//     /* ── View more link ── */
//     .svc-view-link {
//       display: inline-flex; align-items: center; gap: 5px;
//       font-size: 12px; font-weight: 700; color: #5E0E73;
//       text-decoration: none; margin-top: 12px;
//       opacity: 0; transform: translateY(4px);
//       transition: opacity .3s, transform .3s;
//     }
//     .svc-card-premium:hover .svc-view-link { opacity: 1; transform: translateY(0); }
//     .svc-link-arr { display: inline-block; transition: transform .25s; }
//     .svc-view-link:hover .svc-link-arr { transform: translateX(4px); }
//   `}</style>
// </section>



//           {/* ══ 8. WHY CHOOSE US ═════════════════════════════════════════ */}
//           <section className="cc-sec cc-sec-beige">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag">✦ Why Choose Us ✦</span>
//                 <h2 className="cc-h">Plan a Surprise for your <span>Loved One</span></h2>
//               </div>
//               <div className="why-lt-card rv">
//                 <div className="row align-items-center g-5">
//                   <div className="col-lg-6">
//                     <div className="why-lt-img">
//                       <img src={WHY_SLIDES[whyIdx].image} alt="Why CarnivalCastle" />
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <h3 className="why-underline" style={{fontFamily:"'Playfair Display',serif",fontSize:"clamp(18px,2.4vw,26px)",color:C.dark,marginBottom:24,fontWeight:700}}>{WHY_SLIDES[whyIdx].subtitle}</h3>
//                     <ul style={{listStyle:"none",padding:0}}>
//                       {WHY_SLIDES[whyIdx].points.map((pt,i) => (
//                         <li key={i} className="why-pt">
//                           <div className="why-pt-ic"><i className="fas fa-check-circle" style={{color:C.primary,fontSize:13}}/></div>
//                           <span style={{fontSize:14,color:"#555",lineHeight:1.6}}>{pt}</span>
//                         </li>
//                       ))}
//                     </ul>
//                     <div style={{display:"flex",gap:12,flexWrap:"wrap",marginTop:26}}>
//                       <a href="/locations" className="cc-btn"><i className="fas fa-ticket-alt me-2"/>Book Now</a>
//                       <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/>Chat With Us</a>
//                     </div>
//                     <div style={{display:"flex",gap:8,marginTop:24}}>
//                       {WHY_SLIDES.map((_,i)=><button key={i} className={`why-dot${i===whyIdx?" on":""}`} style={{background:i===whyIdx?C.primary:"rgba(94,14,115,.2)"}} onClick={()=>handleWhySelect(i)}/>)}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* ══ 9. OUR REELS ═════════════════════════════════════════════ */}


//           {/* ══ 10. PACKAGES ═════════════════════════════════════════════ */}
//           <HomePackagesSection navigateTheater={navigate} />

//           {/* ══ 11. BEST SELLERS ═════════════════════════════════════════ */}
//           {/* <section className="cc-sec cc-sec-cream">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag">✦ Most Loved ✦</span>
//                 <h2 className="cc-h">Our <span>Best Sellers</span></h2>
//                 <p className="cc-sub">Handpicked add-ons that consistently delight our guests — order with your event.</p>
//               </div>
//               <div className="row g-4">
//                 {SELLERS.map((s,i) => (
//                   <div key={i} className={`col-6 col-md-3 rv d${i+1}`}>
//                     <div className="seller-card">
//                       <div className="seller-img-w">
//                         <img src={s.img} alt={s.name} className="seller-img"/>
//                         <span className="seller-lbl">{s.label}</span>
//                       </div>
//                       <div className="seller-info">
//                         <div className="seller-name">{s.name}</div>
//                         <div className="seller-meta">{s.meta}</div>
//                         <div>
//                           <span className="seller-price"><s>{s.orig}</s>{s.price}</span>
//                           <button className="seller-add">+ Add</button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section> */}

// {/* ══ 11. BEST SELLERS ══════════════════════════════════════════ */}



//           {/* ══ 13. VIDEO TESTIMONIALS ═══════════════════════════════════ */}
//           {testimonials.length > 0 && (
//             <section className="cc-sec cc-sec-white">
//               <div className="container">
//                 <div className="text-center rv" style={{marginBottom:48}}>
//                   <span className="cc-tag">✦ Testimonials ✦</span>
//                   <h2 className="cc-h">Real Stories, <span>Real Magic</span></h2>
//                   <p className="cc-sub">See what our guests experienced at CarnivalCastle.</p>
//                 </div>
//                 <div id="vtCar" className="carousel slide carousel-fade rv" data-bs-ride="false" style={{maxWidth:900,margin:"0 auto"}}>
//                   <div className="carousel-inner">
//                     {testimonials.map((item,idx) => {
//                       const prev=idx===0?testimonials.length-1:idx-1;
//                       const next=idx===testimonials.length-1?0:idx+1;
//                       const getPImg=(t)=>{const p=t?.profileImage?.replace(/\\/g,"/");return p?.startsWith("uploads/")?`https://api.carnivalcastle.com/${p}`:p;};
//                       return (
//                         <div key={idx} className={`carousel-item${idx===0?" active":""}`}>
//                           <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:16,padding:"0 8px"}}>
//                             <div className="d-none d-md-block" style={{width:130,height:190,borderRadius:14,overflow:"hidden",opacity:.65,backgroundImage:`url(${getPImg(testimonials[prev])})`,backgroundSize:"cover",backgroundPosition:"center"}}>
//                               <div style={{width:"100%",height:"100%",display:"flex",alignItems:"flex-end",justifyContent:"center",padding:8}}><span style={{background:"rgba(0,0,0,.7)",color:"#fff",fontSize:11,padding:"3px 8px",borderRadius:6}}>{testimonials[prev]?.name}</span></div>
//                             </div>
//                             <div style={{flex:"1 1 auto",maxWidth:420,borderRadius:18,overflow:"hidden",boxShadow:`0 16px 48px rgba(94,14,115,.25)`}}>
//                               <iframe width="100%" height="300" src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1`} title={item.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen/>
//                               <div style={{background:C.cream,padding:"14px 16px"}}>
//                                 <div style={{fontWeight:700,color:C.primary}}>{item.name}</div>
//                                 <div style={{fontSize:12,color:"#888"}}>{item.role}</div>
//                               </div>
//                             </div>
//                             <div className="d-none d-md-block" style={{width:130,height:190,borderRadius:14,overflow:"hidden",opacity:.65,backgroundImage:`url(${getPImg(testimonials[next])})`,backgroundSize:"cover",backgroundPosition:"center"}}>
//                               <div style={{width:"100%",height:"100%",display:"flex",alignItems:"flex-end",justifyContent:"center",padding:8}}><span style={{background:"rgba(0,0,0,.7)",color:"#fff",fontSize:11,padding:"3px 8px",borderRadius:6}}>{testimonials[next]?.name}</span></div>
//                             </div>
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
//                   <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:24}}>
//                     {testimonials.map((_,i)=><button key={i} type="button" data-bs-target="#vtCar" data-bs-slide-to={i} style={{width:i===0?26:10,height:10,borderRadius:999,border:"none",background:i===0?C.primary:"rgba(94,14,115,.2)",transition:"all .3s",cursor:"pointer"}}/>)}
//                   </div>
//                 </div>
//               </div>
//             </section>
//           )}


//              {/* ══ 6. NOT JUST INSTANT DELIVERY ════════════════════════════ */}


//           {/* ══ 14. TEXT REVIEW CARDS ════════════════════════════════════ */}
//           {slides.length > 0 && (
//             <section className="cc-sec cc-sec-pale">
//               <div className="container">
//                 <div className="text-center rv" style={{marginBottom:48}}>
//                   <span className="cc-tag">✦ Customer Love ✦</span>
//                   <h2 className="cc-h">What Our <span>Guests Say</span></h2>
//                 </div>
//                 <div id="rvCar" className="carousel slide rv" data-bs-interval="5000" data-bs-ride="carousel">
//                   <div className="carousel-inner">
//                     {slides.map((group,gIdx) => (
//                       <div key={gIdx} className={`carousel-item${gIdx===0?" active":""}`}>
//                         <div className="row g-4 justify-content-center">
//                           {group.map((rv,rIdx) => (
//                             <div key={rIdx} className="col-lg-4 col-md-6">
//                               <div className="testi-card">
//                                 <img src={rv.image} alt="" className="t-bg"/>
//                                 <div className="t-glass">
//                                   <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}>
//                                     <img src={rv.avatar} alt="" style={{width:42,height:42,borderRadius:"50%",objectFit:"cover",border:`2px solid ${C.primary}`}}/>
//                                     <div><div className="t-name">{rv.name}</div><div className="t-role">{rv.location}</div></div>
//                                   </div>
//                                   <div className="t-stars">{"★".repeat(rv.rating)}{"☆".repeat(5-rv.rating)}</div>
//                                   <p className="t-desc">{rv.description}</p>
//                                   {rv.occasion&&<div style={{fontSize:11,color:C.primary,fontWeight:600}}>🎉 {rv.occasion}</div>}
//                                 </div>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                   <div style={{display:"flex",justifyContent:"center",gap:8,marginTop:24}}>
//                     {slides.map((_,i)=><button key={i} type="button" data-bs-target="#rvCar" data-bs-slide-to={i} style={{width:i===0?26:10,height:10,borderRadius:999,border:"none",background:i===0?C.primary:"rgba(94,14,115,.2)",cursor:"pointer"}}/>)}
//                   </div>
//                 </div>
//               </div>
//             </section>
//           )}

//           {/* ══ 15. GALLERY ══════════════════════════════════════════════ */}
//           {/* <section className="cc-sec cc-sec-cream" id="gallery">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag">✦ Gallery ✦</span>
//                 <h2 className="cc-h">See the <span>Magic</span> in Action</h2>
//                 <p className="cc-sub">Real moments captured at CarnivalCastle Private Theatres.</p>
//               </div>
//               <Galleria ref={galleria} value={images} numVisible={6} style={{maxWidth:850}} activeIndex={activeGal}
//                 onItemChange={e=>setActiveGal(e.index)} circular fullScreen showItemNavigators showThumbnails={false}
//                 item={galItem} thumbnail={galThumb}/>
//               <div className="row g-3 rv">
//                 {images.map((img,i) => (
//                   <div key={i} className="col-6 col-md-4">
//                     <div className="gal-item" onClick={()=>{setActiveGal(i);galleria.current.show();}}>
//                       <img src={URLS.Base+img.image} alt={img.alt}/>
//                       <div className="gal-zoom"><i className="fas fa-search-plus"/></div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <div style={{display:"flex",gap:12,justifyContent:"center",marginTop:32,flexWrap:"wrap"}}>
//                 <a href="/gallery" className="cc-btn">View Gallery →</a>
//                 <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/>Chat With Us</a>
//               </div>
//             </div>
//           </section> */}

//      {/* ══ 15. GALLERY ══════════════════════════════════════════════ */}
// {/* ══ 15. GALLERY ══════════════════════════════════════════════ */}
// <section className="cc-sec cc-sec-cream" id="gallery" style={{ overflow: "hidden" }}>
//   <div className="container">
//     <div className="text-center rv" style={{ marginBottom: 56 }}>
//       <span className="cc-tag">✦ Gallery ✦</span>
//       <h2 className="cc-h">See the <span>Magic</span> in Action</h2>
//       <p className="cc-sub">Real moments captured at CarnivalCastle Private Theatres.</p>
//     </div>

//     {/* Bento Grid */}
//     <div className="gal-bento rv">
//       {images.map((img, i) => (
//         <div
//           key={i}
//           className={`gal-bento-item gbi-${i + 1}`}
//           onClick={() => { setActiveGal(i); galleria.current.show(); }}
//           style={{ animationDelay: `${i * 0.08}s` }}
//         >
//           <img
//             src={URLS.Base + img.image}
//             alt={img.alt || `Gallery ${i + 1}`}
//           />
//         </div>
//       ))}
//     </div>

//     {/* Galleria fullscreen lightbox */}
//     <Galleria
//       ref={galleria}
//       value={images}
//       numVisible={6}
//       style={{ maxWidth: 850 }}
//       activeIndex={activeGal}
//       onItemChange={e => setActiveGal(e.index)}
//       circular
//       fullScreen
//       showItemNavigators
//       showThumbnails={false}
//       item={galItem}
//       thumbnail={galThumb}
//     />

//     {/* CTAs */}
//     <div style={{ display: "flex", gap: 14, justifyContent: "center", marginTop: 40, flexWrap: "wrap" }}>
//       <a href="/gallery" className="cc-btn">View Full Gallery →</a>
//       <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn">
//         <i className="bi bi-whatsapp" /> Chat With Us
//       </a>
//     </div>
//   </div>

//   <style>{`
//     /* ── Bento Grid ── */
//     .gal-bento {
//       display: grid;
//       grid-template-columns: repeat(12, 1fr);
//       gap: 14px;
//       margin-bottom: 8px;
//     }

//     /* grid slot assignments */
//     .gbi-1 { grid-column: span 5; grid-row: span 2; min-height: 380px; }
//     .gbi-2 { grid-column: span 4; min-height: 182px; }
//     .gbi-3 { grid-column: span 3; min-height: 182px; }
//     .gbi-4 { grid-column: span 4; min-height: 182px; }
//     .gbi-5 { grid-column: span 3; min-height: 182px; }
//     .gbi-6 { grid-column: span 7; min-height: 220px; }

//     /* ── Item base ── */
//     .gal-bento-item {
//       position: relative;
//       border-radius: 18px;
//       overflow: hidden;
//       cursor: pointer;
//       background: #1A0030;
//       opacity: 0;
//       transform: translateY(28px) scale(.97);
//       transition: opacity .6s ease, transform .6s cubic-bezier(.25,1,.5,1), box-shadow .35s;
//     }
//     .gal-bento-item.in {
//       opacity: 1;
//       transform: translateY(0) scale(1);
//     }
//     .gal-bento-item:hover {
//       box-shadow: 0 24px 64px rgba(94,14,115,.28);
//       z-index: 2;
//     }

//     /* ── Image — full clarity, no cutoff ── */
//     .gal-bento-item img {
//       width: 100%;
//       height: 100%;
//       object-fit: cover;
//       object-position: center;
//       display: block;
//       position: absolute;
//       inset: 0;
//       transition: transform .6s cubic-bezier(.25,1,.5,1);
//       filter: brightness(1);
//     }
//     .gal-bento-item:hover img {
//       transform: scale(1.05);
//       filter: brightness(1);
//     }

//     /* ── Responsive ── */
//     @media(max-width: 1024px) {
//       .gal-bento { grid-template-columns: repeat(6, 1fr); gap: 12px; }
//       .gbi-1 { grid-column: span 3; grid-row: span 2; min-height: 320px; }
//       .gbi-2 { grid-column: span 3; min-height: 155px; }
//       .gbi-3 { grid-column: span 3; min-height: 155px; }
//       .gbi-4 { grid-column: span 2; min-height: 175px; }
//       .gbi-5 { grid-column: span 2; min-height: 175px; }
//       .gbi-6 { grid-column: span 2; min-height: 175px; }
//     }
//     @media(max-width: 640px) {
//       .gal-bento { grid-template-columns: 1fr 1fr; gap: 10px; }
//       .gbi-1 { grid-column: span 2; min-height: 220px; grid-row: span 1; }
//       .gbi-2, .gbi-3, .gbi-4, .gbi-5 { grid-column: span 1; min-height: 160px; }
//       .gbi-6 { grid-column: span 2; min-height: 170px; }
//     }
//   `}</style>

//   <GalleryEntranceObserver />
// </section>
//           {/* ══ 16. COUPONS ══════════════════════════════════════════════ */}
//           <CouponSection />


//           <section className="cc-sec cc-sec-dark">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:56}}>
//                 <h2 className="cc-h cc-h-white">Not Just Instant Delivery, <span className="gold">But..</span></h2>
//               </div>
//               <div className="row g-4">
//                 {WHY_CARDS.map((w,i) => (
//                   <div key={i} className={`col-md-6 rv d${i%4+1}`}>
//                     <div className="why-dk-card">
//                       <img src={w.img} alt={w.title} className="why-dk-img" />
//                       <div className="why-dk-body">
//                         <div style={{fontSize:24,marginBottom:8}}>{w.icon}</div>
//                         <div className="why-dk-title">{w.title}</div>
//                         <div className="why-dk-desc">{w.desc}</div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section>

//           {/* ══ 7. FEATURES THAT STAND OUT ══════════════════════════════ */}
//           <section className="cc-sec cc-sec-dark2">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag cc-tag-light">✦ Platform Features ✦</span>
//                 <h2 className="cc-h cc-h-white">Features That Make Us <span className="gold">Stand Out</span></h2>
//                 <p className="cc-sub cc-sub-light">Designed to make every event seamless, smart and sensational.</p>
//               </div>
//               {/* sliding stand-out cards */}
//               <div style={{overflow:"hidden",marginBottom:52}}>
//                 <div style={{display:"flex",gap:18,transition:"transform .6s cubic-bezier(.25,1,.5,1)",transform:`translateX(calc(-${(reelOff%4)*(260+18)}px))`}}>
//                   {[...STAND_OUT,...STAND_OUT].map((f,i) => (
//                     <div key={i} className="stand-card">
//                       <div className="stand-icon">{f.icon}</div>
//                       <div className="stand-title">{f.title}</div>
//                       <div className="stand-desc">{f.desc}</div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//               {/* feat grid */}
//               <div className="text-center rv" style={{marginBottom:32}}>
//                 <span className="cc-tag cc-tag-light">✦ More Features ✦</span>
//                 <h2 className="cc-h cc-h-white">Everything You <span>Need</span></h2>
//               </div>
//               <div className="row g-3">
//                 {EXTRA_FEATS.map((f,i) => (
//                   <div key={i} className={`col-md-6 rv d${i+1}`}>
//                     <div className="feat-card">
//                       <div className="stand-icon" style={{flexShrink:0,marginBottom:0}}>{f.icon}</div>
//                       <div>
//                         <div style={{color:"#fff",fontSize:16,fontWeight:700,marginBottom:5}}>{f.title}</div>
//                         <div style={{color:"rgba(255,255,255,.5)",fontSize:13,lineHeight:1.6}}>{f.desc}</div>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </section> 

//         <TestimonalsSection/>

//           {/* ══ 17. PREMIUM ENQUIRY FORM ═════════════════════════════════ */}
//           <section className="cc-sec cc-sec-beige" id="enquiry">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:48}}>
//                 <span className="cc-tag">✦ Get In Touch ✦</span>
//                 <h2 className="cc-h">Plan Your <span>Perfect Event</span></h2>
//                 <p className="cc-sub">Fill in the form and our team will respond within 2 hours with a personalised plan.</p>
//               </div>
//               <div className="enq-wrap rv" style={{maxWidth:1060,margin:"0 auto"}}>
//                 <div className="row g-0">
//                   {/* Left Panel */}
//                   <div className="col-lg-4">
//                     <div className="enq-left h-100">
//                       <div>
//                         <h3 className="pf" style={{color:"#fff",fontSize:26,fontWeight:700,marginBottom:8}}>Let's Create <span style={{color:C.goldLight}}>Magic</span> Together</h3>
//                         <p style={{color:"rgba(255,255,255,.6)",fontSize:13,lineHeight:1.7,marginBottom:32}}>Share your event details and we'll craft an unforgettable private theatre experience for you.</p>
//                         {/* progress bar */}
//                         <div style={{marginBottom:8}}>
//                           <div style={{fontSize:10,color:"rgba(255,255,255,.4)",letterSpacing:1,textTransform:"uppercase",marginBottom:6}}>Form Progress</div>
//                           <div className="enq-step-bar">
//                             {[0,1,2].map(s=><div key={s} className={`enq-step${formStep>=s?" done":""}`}/>)}
//                           </div>
//                           <div style={{fontSize:11,color:"rgba(255,255,255,.4)",marginTop:6}}>Step {formStep+1} of 3</div>
//                         </div>
//                       </div>
//                       {/* Contact info */}
//                       <div>
//                         {[
//                           {icon:"📞",label:"Call Us",val:"+91 8341428342",href:"tel:8341428342"},
//                           {icon:"💬",label:"WhatsApp",val:"+91 8341428342",href:"https://wa.me/918341428342"},
//                           {icon:"📧",label:"Email",val:Contact.email||"carnivalcastle02@gmail.com",href:`mailto:${Contact.email}`},
//                           {icon:"📍",label:"Location",val:Contact.address||"Hyderabad, Telangana",href:null},
//                         ].map((it,i)=>(
//                           <div key={i} className="enq-contact-info">
//                             <div className="enq-ci-icon">{it.icon}</div>
//                             <div>
//                               <div className="enq-ci-label">{it.label}</div>
//                               {it.href?<a href={it.href} style={{color:"#fff",fontWeight:500,fontSize:13,textDecoration:"none"}}>{it.val}</a>:<span style={{color:"#fff",fontWeight:500,fontSize:13}}>{it.val}</span>}
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   </div>
//                   {/* Right Form */}
//                   <div className="col-lg-8">
//                     <div className="enq-right">
//                       <h3 className="pf" style={{fontSize:22,fontWeight:700,color:C.dark,marginBottom:4}}>We'd Love To Hear <span style={{color:C.primary}}>From You!</span></h3>
//                       <p style={{color:"#aaa",fontSize:13,marginBottom:28}}>Your celebration, your way — tell us what you have in mind.</p>

//                       <form onSubmit={handleSubmit}>
//                         {/* Step 0: Personal details */}
//                         {formStep === 0 && (
//                           <div>
//                             <div className="row g-3">
//                               <div className="col-md-6">
//                                 <label className="enq-label">Your Name</label>
//                                 <input className="enq-input" name="name" value={form.name} onChange={handleChange} placeholder="e.g. Priya Sharma" required/>
//                               </div>
//                               <div className="col-md-6">
//                                 <label className="enq-label">Phone Number</label>
//                                 <input className="enq-input" name="mobileNumber" value={form.mobileNumber} onChange={handleChange} placeholder="+91 00000 00000" required/>
//                               </div>
//                               <div className="col-12">
//                                 <label className="enq-label">Email Address</label>
//                                 <input className="enq-input" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@email.com" required/>
//                               </div>
//                             </div>
//                             <button type="button" className="cc-btn" style={{width:"100%",marginTop:24,padding:"14px"}} onClick={()=>{if(form.name&&form.mobileNumber&&form.email)setFormStep(1);else toast.warn("Please fill all fields.");}}>Next: Choose Occasion →</button>
//                           </div>
//                         )}

//                         {/* Step 1: Occasion selection */}
//                         {formStep === 1 && (
//                           <div>
//                             <label className="enq-label" style={{marginBottom:12}}>Select Your Occasion</label>
//                             <div className="enq-occasion-grid">
//                               {EVENT_TYPES.map((ev,i) => (
//                                 <div key={i} className={`enq-occ-chip${form.eventName===ev?" sel":""}`} onClick={()=>setform(f=>({...f,eventName:ev}))}>{ev}</div>
//                               ))}
//                             </div>
//                             <div style={{display:"flex",gap:10,marginTop:8}}>
//                               <button type="button" className="cc-btn-outline" style={{flex:1,padding:"13px"}} onClick={()=>setFormStep(0)}>← Back</button>
//                               <button type="button" className="cc-btn" style={{flex:2,padding:"13px"}} onClick={()=>{if(form.eventName)setFormStep(2);else toast.warn("Please select an occasion.");}}>Next: Your Message →</button>
//                             </div>
//                           </div>
//                         )}

//                         {/* Step 2: Message */}
//                         {formStep === 2 && (
//                           <div>
//                             <div className="enq-field">
//                               <label className="enq-label">Tell Us About Your Event</label>
//                               <textarea className="enq-input" name="description" value={form.description} onChange={handleChange} rows={5} placeholder={`Tell us about your ${form.eventName||"event"} — number of guests, preferred date, any special requests…`}/>
//                             </div>
//                             {/* Summary */}
//                             <div style={{background:C.primaryPale,borderRadius:14,padding:"14px 18px",marginBottom:20,border:`1px solid rgba(94,14,115,.1)`}}>
//                               <div style={{fontSize:11,fontWeight:700,color:C.primary,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>Summary</div>
//                               <div style={{fontSize:13,color:C.dark}}>
//                                 <span style={{fontWeight:600}}>{form.name}</span> · {form.mobileNumber} · {form.email}<br/>
//                                 <span style={{color:C.primary,fontWeight:600}}>🎉 {form.eventName}</span>
//                               </div>
//                             </div>
//                             <div style={{display:"flex",gap:10}}>
//                               <button type="button" className="cc-btn-outline" style={{flex:1,padding:"13px"}} onClick={()=>setFormStep(1)}>← Back</button>
//                               <button type="submit" className="cc-btn" style={{flex:2,padding:"13px",fontSize:15}}>✨ Send My Request</button>
//                             </div>
//                           </div>
//                         )}
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* ══ 18. FAQ ═══════════════════════════════════════════════════ */}
//           <section className="cc-sec cc-sec-white">
//             <div className="container">
//               <div className="text-center rv" style={{marginBottom:44}}>
//                 <span className="cc-tag">✦ FAQ ✦</span>
//                 <h2 className="cc-h">Got <span>Questions?</span></h2>
//                 <p className="cc-sub">Everything you need to know about celebrating with CarnivalCastle.</p>
//               </div>
//               <div className="row justify-content-center">
//                 <div className="col-md-9 cc-faq rv">
//                   <Accordion defaultActiveKey="0">
//                     {(showAllFaqs?Faqs:Faqs?.slice(0,5))?.map((faq,i) => (
//                       <Accordion.Item key={i} eventKey={String(i)} className="mt-2">
//                         <Accordion.Header><b>{i+1}. {faq.question}</b></Accordion.Header>
//                         <Accordion.Body>{faq.answer}</Accordion.Body>
//                       </Accordion.Item>
//                     ))}
//                   </Accordion>
//                   {Faqs?.length > 5 && (
//                     <div style={{display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap",marginTop:24}}>
//                       <button className="cc-btn-outline" onClick={()=>setShowAllFaqs(p=>!p)}>{showAllFaqs?"View Less":"View More FAQs"}</button>
//                       <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn"><i className="bi bi-whatsapp"/>Chat With Us</a>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* ══ 19. BRANCHES ═════════════════════════════════════════════ */}
//           <section className="cc-sec-sm cc-sec-pale">
//             <div className="container text-center">
//               <h2 className="cc-h rv" style={{marginBottom:32}}>Our <span>Branches</span></h2>
//               <div style={{display:"flex",flexWrap:"wrap",gap:14,justifyContent:"center"}} className="rv">
//                 {addresses.map((addr,i) => (
//                   <a key={i} href={addr.addressLine2} target="_blank" rel="noopener noreferrer" className="branch-pill">
//                     <div className="branch-ic"><i className="bi bi-geo-alt-fill" style={{color:"#fff",fontSize:14}}/></div>
//                     <div style={{textAlign:"left"}}><div style={{fontWeight:700,fontSize:13,color:C.dark,lineHeight:1.3}}>{addr.name}</div></div>
//                     <span style={{color:C.primary,fontSize:12}}>↗</span>
//                   </a>
//                 ))}
//               </div>
//             </div>
//           </section>

//           {/* ══ 20. INSTAGRAM STRIP ══════════════════════════════════════ */}
//           <section className="cc-sec-sm cc-sec-white">
//             <div className="container">
//               <div className="ig-strip rv">
//                 <div>
//                   <h4 className="pf" style={{fontWeight:700,color:C.dark,marginBottom:4}}>Follow Our Journey on Instagram</h4>
//                   <p style={{color:"#888",margin:0,fontSize:14}}>Get inspired by our latest creations and behind-the-scenes moments.</p>
//                 </div>
//                 <a href="https://www.instagram.com/carnival_castle_hyderabad/" target="_blank" rel="noopener noreferrer"
//                   style={{display:"inline-flex",alignItems:"center",gap:8,padding:"11px 22px",borderRadius:50,textDecoration:"none",fontWeight:600,color:"#fff",background:"linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888)",boxShadow:"0 6px 20px rgba(0,0,0,.15)"}}>
//                   <i className="fab fa-instagram"/> carnival_castle_hyderabad
//                 </a>
//               </div>
//             </div>
//           </section>

//           <PopupModal show={showPopup} handleClose={()=>setShowPopup(false)} image={popupImage}/>
//           <ToastContainer position="top-center" autoClose={2500}/>
//           <Footer/>
//         </div>
//       </div>
//     </>
//   );
// }

// /* ─── Scroll Reveal ──────────────────────────────────────────────────────── */
// function ScrollRevealWatcher() {
//   useEffect(() => {
//     const obs = new IntersectionObserver(
//       entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("in"); }),
//       { threshold: 0.08 }
//     );
//     document.querySelectorAll(".rv").forEach(el => obs.observe(el));
//     return () => obs.disconnect();
//   }, []);
//   return null;
// }

// function BestSellerCard({ s }) {
//   const [liked, setLiked] = useState(false);

//   return (
//     <div className="bs-card">
//       <div className="bs-img-w">
//         <img src={s.img} alt={s.name} className="bs-img" />
//         <div className="bs-ovl" />
//         <span className="bs-lbl">{s.label}</span>
//         <button className="bs-wish" onClick={() => setLiked(p => !p)}>
//           <span style={{ color: liked ? "#e03" : "#999" }}>{liked ? "♥" : "♡"}</span>
//         </button>
//         <button className="bs-quick">+ Quick Add to Event</button>
//       </div>
//       <div className="bs-body">
//         <div className="bs-stars">
//           {[1,2,3,4,5].map(n => (
//             <span key={n} className="bs-star" style={{ color: n <= 4 ? "#C9A84C" : "#ddd" }}>★</span>
//           ))}
//           <span className="bs-rating-ct">({Math.floor(Math.random() * 200 + 80)})</span>
//         </div>
//         <div className="bs-name">{s.name}</div>
//         <div className="bs-meta">{s.meta}</div>
//         <div className="bs-price-row">
//           <div>
//             <span className="bs-orig">{s.orig}</span>
//             <span className="bs-price">{s.price}</span>
//           </div>
//           <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:4 }}>
//             <span className="bs-save">Save {parseInt(s.orig.replace(/[₹,]/g,"")) - parseInt(s.price.replace(/[₹,]/g,"")) > 0 ? `₹${parseInt(s.orig.replace(/[₹,]/g,"")) - parseInt(s.price.replace(/[₹,]/g,""))}` : ""}</span>
//             <button className="bs-add-btn">+</button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
// function GalleryEntranceObserver() {
//   useEffect(() => {
//     const items = document.querySelectorAll(".gal-bento-item");
//     const obs = new IntersectionObserver(
//       entries => {
//         entries.forEach(e => {
//           if (e.isIntersecting) {
//             const idx = Array.from(items).indexOf(e.target);
//             e.target.style.transitionDelay = `${idx * 0.08}s`;
//             e.target.classList.add("in");
//             obs.unobserve(e.target);
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );
//     items.forEach(el => obs.observe(el));
//     return () => obs.disconnect();
//   }, []);
//   return null;
// }
// /* ─── Occasion Card ─────────────────────────────────────────── */
// /* ─── OccCard ───────────────────────────────────────────────────── */
// function OccCard({ occ, navigate }) {
//   const zoneRef = useRef(null);
//   const cardRef = useRef(null);

//   const SPARKLE_POS = [
//     [15,20],[80,15],[20,70],[75,80],[50,10],
//     [90,50],[10,50],[60,85],[30,35],[70,30],
//   ];

//   const addSparkles = () => {
//     if (!zoneRef.current) return;
//     zoneRef.current.innerHTML = "";
//     SPARKLE_POS.forEach(([l, t], i) => {
//       const sp = document.createElement("div");
//       sp.className = "sparkle";
//       const size = 5 + Math.random() * 5;
//       sp.style.cssText = `left:${l}%;top:${t}%;width:${size}px;height:${size}px;animation-delay:${i*0.12}s;animation-duration:${1.2+Math.random()*.6}s;`;
//       zoneRef.current.appendChild(sp);
//     });
//   };

//   const clearSparkles = () => {
//     if (zoneRef.current) zoneRef.current.innerHTML = "";
//   };

//   const handleTouchStart = () => {
//     document.querySelectorAll(".occ-card.touched").forEach(c => {
//       if (c !== cardRef.current) {
//         c.classList.remove("touched");
//         const z = c.querySelector(".sparkle-zone");
//         if (z) z.innerHTML = "";
//       }
//     });
//     const already = cardRef.current.classList.contains("touched");
//     if (already) {
//       cardRef.current.classList.remove("touched");
//       clearSparkles();
//     } else {
//       cardRef.current.classList.add("touched");
//       addSparkles();
//     }
//   };

//   const handleTouchEnd = (e) => {
//     e.preventDefault();
//   };

//   return (
//     <div
//       ref={cardRef}
//       className="occ-card"
//       onMouseEnter={addSparkles}
//       onMouseLeave={clearSparkles}
//       onTouchStart={handleTouchStart}
//       onTouchEnd={handleTouchEnd}
//     >
//       <div className="sparkle-zone" ref={zoneRef} />

//       {/* image */}
//       <img src={URLS.Base + occ.image} alt={occ.name} />

//       {/* always-visible title at bottom */}
//       <div className="occ-always">
//         <div className="occ-title-always">{occ.name}</div>
//       </div>

//       {/* hover / touch overlay */}
//       <div className="occ-ovl">
//         <div className="occ-ovl-inner">
//           <div className="occ-occ-name">{occ.name}</div>
//           <p className="occ-desc">{occDesc(occ.name)}</p>

//           {/* ── GOLD BOOK NOW BUTTON ── */}
//           <button
//             className="occ-book-gold"
//             onClick={() => navigate("/locations")}
//           >
//             <span className="occ-book-shine" />
//             <span className="occ-book-icon">🎉</span>
//             <span className="occ-book-label">Book Now</span>
//             <span className="occ-book-arr">→</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ─── OccSliderController ───────────────────────────────────────── */
// function OccSliderController({ occasions, navigate }) {
//   useEffect(() => {
//     if (!occasions.length) return;

//     const track   = document.getElementById("occ-track");
//     const dotsEl  = document.getElementById("occ-dots");
//     const prevBtn = document.getElementById("occ-prev");
//     const nextBtn = document.getElementById("occ-next");
//     if (!track || !dotsEl || !prevBtn || !nextBtn) return;

//     let idx       = 0;
//     let autoTimer = null;

//     const getPerView = () => {
//       const w = window.innerWidth;
//       if (w < 769)  return 1;
//       if (w < 1025) return 2;
//       return 3;
//     };

//     let perView = getPerView();
//     const total = occasions.length;

//     const buildDots = () => {
//       dotsEl.innerHTML = "";
//       const pages = total - perView + 1;
//       for (let i = 0; i < Math.max(1, pages); i++) {
//         const d = document.createElement("button");
//         d.className = "occ-dot" + (i === 0 ? " on" : "");
//         d.setAttribute("aria-label", `Slide ${i + 1}`);
//         d.onclick = () => { stopAuto(); goTo(i); startAuto(); };
//         dotsEl.appendChild(d);
//       }
//     };

//     const updateDots = () => {
//       dotsEl.querySelectorAll(".occ-dot").forEach((d, i) => {
//         d.className = "occ-dot" + (i === idx ? " on" : "");
//       });
//     };

//     const goTo = (i) => {
//       const maxIdx = Math.max(0, total - perView);
//       idx = Math.max(0, Math.min(i, maxIdx));
//       const cards = track.querySelectorAll(".occ-card");
//       if (!cards.length) return;
//       const cardW = cards[0].offsetWidth;
//       track.style.transform = `translateX(-${idx * (cardW + 20)}px)`;
//       updateDots();
//     };

//     const next = () => {
//       const maxIdx = total - perView;
//       goTo(idx >= maxIdx ? 0 : idx + 1);
//     };
//     const prev = () => {
//       const maxIdx = total - perView;
//       goTo(idx <= 0 ? maxIdx : idx - 1);
//     };

//     const startAuto = () => { stopAuto(); autoTimer = setInterval(next, 3200); };
//     const stopAuto  = () => clearInterval(autoTimer);

//     prevBtn.onclick = () => { stopAuto(); prev(); startAuto(); };
//     nextBtn.onclick = () => { stopAuto(); next(); startAuto(); };

//     // touch swipe
//     let touchStartX = 0;
//     let touchStartY = 0;
//     let isSwiping   = false;

//     track.addEventListener("touchstart", e => {
//       touchStartX = e.touches[0].clientX;
//       touchStartY = e.touches[0].clientY;
//       isSwiping   = false;
//       stopAuto();
//     }, { passive: true });

//     track.addEventListener("touchmove", e => {
//       const dx = Math.abs(e.touches[0].clientX - touchStartX);
//       const dy = Math.abs(e.touches[0].clientY - touchStartY);
//       if (dx > dy && dx > 10) isSwiping = true;
//     }, { passive: true });

//     track.addEventListener("touchend", e => {
//       if (isSwiping) {
//         const dx = e.changedTouches[0].clientX - touchStartX;
//         if (Math.abs(dx) > 48) { dx < 0 ? next() : prev(); }
//       }
//       startAuto();
//     }, { passive: true });

//     const onResize = () => { perView = getPerView(); buildDots(); goTo(0); };
//     window.addEventListener("resize", onResize);

//     perView = getPerView();
//     buildDots();
//     startAuto();

//     return () => { stopAuto(); window.removeEventListener("resize", onResize); };
//   }, [occasions]);

//   return null;
// }

// export default Home;


import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Accordion from "react-bootstrap/Accordion";
import { URLS } from "../Url";
import Footer from "./Footer";
import Header from "./Header";
import axios from "axios";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import PopupModal from "./PopUpModal";
import { FaFacebookF, FaYoutube, FaInstagram, FaWhatsapp } from "react-icons/fa";

/* ── section components ── */
import "../styles/home.css";
import ScrollRevealWatcher from "./ScrollRevealWatcher";
import HeroBanner from "./HeroBanner";
import OfferBanner from "./OfferBanner";
import OccasionsSection from "./OccasionsSection";
import ServicesSection from "./ServicesSection";
import WhySection from "./WhySection";
import WhyDarkSection from "./WhyDarkSection";
import FeaturesSection from "./FeaturesSection";
import GallerySection from "./GallerySection";
import EnquiryForm from "./EnquiryForm";
import ReelsSection from "./ReelsSection";
import VideoTestimonialsSpotlight from "./Videotestimonialsspotlight";
// import TestimonalsSection     from "./TestimonialsSection";
import TestimonialsSection from "./TestimonialsSection";

const C = { primary: "#5E0E73", dark: "#1A0030", gold: "#C9A84C", cream: "#E8E1D6" };

export const fetchPopupImage = async () => {
  try {
    const r = await fetch("https://api.carnivalcastle.com/v1/carnivalApi/admin/popup/getpopupimage?type=CarnivalCastle");
    const d = await r.json();
    return d.success && d.data?.length > 0 ? d.data[0] : null;
  } catch { return null; }
};

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const [Faqs, setFaqs] = useState([]);
  const [Highlights, setHighlights] = useState({});
  const [Contact, setContact] = useState({});
  const [PopUp1, setPopUp1] = useState({});
  const [images, setImages] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [slides, setSlides] = useState([]);
  const [banner, setBanner] = useState(null);
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const base = "https://api.carnivalcastle.com/v1/carnivalApi/admin";

    axios.post(URLS.AllModules, {}).then(r => {
      if (r.status === 200) {
        setFaqs(r.data.faqs);
        setContact(r.data.contactus?.[0] || {});
        setHighlights(r.data.highlight?.[0] || {});
        setPopUp1(r.data.popup?.[0] || {});
        setIsLoading(false);
      }
    }).catch(() => setIsLoading(false));

    axios.post(URLS.GetAllGallery, {}).then(r => { if (r.status === 200) setImages(r.data.gallerys?.slice(0, 6) || []); });
    axios.post(URLS.GetAllOccation, {}).then(r => { if (r.status === 200) setOccasions(r.data?.occasions || []); });
    axios.get(`${base}/address/alladdress`).then(r => { if (r.data?.success) setAddresses(r.data.data || []); });

    axios.post(`${base}/testimonial/getalltestimoni?websiteFor=carnivalcastle`).then(r => {
      if (r.data?.success && Array.isArray(r.data.testimoni)) {
        setTestimonials(r.data.testimoni.filter(t => t.status === "active" && t.videoId?.trim()));
        const fmt = r.data.testimoni.filter(t => t.status === "active").map(t => ({
          name: t.name, location: t.role || "Customer", rating: Number(t.rating) || 5,
          description: t.description || "",
          image: `https://api.carnivalcastle.com/${t.image}`,
          avatar: `https://api.carnivalcastle.com/${t.profileImage}`,
          occasion: t.type === "Yes" ? "Special Celebration" : "",
        }));
        const grouped = [];
        for (let i = 0; i < fmt.length; i += 3) grouped.push(fmt.slice(i, i + 3));
        setSlides(grouped);
      }
    });

    axios.get(`${base}/get-banners?type=carnivalcastle`).then(r => {
      if (r.data.success && r.data.banners.length > 0) setBanner(r.data.banners[0]);
    });

    fetchPopupImage().then(p => { if (p?.modalEnabled) { setPopupImage(p.image); setShowPopup(true); } });
  }, []);

  if (isLoading) return (
    <div style={{ background: C.dark, height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
      <img src="assets/img/giff.gif" style={{ height: 280 }} alt="loading" />
      <p style={{ color: C.gold, marginTop: 12, fontWeight: 600, letterSpacing: 2 }}>Loading…</p>
    </div>
  );

  return (
    <>
      <Helmet>
        <title>Carnival Castle | Best Private Theaters for Celebrations in Hyderabad</title>
        <meta name="description" content="Experience the magic of celebrations at Carnival Castle Private Theatres in Hyderabad." />
      </Helmet>

      <ScrollRevealWatcher />

      <div className="home-page">
        <div className="main-wrapper">
          <Header />

          {PopUp1?.modalEnabled && (
            <div className="cc-announce"><marquee>{PopUp1.title}</marquee></div>
          )}

          <HeroBanner banner={banner} />

          {/* <OfferBanner /> */}
          <ReelsSection />
          <GallerySection images={images} />
          <VideoTestimonialsSpotlight />
          <OccasionsSection occasions={occasions} navigate={navigate} />
          <ServicesSection />
          {/* <WhySection Highlights={Highlights} /> */}


          {/* YouTube video testimonials */}
          {testimonials.length > 0 && (
            <section className="cc-sec cc-sec-white">
              <div className="container">
                <div className="text-center rv" style={{ marginBottom: 48 }}>
                  <span className="cc-tag">✦ Testimonials ✦</span>
                  <h2 className="cc-h">Real Stories, <span>Real Magic</span></h2>
                  <p className="cc-sub">See what our guests experienced at CarnivalCastle.</p>
                </div>
                <div id="vtCar" className="carousel slide carousel-fade rv" data-bs-ride="false" style={{ maxWidth: 900, margin: "0 auto" }}>
                  <div className="carousel-inner">
                    {testimonials.map((item, idx) => {
                      const prev = idx === 0 ? testimonials.length - 1 : idx - 1;
                      const next = idx === testimonials.length - 1 ? 0 : idx + 1;
                      const getPImg = t => { const p = t?.profileImage?.replace(/\\/g, "/"); return p?.startsWith("uploads/") ? `https://api.carnivalcastle.com/${p}` : p; };
                      return (
                        <div key={idx} className={`carousel-item${idx === 0 ? " active" : ""}`}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 16, padding: "0 8px" }}>
                            <div className="d-none d-md-block" style={{ width: 130, height: 190, borderRadius: 14, overflow: "hidden", opacity: .65, backgroundImage: `url(${getPImg(testimonials[prev])})`, backgroundSize: "cover", backgroundPosition: "center" }}>
                              <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "flex-end", justifyContent: "center", padding: 8 }}>
                                <span style={{ background: "rgba(0,0,0,.7)", color: "#fff", fontSize: 11, padding: "3px 8px", borderRadius: 6 }}>{testimonials[prev]?.name}</span>
                              </div>
                            </div>
                            <div style={{ flex: "1 1 auto", maxWidth: 420, borderRadius: 18, overflow: "hidden", boxShadow: "0 16px 48px rgba(94,14,115,.25)" }}>
                              <iframe width="100%" height="300"
                                src={`https://www.youtube.com/embed/${item.videoId}?autoplay=1&mute=1`}
                                title={item.name} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                              <div style={{ background: C.cream, padding: "14px 16px" }}>
                                <div style={{ fontWeight: 700, color: C.primary }}>{item.name}</div>
                                <div style={{ fontSize: 12, color: "#888" }}>{item.role}</div>
                              </div>
                            </div>
                            <div className="d-none d-md-block" style={{ width: 130, height: 190, borderRadius: 14, overflow: "hidden", opacity: .65, backgroundImage: `url(${getPImg(testimonials[next])})`, backgroundSize: "cover", backgroundPosition: "center" }}>
                              <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "flex-end", justifyContent: "center", padding: 8 }}>
                                <span style={{ background: "rgba(0,0,0,.7)", color: "#fff", fontSize: 11, padding: "3px 8px", borderRadius: 6 }}>{testimonials[next]?.name}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 24 }}>
                    {testimonials.map((_, i) => (
                      <button key={i} type="button" data-bs-target="#vtCar" data-bs-slide-to={i}
                        style={{ width: i === 0 ? 26 : 10, height: 10, borderRadius: 999, border: "none", background: i === 0 ? C.primary : "rgba(94,14,115,.2)", transition: "all .3s", cursor: "pointer" }} />
                    ))}
                  </div>
                </div>
              </div>
            </section>
          )}

          {/* Text review cards */}
          {/* {slides.length > 0 && (
            <section className="cc-sec cc-sec-pale">
              <div className="container">
                <div className="text-center rv" style={{ marginBottom:48 }}>
                  <span className="cc-tag">✦ Customer Love ✦</span>
                  <h2 className="cc-h">What Our <span>Guests Say</span></h2>
                </div>
                <div id="rvCar" className="carousel slide rv" data-bs-interval="5000" data-bs-ride="carousel">
                  <div className="carousel-inner">
                    {slides.map((group, gIdx) => (
                      <div key={gIdx} className={`carousel-item${gIdx === 0 ? " active" : ""}`}>
                        <div className="row g-4 justify-content-center">
                          {group.map((rv, rIdx) => (
                            <div key={rIdx} className="col-lg-4 col-md-6">
                              <div className="testi-card">
                                <img src={rv.image} alt="" className="t-bg" loading="lazy" />
                                <div className="t-glass">
                                  <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
                                    <img src={rv.avatar} alt="" style={{ width:42, height:42, borderRadius:"50%", objectFit:"cover", border:`2px solid ${C.primary}` }} />
                                    <div><div className="t-name">{rv.name}</div><div className="t-role">{rv.location}</div></div>
                                  </div>
                                  <div className="t-stars">{"★".repeat(rv.rating)}{"☆".repeat(5 - rv.rating)}</div>
                                  <p className="t-desc">{rv.description}</p>
                                  {rv.occasion && <div style={{ fontSize:11, color:C.primary, fontWeight:600 }}>🎉 {rv.occasion}</div>}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
          )} */}
          {/* {slides.length > 0 && <TestimonalsSection slides={slides} />} */}
          <TestimonialsSection />

          <EnquiryForm Contact={Contact} />

          {/* FAQ */}
          <section className="cc-sec cc-sec-white">
            <div className="container">
              <div className="text-center rv" style={{ marginBottom: 44 }}>
                <span className="cc-tag">✦ FAQ ✦</span>
                <h2 className="cc-h">Got <span>Questions?</span></h2>
                <p className="cc-sub">Everything you need to know about celebrating with CarnivalCastle.</p>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-9 cc-faq rv">
                  <Accordion defaultActiveKey="0">
                    {(showAllFaqs ? Faqs : Faqs?.slice(0, 5))?.map((faq, i) => (
                      <Accordion.Item key={i} eventKey={String(i)} className="mt-2">
                        <Accordion.Header><b>{i + 1}. {faq.question}</b></Accordion.Header>
                        <Accordion.Body>{faq.answer}</Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                  {Faqs?.length > 5 && (
                    <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 24 }}>
                      <button className="cc-btn-outline" onClick={() => setShowAllFaqs(p => !p)}>
                        {showAllFaqs ? "View Less" : "View More FAQs"}
                      </button>
                      <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer" className="wa-btn">
                        <i className="bi bi-whatsapp" />Chat With Us
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>

          {/* Branches */}
          <section className="cc-sec-sm cc-sec-pale">
            <div className="container text-center">
              <h2 className="cc-h rv" style={{ marginBottom: 32 }}>Our <span>Branches</span></h2>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 14, justifyContent: "center" }} className="rv">
                {(addresses.length > 0 ? addresses : [
                  { _id: "687181cbdffe2f15c8d0ae1d", name: "Gachibowli" },
                  { _id: "6871823bdffe2f15c8d0ae2a", name: "Kondapur – Premium Theatres" },
                  { _id: "68d2afe21aaafdc6fe7f16ba", name: "Miyapur" },
                ]).map((addr, i) => {
                  const getBranchSlug = (name) => {
                    const lower = (name || "").toLowerCase();
                    if (lower.includes("kondapur")) return "kondapur";
                    if (lower.includes("gachibowli")) return "gachibowli";
                    if (lower.includes("miyapur")) return "miyapur";
                    return lower.replace(/\s+/g, "-");
                  };
                  const slug = getBranchSlug(addr.name);
                  return (
                    <a
                      key={i}
                      href={`/theaters/${slug}`}
                      onClick={(e) => {
                        e.preventDefault();
                        sessionStorage.setItem("selectedAddress", JSON.stringify(addr));
                        navigate(`/theaters/${slug}`, { state: { address: addr } });
                      }}
                      className="branch-pill"
                    >
                      <div className="branch-ic"><i className="bi bi-geo-alt-fill" style={{ color: "#fff", fontSize: 14 }} /></div>
                      <div style={{ textAlign: "left" }}><div style={{ fontWeight: 700, fontSize: 13, color: C.dark, lineHeight: 1.3 }}>{addr.name}</div></div>
                      <span style={{ color: C.primary, fontSize: 12 }}>↗</span>
                    </a>
                  );
                })}
              </div>
            </div>
          </section>

          {/* ── Connect With Us / Social Showcase ── */}
          <section className="cc-sec-sm cc-sec-white" style={{ paddingTop: 32, paddingBottom: 48 }}>
            <div className="container">
              <div className="cc-social-showcase rv">
                <div className="cc-social-head">
                  <span className="cc-social-tag">✦ STAY CONNECTED ✦</span>
                  <h3 className="pf cc-social-title">
                    Stay Connected With <span>Carnival Castle</span>
                  </h3>
                  <p className="cc-social-subtitle">
                    Follow our celebrations, latest moments, videos and updates across our channels.
                  </p>
                </div>

                <div className="cc-social-grid">
                  {/* Instagram */}
                  <a
                    href="https://www.instagram.com/carnival_castle_/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cc-social-card cc-social-instagram"
                    aria-label="Instagram"
                  >
                    <div className="cc-sc-glow" />
                    <div className="cc-sc-top">
                      <div className="cc-sc-icon-wrap cc-sc-ig-icon">
                        <FaInstagram />
                      </div>
                      <span className="cc-sc-badge">Featured</span>
                    </div>
                    <div className="cc-sc-body">
                      <div className="cc-sc-platform">Instagram</div>
                      <div className="cc-sc-handle">@carnival_castle_</div>
                    </div>
                    <div className="cc-sc-cta cc-sc-cta-ig">
                      <span>Follow Us</span> <span className="cc-sc-arrow">↗</span>
                    </div>
                  </a>

                  {/* YouTube */}
                  <a
                    href="https://www.youtube.com/@Carnival_Castle"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cc-social-card cc-social-youtube"
                    aria-label="YouTube"
                  >
                    <div className="cc-sc-glow" />
                    <div className="cc-sc-top">
                      <div className="cc-sc-icon-wrap cc-sc-yt-icon">
                        <FaYoutube />
                      </div>
                    </div>
                    <div className="cc-sc-body">
                      <div className="cc-sc-platform">YouTube</div>
                      <div className="cc-sc-handle">@Carnival_Castle</div>
                    </div>
                    <div className="cc-sc-cta">
                      <span>Watch</span> <span className="cc-sc-arrow">↗</span>
                    </div>
                  </a>

                  {/* Facebook */}
                  <a
                    href="https://www.facebook.com/carnivalcastlehyderabad?_rdr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cc-social-card cc-social-facebook"
                    aria-label="Facebook"
                  >
                    <div className="cc-sc-glow" />
                    <div className="cc-sc-top">
                      <div className="cc-sc-icon-wrap cc-sc-fb-icon">
                        <FaFacebookF />
                      </div>
                    </div>
                    <div className="cc-sc-body">
                      <div className="cc-sc-platform">Facebook</div>
                      <div className="cc-sc-handle">@carnivalcastlehyderabad</div>
                    </div>
                    <div className="cc-sc-cta">
                      <span>Connect</span> <span className="cc-sc-arrow">↗</span>
                    </div>
                  </a>

                  {/* WhatsApp */}
                  <a
                    href={Contact?.phone ? `https://wa.me/${Contact.phone}` : "https://wa.me/918341428342"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="cc-social-card cc-social-whatsapp"
                    aria-label="WhatsApp"
                  >
                    <div className="cc-sc-glow" />
                    <div className="cc-sc-top">
                      <div className="cc-sc-icon-wrap cc-sc-wa-icon">
                        <FaWhatsapp />
                      </div>
                    </div>
                    <div className="cc-sc-body">
                      <div className="cc-sc-platform">WhatsApp</div>
                      <div className="cc-sc-handle">Quick Chat & Enquiry</div>
                    </div>
                    <div className="cc-sc-cta">
                      <span>Message</span> <span className="cc-sc-arrow">↗</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <style>{`
              .cc-social-showcase {
                background: radial-gradient(circle at 10% 15%, rgba(201, 168, 76, 0.12) 0%, transparent 45%),
                            radial-gradient(circle at 90% 85%, rgba(124, 58, 237, 0.22) 0%, transparent 50%),
                            linear-gradient(135deg, #18002E 0%, #250342 50%, #120022 100%);
                border: 1px solid rgba(201, 168, 76, 0.28);
                border-radius: 24px;
                padding: 38px 32px 34px;
                box-shadow: 0 16px 44px rgba(20, 0, 40, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.12);
                position: relative;
                overflow: hidden;
              }
              .cc-social-head {
                text-align: center;
                margin-bottom: 28px;
                position: relative;
                z-index: 1;
              }
              .cc-social-tag {
                display: inline-block;
                color: #E8D5A0;
                font-size: 11px;
                letter-spacing: 3.5px;
                font-weight: 700;
                text-transform: uppercase;
                margin-bottom: 8px;
                text-shadow: 0 2px 8px rgba(0,0,0,0.4);
              }
              .cc-social-title {
                color: #FFFFFF;
                font-size: 26px;
                font-weight: 700;
                margin: 0 0 8px;
                letter-spacing: -0.3px;
              }
              .cc-social-title span {
                background: linear-gradient(135deg, #E8D5A0 0%, #C9A84C 50%, #FFF2CC 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              .cc-social-subtitle {
                color: rgba(255, 255, 255, 0.72);
                font-size: 14px;
                margin: 0 auto;
                max-width: 580px;
                line-height: 1.5;
              }
              .cc-social-grid {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 16px;
                position: relative;
                z-index: 1;
              }
              .cc-social-card {
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: 20px 18px 18px;
                border-radius: 16px;
                background: rgba(255, 255, 255, 0.05);
                backdrop-filter: blur(10px);
                -webkit-backdrop-filter: blur(10px);
                border: 1px solid rgba(255, 255, 255, 0.1);
                text-decoration: none !important;
                color: #FFFFFF !important;
                transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
                overflow: hidden;
                min-height: 172px;
              }
              .cc-sc-glow {
                position: absolute;
                inset: 0;
                opacity: 0;
                transition: opacity 0.35s ease;
                pointer-events: none;
              }
              .cc-social-card:hover {
                transform: translateY(-4px);
                color: #FFFFFF !important;
              }
              .cc-sc-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 14px;
                position: relative;
                z-index: 1;
              }
              .cc-sc-badge {
                font-size: 10px;
                font-weight: 700;
                letter-spacing: 0.5px;
                text-transform: uppercase;
                padding: 2px 8px;
                border-radius: 20px;
                background: linear-gradient(135deg, rgba(201, 168, 76, 0.35) 0%, rgba(225, 48, 108, 0.35) 100%);
                border: 1px solid rgba(201, 168, 76, 0.5);
                color: #FFF2CC;
              }
              .cc-social-instagram {
                border-color: rgba(225, 48, 108, 0.3);
                background: linear-gradient(145deg, rgba(225, 48, 108, 0.09) 0%, rgba(255, 255, 255, 0.04) 100%);
              }
              .cc-social-instagram .cc-sc-glow {
                background: radial-gradient(circle at 50% 0%, rgba(225, 48, 108, 0.28) 0%, transparent 70%);
              }
              .cc-social-instagram:hover {
                border-color: rgba(225, 48, 108, 0.7);
                box-shadow: 0 12px 30px rgba(225, 48, 108, 0.25);
              }
              .cc-social-instagram:hover .cc-sc-glow { opacity: 1; }

              .cc-social-youtube {
                border-color: rgba(255, 0, 0, 0.22);
              }
              .cc-social-youtube .cc-sc-glow {
                background: radial-gradient(circle at 50% 0%, rgba(255, 0, 0, 0.22) 0%, transparent 70%);
              }
              .cc-social-youtube:hover {
                border-color: rgba(255, 0, 0, 0.65);
                box-shadow: 0 12px 30px rgba(255, 0, 0, 0.22);
              }
              .cc-social-youtube:hover .cc-sc-glow { opacity: 1; }

              .cc-social-facebook {
                border-color: rgba(24, 119, 242, 0.22);
              }
              .cc-social-facebook .cc-sc-glow {
                background: radial-gradient(circle at 50% 0%, rgba(24, 119, 242, 0.22) 0%, transparent 70%);
              }
              .cc-social-facebook:hover {
                border-color: rgba(24, 119, 242, 0.65);
                box-shadow: 0 12px 30px rgba(24, 119, 242, 0.22);
              }
              .cc-social-facebook:hover .cc-sc-glow { opacity: 1; }

              .cc-social-whatsapp {
                border-color: rgba(37, 211, 102, 0.22);
              }
              .cc-social-whatsapp .cc-sc-glow {
                background: radial-gradient(circle at 50% 0%, rgba(37, 211, 102, 0.22) 0%, transparent 70%);
              }
              .cc-social-whatsapp:hover {
                border-color: rgba(37, 211, 102, 0.65);
                box-shadow: 0 12px 30px rgba(37, 211, 102, 0.22);
              }
              .cc-social-whatsapp:hover .cc-sc-glow { opacity: 1; }

              .cc-sc-icon-wrap {
                width: 44px;
                height: 44px;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
                color: #FFFFFF;
                position: relative;
                z-index: 1;
                transition: transform 0.3s ease;
              }
              .cc-social-card:hover .cc-sc-icon-wrap {
                transform: scale(1.08);
              }
              .cc-sc-ig-icon {
                background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
                box-shadow: 0 4px 14px rgba(220, 39, 67, 0.4);
              }
              .cc-sc-yt-icon {
                background: linear-gradient(135deg, #ff2a2a 0%, #cc0000 100%);
                box-shadow: 0 4px 14px rgba(255, 0, 0, 0.35);
              }
              .cc-sc-fb-icon {
                background: linear-gradient(135deg, #1877F2 0%, #0c56b8 100%);
                box-shadow: 0 4px 14px rgba(24, 119, 242, 0.35);
              }
              .cc-sc-wa-icon {
                background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
                box-shadow: 0 4px 14px rgba(37, 211, 102, 0.35);
              }
              .cc-sc-body {
                position: relative;
                z-index: 1;
                margin-bottom: 14px;
              }
              .cc-sc-platform {
                font-weight: 700;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 1.2;
                margin-bottom: 4px;
              }
              .cc-sc-handle {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.65);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .cc-sc-cta {
                position: relative;
                z-index: 1;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;
                font-weight: 600;
                padding: 7px 12px;
                border-radius: 20px;
                background: rgba(255, 255, 255, 0.08);
                border: 1px solid rgba(255, 255, 255, 0.15);
                color: rgba(255, 255, 255, 0.9);
                transition: all 0.25s ease;
                width: 100%;
                box-sizing: border-box;
              }
              .cc-sc-cta-ig {
                background: linear-gradient(135deg, rgba(201, 168, 76, 0.22) 0%, rgba(225, 48, 108, 0.22) 100%);
                border-color: rgba(201, 168, 76, 0.35);
                color: #FFF2CC;
              }
              .cc-social-card:hover .cc-sc-cta {
                background: rgba(255, 255, 255, 0.2);
                border-color: rgba(255, 255, 255, 0.35);
                color: #FFFFFF;
              }
              .cc-social-instagram:hover .cc-sc-cta-ig {
                background: linear-gradient(135deg, #C9A84C 0%, #E8D5A0 100%);
                border-color: #C9A84C;
                color: #1A0030 !important;
                font-weight: 700;
              }
              .cc-sc-arrow {
                font-size: 13px;
                transition: transform 0.25s ease;
              }
              .cc-social-card:hover .cc-sc-arrow {
                transform: translateX(3px) translateY(-2px);
              }

              @media (max-width: 991px) {
                .cc-social-grid {
                  grid-template-columns: repeat(2, 1fr);
                  gap: 14px;
                }
                .cc-social-showcase {
                  padding: 30px 22px 26px;
                }
                .cc-social-title {
                  font-size: 22px;
                }
              }
              @media (max-width: 576px) {
                .cc-social-grid {
                  grid-template-columns: repeat(2, 1fr);
                  gap: 8px;
                }
                .cc-social-showcase {
                  padding: 22px 14px 18px;
                  border-radius: 18px;
                }
                .cc-social-title {
                  font-size: 17px;
                  line-height: 1.3;
                }
                .cc-social-subtitle {
                  font-size: 12px;
                  line-height: 1.45;
                }
                .cc-social-card {
                  padding: 12px 10px 10px;
                  min-height: 140px;
                  border-radius: 14px;
                }
                .cc-sc-icon-wrap {
                  width: 34px;
                  height: 34px;
                  font-size: 16px;
                  border-radius: 9px;
                }
                .cc-sc-top {
                  margin-bottom: 8px;
                }
                .cc-sc-badge {
                  font-size: 9px;
                  padding: 1px 6px;
                }
                .cc-sc-body {
                  margin-bottom: 10px;
                }
                .cc-sc-platform {
                  font-size: 13px;
                  margin-bottom: 2px;
                }
                .cc-sc-handle {
                  font-size: 10.5px;
                }
                .cc-sc-cta {
                  padding: 5px 8px;
                  font-size: 11px;
                }
              }
              @media (max-width: 360px) {
                .cc-social-grid {
                  grid-template-columns: 1fr;
                }
              }
            `}</style>
          </section>

          <PopupModal show={showPopup} handleClose={() => setShowPopup(false)} image={popupImage} />
          <ToastContainer position="top-center" autoClose={2500} />
          <Footer />
        </div>
      </div>
    </>
  );
}